import He, { useState as Ze, useEffect as lt, useId as Fi, forwardRef as $i, useRef as on, useContext as Bi, createElement as Aa, Component as ja, createContext as Na, useImperativeHandle as Pa, useCallback as jn } from "react";
import Ia from "react-dom";
function zi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var gs = { exports: {} }, Xn = {};
var wo;
function La() {
  if (wo) return Xn;
  wo = 1;
  var e = He, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(m, h, p) {
    var b, w = {}, C = null, L = null;
    p !== void 0 && (C = "" + p), h.key !== void 0 && (C = "" + h.key), h.ref !== void 0 && (L = h.ref);
    for (b in h) r.call(h, b) && !a.hasOwnProperty(b) && (w[b] = h[b]);
    if (m && m.defaultProps) for (b in h = m.defaultProps, h) w[b] === void 0 && (w[b] = h[b]);
    return { $$typeof: t, type: m, key: C, ref: L, props: w, _owner: o.current };
  }
  return Xn.Fragment = n, Xn.jsx = d, Xn.jsxs = d, Xn;
}
gs.exports = La();
var f = gs.exports, vs = { exports: {} }, oi, So;
function Ma() {
  if (So) return oi;
  So = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return oi = e, oi;
}
var si, ko;
function Da() {
  if (ko) return si;
  ko = 1;
  var e = Ma();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, si = function() {
    function r(d, m, h, p, b, w) {
      if (w !== e) {
        var C = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw C.name = "Invariant Violation", C;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, si;
}
vs.exports = Da()();
var Fa = vs.exports;
const l = /* @__PURE__ */ zi(Fa), $a = () => {
  const [e, t] = Ze(null), [n, r] = Ze(!1), [o, a] = Ze(null), [d, m] = Ze("");
  return lt(() => {
    if (!d) return;
    (() => {
      a(null), r(!0);
      try {
        fetch(d).then((p) => p.json()).then((p) => {
          t(p), r(!1);
        }).catch((p) => {
          a(p), r(!1);
        });
      } catch (p) {
        a(p);
      }
    })();
  }, [d]), [{ data: e, loading: n, error: o }, m];
};
function Ba(e) {
  const [t, n] = Ze(!1);
  return lt(() => {
    const r = window.matchMedia(e);
    r.matches !== t && n(r.matches);
    const o = () => {
      n(r.matches);
    };
    return r.addEventListener("change", o), () => r.removeEventListener("change", o);
  }, [t, e]), t;
}
const To = (e, t, n) => e ? t : n, Ar = (e) => (e || []).join(" ");
const {
  entries: ys,
  setPrototypeOf: _o,
  isFrozen: za,
  getPrototypeOf: Ha,
  getOwnPropertyDescriptor: Va
} = Object;
let {
  freeze: ct,
  seal: bt,
  create: xs
} = Object, {
  apply: gi,
  construct: vi
} = typeof Reflect < "u" && Reflect;
ct || (ct = function(t) {
  return t;
});
bt || (bt = function(t) {
  return t;
});
gi || (gi = function(t, n, r) {
  return t.apply(n, r);
});
vi || (vi = function(t, n) {
  return new t(...n);
});
const Sr = ut(Array.prototype.forEach), Wa = ut(Array.prototype.lastIndexOf), Eo = ut(Array.prototype.pop), Gn = ut(Array.prototype.push), Ua = ut(Array.prototype.splice), jr = ut(String.prototype.toLowerCase), ai = ut(String.prototype.toString), Co = ut(String.prototype.match), Kn = ut(String.prototype.replace), qa = ut(String.prototype.indexOf), Ya = ut(String.prototype.trim), At = ut(Object.prototype.hasOwnProperty), at = ut(RegExp.prototype.test), Zn = Xa(TypeError);
function ut(e) {
  return function(t) {
    t instanceof RegExp && (t.lastIndex = 0);
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      r[o - 1] = arguments[o];
    return gi(e, t, r);
  };
}
function Xa(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return vi(e, n);
  };
}
function me(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : jr;
  _o && _o(e, null);
  let r = t.length;
  for (; r--; ) {
    let o = t[r];
    if (typeof o == "string") {
      const a = n(o);
      a !== o && (za(t) || (t[r] = a), o = a);
    }
    e[o] = !0;
  }
  return e;
}
function Ga(e) {
  for (let t = 0; t < e.length; t++)
    At(e, t) || (e[t] = null);
  return e;
}
function xn(e) {
  const t = xs(null);
  for (const [n, r] of ys(e))
    At(e, n) && (Array.isArray(r) ? t[n] = Ga(r) : r && typeof r == "object" && r.constructor === Object ? t[n] = xn(r) : t[n] = r);
  return t;
}
function Jn(e, t) {
  for (; e !== null; ) {
    const r = Va(e, t);
    if (r) {
      if (r.get)
        return ut(r.get);
      if (typeof r.value == "function")
        return ut(r.value);
    }
    e = Ha(e);
  }
  function n() {
    return null;
  }
  return n;
}
const Ro = ct(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), li = ct(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), ci = ct(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Ka = ct(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), ui = ct(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Za = ct(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Oo = ct(["#text"]), Ao = ct(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), di = ct(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), jo = ct(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), kr = ct(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Ja = bt(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Qa = bt(/<%[\w\W]*|[\w\W]*%>/gm), el = bt(/\$\{[\w\W]*/gm), tl = bt(/^data-[\-\w.\u00B7-\uFFFF]+$/), nl = bt(/^aria-[\-\w]+$/), bs = bt(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), rl = bt(/^(?:\w+script|data):/i), il = bt(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), ws = bt(/^html$/i), ol = bt(/^[a-z][.\w]*(-[.\w]+)+$/i);
var No = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: nl,
  ATTR_WHITESPACE: il,
  CUSTOM_ELEMENT: ol,
  DATA_ATTR: tl,
  DOCTYPE_NAME: ws,
  ERB_EXPR: Qa,
  IS_ALLOWED_URI: bs,
  IS_SCRIPT_OR_DATA: rl,
  MUSTACHE_EXPR: Ja,
  TMPLIT_EXPR: el
});
const Qn = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, sl = function() {
  return typeof window > "u" ? null : window;
}, al = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let r = null;
  const o = "data-tt-policy-suffix";
  n && n.hasAttribute(o) && (r = n.getAttribute(o));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return t.createPolicy(a, {
      createHTML(d) {
        return d;
      },
      createScriptURL(d) {
        return d;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, Po = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function Ss() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : sl();
  const t = (G) => Ss(G);
  if (t.version = "3.2.5", t.removed = [], !e || !e.document || e.document.nodeType !== Qn.document || !e.Element)
    return t.isSupported = !1, t;
  let {
    document: n
  } = e;
  const r = n, o = r.currentScript, {
    DocumentFragment: a,
    HTMLTemplateElement: d,
    Node: m,
    Element: h,
    NodeFilter: p,
    NamedNodeMap: b = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: w,
    DOMParser: C,
    trustedTypes: L
  } = e, O = h.prototype, k = Jn(O, "cloneNode"), N = Jn(O, "remove"), j = Jn(O, "nextSibling"), D = Jn(O, "childNodes"), V = Jn(O, "parentNode");
  if (typeof d == "function") {
    const G = n.createElement("template");
    G.content && G.content.ownerDocument && (n = G.content.ownerDocument);
  }
  let W, M = "";
  const {
    implementation: J,
    createNodeIterator: se,
    createDocumentFragment: Oe,
    getElementsByTagName: Fe
  } = n, {
    importNode: Ve
  } = r;
  let ke = Po();
  t.isSupported = typeof ys == "function" && typeof V == "function" && J && J.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: ve,
    ERB_EXPR: Q,
    TMPLIT_EXPR: he,
    DATA_ATTR: Ne,
    ARIA_ATTR: dt,
    IS_SCRIPT_OR_DATA: $e,
    ATTR_WHITESPACE: Be,
    CUSTOM_ELEMENT: qe
  } = No;
  let {
    IS_ALLOWED_URI: ft
  } = No, be = null;
  const Y = me({}, [...Ro, ...li, ...ci, ...ui, ...Oo]);
  let B = null;
  const q = me({}, [...Ao, ...di, ...jo, ...kr]);
  let U = Object.seal(xs(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), A = null, ue = null, z = !0, pe = !0, re = !1, ie = !0, Z = !1, de = !0, ye = !1, ae = !1, Ae = !1, le = !1, Ee = !1, Xe = !1, je = !0, vt = !1;
  const Ge = "user-content-";
  let Se = !0, K = !1, xe = {}, it = null;
  const wt = me({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Ke = null;
  const an = me({}, ["audio", "video", "img", "source", "image", "track"]);
  let qt = null;
  const Tn = me({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Nt = "http://www.w3.org/1998/Math/MathML", St = "http://www.w3.org/2000/svg", pt = "http://www.w3.org/1999/xhtml";
  let Pt = pt, ln = !1, cn = null;
  const Fn = me({}, [Nt, St, pt], ai);
  let Je = me({}, ["mi", "mo", "mn", "ms", "mtext"]), It = me({}, ["annotation-xml"]);
  const Yt = me({}, ["title", "style", "font", "a", "script"]);
  let ge = null;
  const Ft = ["application/xhtml+xml", "text/html"], Xt = "text/html";
  let Pe = null, Qe = null;
  const Gt = n.createElement("form"), yt = function(S) {
    return S instanceof RegExp || S instanceof Function;
  }, Kt = function() {
    let S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Qe && Qe === S)) {
      if ((!S || typeof S != "object") && (S = {}), S = xn(S), ge = // eslint-disable-next-line unicorn/prefer-includes
      Ft.indexOf(S.PARSER_MEDIA_TYPE) === -1 ? Xt : S.PARSER_MEDIA_TYPE, Pe = ge === "application/xhtml+xml" ? ai : jr, be = At(S, "ALLOWED_TAGS") ? me({}, S.ALLOWED_TAGS, Pe) : Y, B = At(S, "ALLOWED_ATTR") ? me({}, S.ALLOWED_ATTR, Pe) : q, cn = At(S, "ALLOWED_NAMESPACES") ? me({}, S.ALLOWED_NAMESPACES, ai) : Fn, qt = At(S, "ADD_URI_SAFE_ATTR") ? me(xn(Tn), S.ADD_URI_SAFE_ATTR, Pe) : Tn, Ke = At(S, "ADD_DATA_URI_TAGS") ? me(xn(an), S.ADD_DATA_URI_TAGS, Pe) : an, it = At(S, "FORBID_CONTENTS") ? me({}, S.FORBID_CONTENTS, Pe) : wt, A = At(S, "FORBID_TAGS") ? me({}, S.FORBID_TAGS, Pe) : {}, ue = At(S, "FORBID_ATTR") ? me({}, S.FORBID_ATTR, Pe) : {}, xe = At(S, "USE_PROFILES") ? S.USE_PROFILES : !1, z = S.ALLOW_ARIA_ATTR !== !1, pe = S.ALLOW_DATA_ATTR !== !1, re = S.ALLOW_UNKNOWN_PROTOCOLS || !1, ie = S.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Z = S.SAFE_FOR_TEMPLATES || !1, de = S.SAFE_FOR_XML !== !1, ye = S.WHOLE_DOCUMENT || !1, le = S.RETURN_DOM || !1, Ee = S.RETURN_DOM_FRAGMENT || !1, Xe = S.RETURN_TRUSTED_TYPE || !1, Ae = S.FORCE_BODY || !1, je = S.SANITIZE_DOM !== !1, vt = S.SANITIZE_NAMED_PROPS || !1, Se = S.KEEP_CONTENT !== !1, K = S.IN_PLACE || !1, ft = S.ALLOWED_URI_REGEXP || bs, Pt = S.NAMESPACE || pt, Je = S.MATHML_TEXT_INTEGRATION_POINTS || Je, It = S.HTML_INTEGRATION_POINTS || It, U = S.CUSTOM_ELEMENT_HANDLING || {}, S.CUSTOM_ELEMENT_HANDLING && yt(S.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (U.tagNameCheck = S.CUSTOM_ELEMENT_HANDLING.tagNameCheck), S.CUSTOM_ELEMENT_HANDLING && yt(S.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (U.attributeNameCheck = S.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), S.CUSTOM_ELEMENT_HANDLING && typeof S.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (U.allowCustomizedBuiltInElements = S.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Z && (pe = !1), Ee && (le = !0), xe && (be = me({}, Oo), B = [], xe.html === !0 && (me(be, Ro), me(B, Ao)), xe.svg === !0 && (me(be, li), me(B, di), me(B, kr)), xe.svgFilters === !0 && (me(be, ci), me(B, di), me(B, kr)), xe.mathMl === !0 && (me(be, ui), me(B, jo), me(B, kr))), S.ADD_TAGS && (be === Y && (be = xn(be)), me(be, S.ADD_TAGS, Pe)), S.ADD_ATTR && (B === q && (B = xn(B)), me(B, S.ADD_ATTR, Pe)), S.ADD_URI_SAFE_ATTR && me(qt, S.ADD_URI_SAFE_ATTR, Pe), S.FORBID_CONTENTS && (it === wt && (it = xn(it)), me(it, S.FORBID_CONTENTS, Pe)), Se && (be["#text"] = !0), ye && me(be, ["html", "head", "body"]), be.table && (me(be, ["tbody"]), delete A.tbody), S.TRUSTED_TYPES_POLICY) {
        if (typeof S.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Zn('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof S.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Zn('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        W = S.TRUSTED_TYPES_POLICY, M = W.createHTML("");
      } else
        W === void 0 && (W = al(L, o)), W !== null && typeof M == "string" && (M = W.createHTML(""));
      ct && ct(S), Qe = S;
    }
  }, Zt = me({}, [...li, ...ci, ...Ka]), Jt = me({}, [...ui, ...Za]), _n = function(S) {
    let F = V(S);
    (!F || !F.tagName) && (F = {
      namespaceURI: Pt,
      tagName: "template"
    });
    const X = jr(S.tagName), Ce = jr(F.tagName);
    return cn[S.namespaceURI] ? S.namespaceURI === St ? F.namespaceURI === pt ? X === "svg" : F.namespaceURI === Nt ? X === "svg" && (Ce === "annotation-xml" || Je[Ce]) : !!Zt[X] : S.namespaceURI === Nt ? F.namespaceURI === pt ? X === "math" : F.namespaceURI === St ? X === "math" && It[Ce] : !!Jt[X] : S.namespaceURI === pt ? F.namespaceURI === St && !It[Ce] || F.namespaceURI === Nt && !Je[Ce] ? !1 : !Jt[X] && (Yt[X] || !Zt[X]) : !!(ge === "application/xhtml+xml" && cn[S.namespaceURI]) : !1;
  }, ot = function(S) {
    Gn(t.removed, {
      element: S
    });
    try {
      V(S).removeChild(S);
    } catch {
      N(S);
    }
  }, $t = function(S, F) {
    try {
      Gn(t.removed, {
        attribute: F.getAttributeNode(S),
        from: F
      });
    } catch {
      Gn(t.removed, {
        attribute: null,
        from: F
      });
    }
    if (F.removeAttribute(S), S === "is")
      if (le || Ee)
        try {
          ot(F);
        } catch {
        }
      else
        try {
          F.setAttribute(S, "");
        } catch {
        }
  }, En = function(S) {
    let F = null, X = null;
    if (Ae)
      S = "<remove></remove>" + S;
    else {
      const ze = Co(S, /^[\r\n\t ]+/);
      X = ze && ze[0];
    }
    ge === "application/xhtml+xml" && Pt === pt && (S = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + S + "</body></html>");
    const Ce = W ? W.createHTML(S) : S;
    if (Pt === pt)
      try {
        F = new C().parseFromString(Ce, ge);
      } catch {
      }
    if (!F || !F.documentElement) {
      F = J.createDocument(Pt, "template", null);
      try {
        F.documentElement.innerHTML = ln ? M : Ce;
      } catch {
      }
    }
    const We = F.body || F.documentElement;
    return S && X && We.insertBefore(n.createTextNode(X), We.childNodes[0] || null), Pt === pt ? Fe.call(F, ye ? "html" : "body")[0] : ye ? F.documentElement : We;
  }, Cn = function(S) {
    return se.call(
      S.ownerDocument || S,
      S,
      // eslint-disable-next-line no-bitwise
      p.SHOW_ELEMENT | p.SHOW_COMMENT | p.SHOW_TEXT | p.SHOW_PROCESSING_INSTRUCTION | p.SHOW_CDATA_SECTION,
      null
    );
  }, Lt = function(S) {
    return S instanceof w && (typeof S.nodeName != "string" || typeof S.textContent != "string" || typeof S.removeChild != "function" || !(S.attributes instanceof b) || typeof S.removeAttribute != "function" || typeof S.setAttribute != "function" || typeof S.namespaceURI != "string" || typeof S.insertBefore != "function" || typeof S.hasChildNodes != "function");
  }, un = function(S) {
    return typeof m == "function" && S instanceof m;
  };
  function nt(G, S, F) {
    Sr(G, (X) => {
      X.call(t, S, F, Qe);
    });
  }
  const Qt = function(S) {
    let F = null;
    if (nt(ke.beforeSanitizeElements, S, null), Lt(S))
      return ot(S), !0;
    const X = Pe(S.nodeName);
    if (nt(ke.uponSanitizeElement, S, {
      tagName: X,
      allowedTags: be
    }), S.hasChildNodes() && !un(S.firstElementChild) && at(/<[/\w!]/g, S.innerHTML) && at(/<[/\w!]/g, S.textContent) || S.nodeType === Qn.progressingInstruction || de && S.nodeType === Qn.comment && at(/<[/\w]/g, S.data))
      return ot(S), !0;
    if (!be[X] || A[X]) {
      if (!A[X] && Mt(X) && (U.tagNameCheck instanceof RegExp && at(U.tagNameCheck, X) || U.tagNameCheck instanceof Function && U.tagNameCheck(X)))
        return !1;
      if (Se && !it[X]) {
        const Ce = V(S) || S.parentNode, We = D(S) || S.childNodes;
        if (We && Ce) {
          const ze = We.length;
          for (let Te = ze - 1; Te >= 0; --Te) {
            const st = k(We[Te], !0);
            st.__removalCount = (S.__removalCount || 0) + 1, Ce.insertBefore(st, j(S));
          }
        }
      }
      return ot(S), !0;
    }
    return S instanceof h && !_n(S) || (X === "noscript" || X === "noembed" || X === "noframes") && at(/<\/no(script|embed|frames)/i, S.innerHTML) ? (ot(S), !0) : (Z && S.nodeType === Qn.text && (F = S.textContent, Sr([ve, Q, he], (Ce) => {
      F = Kn(F, Ce, " ");
    }), S.textContent !== F && (Gn(t.removed, {
      element: S.cloneNode()
    }), S.textContent = F)), nt(ke.afterSanitizeElements, S, null), !1);
  }, Rn = function(S, F, X) {
    if (je && (F === "id" || F === "name") && (X in n || X in Gt))
      return !1;
    if (!(pe && !ue[F] && at(Ne, F))) {
      if (!(z && at(dt, F))) {
        if (!B[F] || ue[F]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Mt(S) && (U.tagNameCheck instanceof RegExp && at(U.tagNameCheck, S) || U.tagNameCheck instanceof Function && U.tagNameCheck(S)) && (U.attributeNameCheck instanceof RegExp && at(U.attributeNameCheck, F) || U.attributeNameCheck instanceof Function && U.attributeNameCheck(F)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            F === "is" && U.allowCustomizedBuiltInElements && (U.tagNameCheck instanceof RegExp && at(U.tagNameCheck, X) || U.tagNameCheck instanceof Function && U.tagNameCheck(X)))
          ) return !1;
        } else if (!qt[F]) {
          if (!at(ft, Kn(X, Be, ""))) {
            if (!((F === "src" || F === "xlink:href" || F === "href") && S !== "script" && qa(X, "data:") === 0 && Ke[S])) {
              if (!(re && !at($e, Kn(X, Be, "")))) {
                if (X)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Mt = function(S) {
    return S !== "annotation-xml" && Co(S, qe);
  }, On = function(S) {
    nt(ke.beforeSanitizeAttributes, S, null);
    const {
      attributes: F
    } = S;
    if (!F || Lt(S))
      return;
    const X = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: B,
      forceKeepAttr: void 0
    };
    let Ce = F.length;
    for (; Ce--; ) {
      const We = F[Ce], {
        name: ze,
        namespaceURI: Te,
        value: st
      } = We, kt = Pe(ze);
      let Ue = ze === "value" ? st : Ya(st);
      if (X.attrName = kt, X.attrValue = Ue, X.keepAttr = !0, X.forceKeepAttr = void 0, nt(ke.uponSanitizeAttribute, S, X), Ue = X.attrValue, vt && (kt === "id" || kt === "name") && ($t(ze, S), Ue = Ge + Ue), de && at(/((--!?|])>)|<\/(style|title)/i, Ue)) {
        $t(ze, S);
        continue;
      }
      if (X.forceKeepAttr || ($t(ze, S), !X.keepAttr))
        continue;
      if (!ie && at(/\/>/i, Ue)) {
        $t(ze, S);
        continue;
      }
      Z && Sr([ve, Q, he], (Tt) => {
        Ue = Kn(Ue, Tt, " ");
      });
      const fn = Pe(S.nodeName);
      if (Rn(fn, kt, Ue)) {
        if (W && typeof L == "object" && typeof L.getAttributeType == "function" && !Te)
          switch (L.getAttributeType(fn, kt)) {
            case "TrustedHTML": {
              Ue = W.createHTML(Ue);
              break;
            }
            case "TrustedScriptURL": {
              Ue = W.createScriptURL(Ue);
              break;
            }
          }
        try {
          Te ? S.setAttributeNS(Te, ze, Ue) : S.setAttribute(ze, Ue), Lt(S) ? ot(S) : Eo(t.removed);
        } catch {
        }
      }
    }
    nt(ke.afterSanitizeAttributes, S, null);
  }, dn = function G(S) {
    let F = null;
    const X = Cn(S);
    for (nt(ke.beforeSanitizeShadowDOM, S, null); F = X.nextNode(); )
      nt(ke.uponSanitizeShadowNode, F, null), Qt(F), On(F), F.content instanceof a && G(F.content);
    nt(ke.afterSanitizeShadowDOM, S, null);
  };
  return t.sanitize = function(G) {
    let S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, F = null, X = null, Ce = null, We = null;
    if (ln = !G, ln && (G = "<!-->"), typeof G != "string" && !un(G))
      if (typeof G.toString == "function") {
        if (G = G.toString(), typeof G != "string")
          throw Zn("dirty is not a string, aborting");
      } else
        throw Zn("toString is not a function");
    if (!t.isSupported)
      return G;
    if (ae || Kt(S), t.removed = [], typeof G == "string" && (K = !1), K) {
      if (G.nodeName) {
        const st = Pe(G.nodeName);
        if (!be[st] || A[st])
          throw Zn("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (G instanceof m)
      F = En("<!---->"), X = F.ownerDocument.importNode(G, !0), X.nodeType === Qn.element && X.nodeName === "BODY" || X.nodeName === "HTML" ? F = X : F.appendChild(X);
    else {
      if (!le && !Z && !ye && // eslint-disable-next-line unicorn/prefer-includes
      G.indexOf("<") === -1)
        return W && Xe ? W.createHTML(G) : G;
      if (F = En(G), !F)
        return le ? null : Xe ? M : "";
    }
    F && Ae && ot(F.firstChild);
    const ze = Cn(K ? G : F);
    for (; Ce = ze.nextNode(); )
      Qt(Ce), On(Ce), Ce.content instanceof a && dn(Ce.content);
    if (K)
      return G;
    if (le) {
      if (Ee)
        for (We = Oe.call(F.ownerDocument); F.firstChild; )
          We.appendChild(F.firstChild);
      else
        We = F;
      return (B.shadowroot || B.shadowrootmode) && (We = Ve.call(r, We, !0)), We;
    }
    let Te = ye ? F.outerHTML : F.innerHTML;
    return ye && be["!doctype"] && F.ownerDocument && F.ownerDocument.doctype && F.ownerDocument.doctype.name && at(ws, F.ownerDocument.doctype.name) && (Te = "<!DOCTYPE " + F.ownerDocument.doctype.name + `>
` + Te), Z && Sr([ve, Q, he], (st) => {
      Te = Kn(Te, st, " ");
    }), W && Xe ? W.createHTML(Te) : Te;
  }, t.setConfig = function() {
    let G = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Kt(G), ae = !0;
  }, t.clearConfig = function() {
    Qe = null, ae = !1;
  }, t.isValidAttribute = function(G, S, F) {
    Qe || Kt({});
    const X = Pe(G), Ce = Pe(S);
    return Rn(X, Ce, F);
  }, t.addHook = function(G, S) {
    typeof S == "function" && Gn(ke[G], S);
  }, t.removeHook = function(G, S) {
    if (S !== void 0) {
      const F = Wa(ke[G], S);
      return F === -1 ? void 0 : Ua(ke[G], F, 1)[0];
    }
    return Eo(ke[G]);
  }, t.removeHooks = function(G) {
    ke[G] = [];
  }, t.removeAllHooks = function() {
    ke = Po();
  }, t;
}
var Io = Ss();
let Tr = null;
function ll() {
  return Tr || (typeof window < "u" ? Tr = Io(window) : Tr = Io), Tr;
}
function cl(e) {
  const t = e ? document.querySelector(e) : document;
  return t ? t.querySelector(
    'button, [href], input, select, textarea, [tabIndex]:not([tabIndex="-1"])'
  ) : null;
}
const xt = (e) => ({ __html: ll().sanitize(e) }), Lo = (e, t, n) => {
  let r = e;
  const o = [];
  for (; r < t; )
    r > 0 && r <= n && o.push(r), r += 1;
  return o;
};
let fi = !1;
const yi = (e, t) => {
  fi || (fi = !0, setTimeout(() => {
    e(), fi = !1;
  }, t));
};
let Mo;
const xi = (e, t) => {
  window.clearTimeout(Mo), Mo = window.setTimeout(e, t);
};
function ul(e) {
  if (e && typeof e.getBoundingClientRect == "function") {
    const { bottom: t, top: n } = e.getBoundingClientRect(), { offsetTop: r } = e;
    if (n < 0 && t > 0) {
      const o = e.style;
      e.style = `${o};transition: height 0s !important; overflow:hidden; height:${t}px!important;max-height:${t}px!important`, window.scrollTo({ behavior: "instant", top: r }), setTimeout(() => {
        e.style = o, window.scrollTo({
          behavior: "smooth",
          top: e.offsetTop - t / 2
        });
      }, 50);
    }
  }
}
l.shape({
  event: l.string,
  action: l.string,
  name: l.string,
  region: l.string,
  section: l.string,
  component: l.string,
  type: l.string,
  text: l.string
});
const ks = ({
  event: e = "",
  action: t = "",
  name: n = "",
  type: r = "",
  section: o = "",
  text: a = "",
  region: d = "",
  component: m = ""
}) => {
  const { dataLayer: h } = window, p = {
    event: e.toLowerCase(),
    action: t.toLowerCase(),
    name: n.toLowerCase(),
    type: r.toLowerCase(),
    region: d.toLowerCase(),
    section: o.toLowerCase(),
    text: a.toLowerCase(),
    component: m.toLowerCase()
  };
  h && h.push(p);
}, rr = ({ children: e }) => /* @__PURE__ */ f.jsx(f.Fragment, { children: e });
rr.propTypes = {
  children: l.oneOfType([
    l.arrayOf(l.node),
    l.node,
    l.string
  ])
};
var Ts = { exports: {} };
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var a = "", d = 0; d < arguments.length; d++) {
        var m = arguments[d];
        m && (a = o(a, r(m)));
      }
      return a;
    }
    function r(a) {
      if (typeof a == "string" || typeof a == "number")
        return a;
      if (typeof a != "object")
        return "";
      if (Array.isArray(a))
        return n.apply(null, a);
      if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
        return a.toString();
      var d = "";
      for (var m in a)
        t.call(a, m) && a[m] && (d = o(d, m));
      return d;
    }
    function o(a, d) {
      return d ? a ? a + " " + d : a + d : a;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(Ts);
var dl = Ts.exports;
const we = /* @__PURE__ */ zi(dl);
({
  ...rr.propTypes
});
const _s = ({ children: e, className: t = "container", ...n }) => /* @__PURE__ */ f.jsx("div", { className: t, ...n, children: /* @__PURE__ */ f.jsx("div", { className: "row", children: e }) });
_s.propTypes = {
  children: rr.propTypes.children
};
({
  ..._s.propTypes
});
rr.propTypes.children, l.oneOf(["0", "3", "4", "6", "8", "9", "12"]);
rr.propTypes.children;
const fl = l.shape({
  url: l.string,
  altText: l.string,
  cssClass: l.arrayOf(l.string),
  size: l.oneOf(["small", "medium", "large"])
}), pi = l.shape({
  text: l.string,
  maxWidth: l.string,
  cssClass: l.arrayOf(l.string),
  highlightColor: l.oneOf(["gold", "black"])
}), Es = l.shape({
  color: l.oneOf(["gold", "maroon", "gray", "dark"]),
  content: l.shape({
    icon: l.arrayOf(l.string),
    header: l.string,
    body: l.string
  })
}), Hi = l.shape({
  text: l.string,
  name: l.string,
  event: l.string,
  action: l.string,
  type: l.string,
  region: l.string,
  section: l.string,
  component: l.string
});
var yn = {};
var Do;
function pl() {
  if (Do) return yn;
  Do = 1;
  var e = He;
  function t(i) {
    for (var u = "https://reactjs.org/docs/error-decoder.html?invariant=" + i, v = 1; v < arguments.length; v++) u += "&args[]=" + encodeURIComponent(arguments[v]);
    return "Minified React error #" + i + "; visit " + u + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var n = Object.prototype.hasOwnProperty, r = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, o = {}, a = {};
  function d(i) {
    return n.call(a, i) ? !0 : n.call(o, i) ? !1 : r.test(i) ? a[i] = !0 : (o[i] = !0, !1);
  }
  function m(i, u, v, x, R, T, P) {
    this.acceptsBooleans = u === 2 || u === 3 || u === 4, this.attributeName = x, this.attributeNamespace = R, this.mustUseProperty = v, this.propertyName = i, this.type = u, this.sanitizeURL = T, this.removeEmptyString = P;
  }
  var h = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(i) {
    h[i] = new m(i, 0, !1, i, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(i) {
    var u = i[0];
    h[u] = new m(u, 1, !1, i[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(i) {
    h[i] = new m(i, 2, !1, i.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(i) {
    h[i] = new m(i, 2, !1, i, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(i) {
    h[i] = new m(i, 3, !1, i.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(i) {
    h[i] = new m(i, 3, !0, i, null, !1, !1);
  }), ["capture", "download"].forEach(function(i) {
    h[i] = new m(i, 4, !1, i, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(i) {
    h[i] = new m(i, 6, !1, i, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(i) {
    h[i] = new m(i, 5, !1, i.toLowerCase(), null, !1, !1);
  });
  var p = /[\-:]([a-z])/g;
  function b(i) {
    return i[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(i) {
    var u = i.replace(
      p,
      b
    );
    h[u] = new m(u, 1, !1, i, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(i) {
    var u = i.replace(p, b);
    h[u] = new m(u, 1, !1, i, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(i) {
    var u = i.replace(p, b);
    h[u] = new m(u, 1, !1, i, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(i) {
    h[i] = new m(i, 1, !1, i.toLowerCase(), null, !1, !1);
  }), h.xlinkHref = new m("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(i) {
    h[i] = new m(i, 1, !1, i.toLowerCase(), null, !0, !0);
  });
  var w = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, C = ["Webkit", "ms", "Moz", "O"];
  Object.keys(w).forEach(function(i) {
    C.forEach(function(u) {
      u = u + i.charAt(0).toUpperCase() + i.substring(1), w[u] = w[i];
    });
  });
  var L = /["'&<>]/;
  function O(i) {
    if (typeof i == "boolean" || typeof i == "number") return "" + i;
    i = "" + i;
    var u = L.exec(i);
    if (u) {
      var v = "", x, R = 0;
      for (x = u.index; x < i.length; x++) {
        switch (i.charCodeAt(x)) {
          case 34:
            u = "&quot;";
            break;
          case 38:
            u = "&amp;";
            break;
          case 39:
            u = "&#x27;";
            break;
          case 60:
            u = "&lt;";
            break;
          case 62:
            u = "&gt;";
            break;
          default:
            continue;
        }
        R !== x && (v += i.substring(R, x)), R = x + 1, v += u;
      }
      i = R !== x ? v + i.substring(R, x) : v;
    }
    return i;
  }
  var k = /([A-Z])/g, N = /^ms-/, j = Array.isArray;
  function D(i, u) {
    return { insertionMode: i, selectedValue: u };
  }
  function V(i, u, v) {
    switch (u) {
      case "select":
        return D(1, v.value != null ? v.value : v.defaultValue);
      case "svg":
        return D(2, null);
      case "math":
        return D(3, null);
      case "foreignObject":
        return D(1, null);
      case "table":
        return D(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return D(5, null);
      case "colgroup":
        return D(7, null);
      case "tr":
        return D(6, null);
    }
    return 4 <= i.insertionMode || i.insertionMode === 0 ? D(1, null) : i;
  }
  var W = /* @__PURE__ */ new Map();
  function M(i, u, v) {
    if (typeof v != "object") throw Error(t(62));
    u = !0;
    for (var x in v) if (n.call(v, x)) {
      var R = v[x];
      if (R != null && typeof R != "boolean" && R !== "") {
        if (x.indexOf("--") === 0) {
          var T = O(x);
          R = O(("" + R).trim());
        } else {
          T = x;
          var P = W.get(T);
          P !== void 0 || (P = O(T.replace(k, "-$1").toLowerCase().replace(N, "-ms-")), W.set(T, P)), T = P, R = typeof R == "number" ? R === 0 || n.call(w, x) ? "" + R : R + "px" : O(("" + R).trim());
        }
        u ? (u = !1, i.push(' style="', T, ":", R)) : i.push(";", T, ":", R);
      }
    }
    u || i.push('"');
  }
  function J(i, u, v, x) {
    switch (v) {
      case "style":
        M(i, u, x);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < v.length) || v[0] !== "o" && v[0] !== "O" || v[1] !== "n" && v[1] !== "N") {
      if (u = h.hasOwnProperty(v) ? h[v] : null, u !== null) {
        switch (typeof x) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!u.acceptsBooleans) return;
        }
        switch (v = u.attributeName, u.type) {
          case 3:
            x && i.push(" ", v, '=""');
            break;
          case 4:
            x === !0 ? i.push(" ", v, '=""') : x !== !1 && i.push(" ", v, '="', O(x), '"');
            break;
          case 5:
            isNaN(x) || i.push(" ", v, '="', O(x), '"');
            break;
          case 6:
            !isNaN(x) && 1 <= x && i.push(" ", v, '="', O(x), '"');
            break;
          default:
            u.sanitizeURL && (x = "" + x), i.push(" ", v, '="', O(x), '"');
        }
      } else if (d(v)) {
        switch (typeof x) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (u = v.toLowerCase().slice(0, 5), u !== "data-" && u !== "aria-") return;
        }
        i.push(" ", v, '="', O(x), '"');
      }
    }
  }
  function se(i, u, v) {
    if (u != null) {
      if (v != null) throw Error(t(60));
      if (typeof u != "object" || !("__html" in u)) throw Error(t(61));
      u = u.__html, u != null && i.push("" + u);
    }
  }
  function Oe(i) {
    var u = "";
    return e.Children.forEach(i, function(v) {
      v != null && (u += v);
    }), u;
  }
  function Fe(i, u, v, x) {
    i.push(ve(v));
    var R = v = null, T;
    for (T in u) if (n.call(u, T)) {
      var P = u[T];
      if (P != null) switch (T) {
        case "children":
          v = P;
          break;
        case "dangerouslySetInnerHTML":
          R = P;
          break;
        default:
          J(i, x, T, P);
      }
    }
    return i.push(">"), se(i, R, v), typeof v == "string" ? (i.push(O(v)), null) : v;
  }
  var Ve = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, ke = /* @__PURE__ */ new Map();
  function ve(i) {
    var u = ke.get(i);
    if (u === void 0) {
      if (!Ve.test(i)) throw Error(t(65, i));
      u = "<" + i, ke.set(i, u);
    }
    return u;
  }
  function Q(i, u, v, x, R) {
    switch (u) {
      case "select":
        i.push(ve("select"));
        var T = null, P = null;
        for (oe in v) if (n.call(v, oe)) {
          var H = v[oe];
          if (H != null) switch (oe) {
            case "children":
              T = H;
              break;
            case "dangerouslySetInnerHTML":
              P = H;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              J(i, x, oe, H);
          }
        }
        return i.push(">"), se(i, P, T), T;
      case "option":
        P = R.selectedValue, i.push(ve("option"));
        var ee = H = null, ne = null, oe = null;
        for (T in v) if (n.call(v, T)) {
          var Me = v[T];
          if (Me != null) switch (T) {
            case "children":
              H = Me;
              break;
            case "selected":
              ne = Me;
              break;
            case "dangerouslySetInnerHTML":
              oe = Me;
              break;
            case "value":
              ee = Me;
            default:
              J(i, x, T, Me);
          }
        }
        if (P != null) if (v = ee !== null ? "" + ee : Oe(H), j(P)) {
          for (x = 0; x < P.length; x++)
            if ("" + P[x] === v) {
              i.push(' selected=""');
              break;
            }
        } else "" + P === v && i.push(' selected=""');
        else ne && i.push(' selected=""');
        return i.push(">"), se(i, oe, H), H;
      case "textarea":
        i.push(ve("textarea")), oe = P = T = null;
        for (H in v) if (n.call(v, H) && (ee = v[H], ee != null)) switch (H) {
          case "children":
            oe = ee;
            break;
          case "value":
            T = ee;
            break;
          case "defaultValue":
            P = ee;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(91));
          default:
            J(
              i,
              x,
              H,
              ee
            );
        }
        if (T === null && P !== null && (T = P), i.push(">"), oe != null) {
          if (T != null) throw Error(t(92));
          if (j(oe) && 1 < oe.length) throw Error(t(93));
          T = "" + oe;
        }
        return typeof T == "string" && T[0] === `
` && i.push(`
`), T !== null && i.push(O("" + T)), null;
      case "input":
        i.push(ve("input")), ee = oe = H = T = null;
        for (P in v) if (n.call(v, P) && (ne = v[P], ne != null)) switch (P) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, "input"));
          case "defaultChecked":
            ee = ne;
            break;
          case "defaultValue":
            H = ne;
            break;
          case "checked":
            oe = ne;
            break;
          case "value":
            T = ne;
            break;
          default:
            J(i, x, P, ne);
        }
        return oe !== null ? J(i, x, "checked", oe) : ee !== null && J(i, x, "checked", ee), T !== null ? J(i, x, "value", T) : H !== null && J(i, x, "value", H), i.push("/>"), null;
      case "menuitem":
        i.push(ve("menuitem"));
        for (var _t in v) if (n.call(v, _t) && (T = v[_t], T != null)) switch (_t) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(400));
          default:
            J(i, x, _t, T);
        }
        return i.push(">"), null;
      case "title":
        i.push(ve("title")), T = null;
        for (Me in v) if (n.call(v, Me) && (P = v[Me], P != null)) switch (Me) {
          case "children":
            T = P;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(434));
          default:
            J(i, x, Me, P);
        }
        return i.push(">"), T;
      case "listing":
      case "pre":
        i.push(ve(u)), P = T = null;
        for (ee in v) if (n.call(v, ee) && (H = v[ee], H != null)) switch (ee) {
          case "children":
            T = H;
            break;
          case "dangerouslySetInnerHTML":
            P = H;
            break;
          default:
            J(i, x, ee, H);
        }
        if (i.push(">"), P != null) {
          if (T != null) throw Error(t(60));
          if (typeof P != "object" || !("__html" in P)) throw Error(t(61));
          v = P.__html, v != null && (typeof v == "string" && 0 < v.length && v[0] === `
` ? i.push(`
`, v) : i.push("" + v));
        }
        return typeof T == "string" && T[0] === `
` && i.push(`
`), T;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        i.push(ve(u));
        for (var Et in v) if (n.call(v, Et) && (T = v[Et], T != null)) switch (Et) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, u));
          default:
            J(i, x, Et, T);
        }
        return i.push("/>"), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return Fe(
          i,
          v,
          u,
          x
        );
      case "html":
        return R.insertionMode === 0 && i.push("<!DOCTYPE html>"), Fe(i, v, u, x);
      default:
        if (u.indexOf("-") === -1 && typeof v.is != "string") return Fe(i, v, u, x);
        i.push(ve(u)), P = T = null;
        for (ne in v) if (n.call(v, ne) && (H = v[ne], H != null)) switch (ne) {
          case "children":
            T = H;
            break;
          case "dangerouslySetInnerHTML":
            P = H;
            break;
          case "style":
            M(i, x, H);
            break;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;
          default:
            d(ne) && typeof H != "function" && typeof H != "symbol" && i.push(" ", ne, '="', O(H), '"');
        }
        return i.push(">"), se(i, P, T), T;
    }
  }
  function he(i, u, v) {
    if (i.push('<!--$?--><template id="'), v === null) throw Error(t(395));
    return i.push(v), i.push('"></template>');
  }
  function Ne(i, u, v, x) {
    switch (v.insertionMode) {
      case 0:
      case 1:
        return i.push('<div hidden id="'), i.push(u.segmentPrefix), u = x.toString(16), i.push(u), i.push('">');
      case 2:
        return i.push('<svg aria-hidden="true" style="display:none" id="'), i.push(u.segmentPrefix), u = x.toString(16), i.push(u), i.push('">');
      case 3:
        return i.push('<math aria-hidden="true" style="display:none" id="'), i.push(u.segmentPrefix), u = x.toString(16), i.push(u), i.push('">');
      case 4:
        return i.push('<table hidden id="'), i.push(u.segmentPrefix), u = x.toString(16), i.push(u), i.push('">');
      case 5:
        return i.push('<table hidden><tbody id="'), i.push(u.segmentPrefix), u = x.toString(16), i.push(u), i.push('">');
      case 6:
        return i.push('<table hidden><tr id="'), i.push(u.segmentPrefix), u = x.toString(16), i.push(u), i.push('">');
      case 7:
        return i.push('<table hidden><colgroup id="'), i.push(u.segmentPrefix), u = x.toString(16), i.push(u), i.push('">');
      default:
        throw Error(t(397));
    }
  }
  function dt(i, u) {
    switch (u.insertionMode) {
      case 0:
      case 1:
        return i.push("</div>");
      case 2:
        return i.push("</svg>");
      case 3:
        return i.push("</math>");
      case 4:
        return i.push("</table>");
      case 5:
        return i.push("</tbody></table>");
      case 6:
        return i.push("</tr></table>");
      case 7:
        return i.push("</colgroup></table>");
      default:
        throw Error(t(397));
    }
  }
  var $e = /[<\u2028\u2029]/g;
  function Be(i) {
    return JSON.stringify(i).replace($e, function(u) {
      switch (u) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  function qe(i, u) {
    return u = u === void 0 ? "" : u, { bootstrapChunks: [], startInlineScript: "<script>", placeholderPrefix: u + "P:", segmentPrefix: u + "S:", boundaryPrefix: u + "B:", idPrefix: u, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1, generateStaticMarkup: i };
  }
  function ft(i, u, v, x) {
    return v.generateStaticMarkup ? (i.push(O(u)), !1) : (u === "" ? i = x : (x && i.push("<!-- -->"), i.push(O(u)), i = !0), i);
  }
  var be = Object.assign, Y = Symbol.for("react.element"), B = Symbol.for("react.portal"), q = Symbol.for("react.fragment"), U = Symbol.for("react.strict_mode"), A = Symbol.for("react.profiler"), ue = Symbol.for("react.provider"), z = Symbol.for("react.context"), pe = Symbol.for("react.forward_ref"), re = Symbol.for("react.suspense"), ie = Symbol.for("react.suspense_list"), Z = Symbol.for("react.memo"), de = Symbol.for("react.lazy"), ye = Symbol.for("react.scope"), ae = Symbol.for("react.debug_trace_mode"), Ae = Symbol.for("react.legacy_hidden"), le = Symbol.for("react.default_value"), Ee = Symbol.iterator;
  function Xe(i) {
    if (i == null) return null;
    if (typeof i == "function") return i.displayName || i.name || null;
    if (typeof i == "string") return i;
    switch (i) {
      case q:
        return "Fragment";
      case B:
        return "Portal";
      case A:
        return "Profiler";
      case U:
        return "StrictMode";
      case re:
        return "Suspense";
      case ie:
        return "SuspenseList";
    }
    if (typeof i == "object") switch (i.$$typeof) {
      case z:
        return (i.displayName || "Context") + ".Consumer";
      case ue:
        return (i._context.displayName || "Context") + ".Provider";
      case pe:
        var u = i.render;
        return i = i.displayName, i || (i = u.displayName || u.name || "", i = i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef"), i;
      case Z:
        return u = i.displayName || null, u !== null ? u : Xe(i.type) || "Memo";
      case de:
        u = i._payload, i = i._init;
        try {
          return Xe(i(u));
        } catch {
        }
    }
    return null;
  }
  var je = {};
  function vt(i, u) {
    if (i = i.contextTypes, !i) return je;
    var v = {}, x;
    for (x in i) v[x] = u[x];
    return v;
  }
  var Ge = null;
  function Se(i, u) {
    if (i !== u) {
      i.context._currentValue2 = i.parentValue, i = i.parent;
      var v = u.parent;
      if (i === null) {
        if (v !== null) throw Error(t(401));
      } else {
        if (v === null) throw Error(t(401));
        Se(i, v);
      }
      u.context._currentValue2 = u.value;
    }
  }
  function K(i) {
    i.context._currentValue2 = i.parentValue, i = i.parent, i !== null && K(i);
  }
  function xe(i) {
    var u = i.parent;
    u !== null && xe(u), i.context._currentValue2 = i.value;
  }
  function it(i, u) {
    if (i.context._currentValue2 = i.parentValue, i = i.parent, i === null) throw Error(t(402));
    i.depth === u.depth ? Se(i, u) : it(i, u);
  }
  function wt(i, u) {
    var v = u.parent;
    if (v === null) throw Error(t(402));
    i.depth === v.depth ? Se(i, v) : wt(i, v), u.context._currentValue2 = u.value;
  }
  function Ke(i) {
    var u = Ge;
    u !== i && (u === null ? xe(i) : i === null ? K(u) : u.depth === i.depth ? Se(u, i) : u.depth > i.depth ? it(u, i) : wt(u, i), Ge = i);
  }
  var an = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(i, u) {
    i = i._reactInternals, i.queue !== null && i.queue.push(u);
  }, enqueueReplaceState: function(i, u) {
    i = i._reactInternals, i.replace = !0, i.queue = [u];
  }, enqueueForceUpdate: function() {
  } };
  function qt(i, u, v, x) {
    var R = i.state !== void 0 ? i.state : null;
    i.updater = an, i.props = v, i.state = R;
    var T = { queue: [], replace: !1 };
    i._reactInternals = T;
    var P = u.contextType;
    if (i.context = typeof P == "object" && P !== null ? P._currentValue2 : x, P = u.getDerivedStateFromProps, typeof P == "function" && (P = P(v, R), R = P == null ? R : be({}, R, P), i.state = R), typeof u.getDerivedStateFromProps != "function" && typeof i.getSnapshotBeforeUpdate != "function" && (typeof i.UNSAFE_componentWillMount == "function" || typeof i.componentWillMount == "function")) if (u = i.state, typeof i.componentWillMount == "function" && i.componentWillMount(), typeof i.UNSAFE_componentWillMount == "function" && i.UNSAFE_componentWillMount(), u !== i.state && an.enqueueReplaceState(i, i.state, null), T.queue !== null && 0 < T.queue.length) if (u = T.queue, P = T.replace, T.queue = null, T.replace = !1, P && u.length === 1) i.state = u[0];
    else {
      for (T = P ? u[0] : i.state, R = !0, P = P ? 1 : 0; P < u.length; P++) {
        var H = u[P];
        H = typeof H == "function" ? H.call(i, T, v, x) : H, H != null && (R ? (R = !1, T = be({}, T, H)) : be(T, H));
      }
      i.state = T;
    }
    else T.queue = null;
  }
  var Tn = { id: 1, overflow: "" };
  function Nt(i, u, v) {
    var x = i.id;
    i = i.overflow;
    var R = 32 - St(x) - 1;
    x &= ~(1 << R), v += 1;
    var T = 32 - St(u) + R;
    if (30 < T) {
      var P = R - R % 5;
      return T = (x & (1 << P) - 1).toString(32), x >>= P, R -= P, { id: 1 << 32 - St(u) + R | v << R | x, overflow: T + i };
    }
    return { id: 1 << T | v << R | x, overflow: i };
  }
  var St = Math.clz32 ? Math.clz32 : ln, pt = Math.log, Pt = Math.LN2;
  function ln(i) {
    return i >>>= 0, i === 0 ? 32 : 31 - (pt(i) / Pt | 0) | 0;
  }
  function cn(i, u) {
    return i === u && (i !== 0 || 1 / i === 1 / u) || i !== i && u !== u;
  }
  var Fn = typeof Object.is == "function" ? Object.is : cn, Je = null, It = null, Yt = null, ge = null, Ft = !1, Xt = !1, Pe = 0, Qe = null, Gt = 0;
  function yt() {
    if (Je === null) throw Error(t(321));
    return Je;
  }
  function Kt() {
    if (0 < Gt) throw Error(t(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function Zt() {
    return ge === null ? Yt === null ? (Ft = !1, Yt = ge = Kt()) : (Ft = !0, ge = Yt) : ge.next === null ? (Ft = !1, ge = ge.next = Kt()) : (Ft = !0, ge = ge.next), ge;
  }
  function Jt() {
    It = Je = null, Xt = !1, Yt = null, Gt = 0, ge = Qe = null;
  }
  function _n(i, u) {
    return typeof u == "function" ? u(i) : u;
  }
  function ot(i, u, v) {
    if (Je = yt(), ge = Zt(), Ft) {
      var x = ge.queue;
      if (u = x.dispatch, Qe !== null && (v = Qe.get(x), v !== void 0)) {
        Qe.delete(x), x = ge.memoizedState;
        do
          x = i(x, v.action), v = v.next;
        while (v !== null);
        return ge.memoizedState = x, [x, u];
      }
      return [ge.memoizedState, u];
    }
    return i = i === _n ? typeof u == "function" ? u() : u : v !== void 0 ? v(u) : u, ge.memoizedState = i, i = ge.queue = { last: null, dispatch: null }, i = i.dispatch = En.bind(null, Je, i), [ge.memoizedState, i];
  }
  function $t(i, u) {
    if (Je = yt(), ge = Zt(), u = u === void 0 ? null : u, ge !== null) {
      var v = ge.memoizedState;
      if (v !== null && u !== null) {
        var x = v[1];
        e: if (x === null) x = !1;
        else {
          for (var R = 0; R < x.length && R < u.length; R++) if (!Fn(u[R], x[R])) {
            x = !1;
            break e;
          }
          x = !0;
        }
        if (x) return v[0];
      }
    }
    return i = i(), ge.memoizedState = [i, u], i;
  }
  function En(i, u, v) {
    if (25 <= Gt) throw Error(t(301));
    if (i === Je) if (Xt = !0, i = { action: v, next: null }, Qe === null && (Qe = /* @__PURE__ */ new Map()), v = Qe.get(u), v === void 0) Qe.set(u, i);
    else {
      for (u = v; u.next !== null; ) u = u.next;
      u.next = i;
    }
  }
  function Cn() {
    throw Error(t(394));
  }
  function Lt() {
  }
  var un = { readContext: function(i) {
    return i._currentValue2;
  }, useContext: function(i) {
    return yt(), i._currentValue2;
  }, useMemo: $t, useReducer: ot, useRef: function(i) {
    Je = yt(), ge = Zt();
    var u = ge.memoizedState;
    return u === null ? (i = { current: i }, ge.memoizedState = i) : u;
  }, useState: function(i) {
    return ot(_n, i);
  }, useInsertionEffect: Lt, useLayoutEffect: function() {
  }, useCallback: function(i, u) {
    return $t(function() {
      return i;
    }, u);
  }, useImperativeHandle: Lt, useEffect: Lt, useDebugValue: Lt, useDeferredValue: function(i) {
    return yt(), i;
  }, useTransition: function() {
    return yt(), [
      !1,
      Cn
    ];
  }, useId: function() {
    var i = It.treeContext, u = i.overflow;
    i = i.id, i = (i & ~(1 << 32 - St(i) - 1)).toString(32) + u;
    var v = nt;
    if (v === null) throw Error(t(404));
    return u = Pe++, i = ":" + v.idPrefix + "R" + i, 0 < u && (i += "H" + u.toString(32)), i + ":";
  }, useMutableSource: function(i, u) {
    return yt(), u(i._source);
  }, useSyncExternalStore: function(i, u, v) {
    if (v === void 0) throw Error(t(407));
    return v();
  } }, nt = null, Qt = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function Rn(i) {
    return console.error(i), null;
  }
  function Mt() {
  }
  function On(i, u, v, x, R, T, P, H, ee) {
    var ne = [], oe = /* @__PURE__ */ new Set();
    return u = { destination: null, responseState: u, progressiveChunkSize: x === void 0 ? 12800 : x, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: oe, pingedTasks: ne, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: R === void 0 ? Rn : R, onAllReady: Mt, onShellReady: P === void 0 ? Mt : P, onShellError: Mt, onFatalError: Mt }, v = G(u, 0, null, v, !1, !1), v.parentFlushed = !0, i = dn(u, i, null, v, oe, je, null, Tn), ne.push(i), u;
  }
  function dn(i, u, v, x, R, T, P, H) {
    i.allPendingTasks++, v === null ? i.pendingRootTasks++ : v.pendingTasks++;
    var ee = { node: u, ping: function() {
      var ne = i.pingedTasks;
      ne.push(ee), ne.length === 1 && sr(i);
    }, blockedBoundary: v, blockedSegment: x, abortSet: R, legacyContext: T, context: P, treeContext: H };
    return R.add(ee), ee;
  }
  function G(i, u, v, x, R, T) {
    return { status: 0, id: -1, index: u, parentFlushed: !1, chunks: [], children: [], formatContext: x, boundary: v, lastPushedText: R, textEmbedded: T };
  }
  function S(i, u) {
    if (i = i.onError(u), i != null && typeof i != "string") throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof i + '" instead');
    return i;
  }
  function F(i, u) {
    var v = i.onShellError;
    v(u), v = i.onFatalError, v(u), i.destination !== null ? (i.status = 2, i.destination.destroy(u)) : (i.status = 1, i.fatalError = u);
  }
  function X(i, u, v, x, R) {
    for (Je = {}, It = u, Pe = 0, i = v(x, R); Xt; ) Xt = !1, Pe = 0, Gt += 1, ge = null, i = v(x, R);
    return Jt(), i;
  }
  function Ce(i, u, v, x) {
    var R = v.render(), T = x.childContextTypes;
    if (T != null) {
      var P = u.legacyContext;
      if (typeof v.getChildContext != "function") x = P;
      else {
        v = v.getChildContext();
        for (var H in v) if (!(H in T)) throw Error(t(108, Xe(x) || "Unknown", H));
        x = be({}, P, v);
      }
      u.legacyContext = x, Te(i, u, R), u.legacyContext = P;
    } else Te(i, u, R);
  }
  function We(i, u) {
    if (i && i.defaultProps) {
      u = be({}, u), i = i.defaultProps;
      for (var v in i) u[v] === void 0 && (u[v] = i[v]);
      return u;
    }
    return u;
  }
  function ze(i, u, v, x, R) {
    if (typeof v == "function") if (v.prototype && v.prototype.isReactComponent) {
      R = vt(v, u.legacyContext);
      var T = v.contextType;
      T = new v(x, typeof T == "object" && T !== null ? T._currentValue2 : R), qt(T, v, x, R), Ce(i, u, T, v);
    } else {
      T = vt(v, u.legacyContext), R = X(i, u, v, x, T);
      var P = Pe !== 0;
      if (typeof R == "object" && R !== null && typeof R.render == "function" && R.$$typeof === void 0) qt(R, v, x, T), Ce(i, u, R, v);
      else if (P) {
        x = u.treeContext, u.treeContext = Nt(x, 1, 0);
        try {
          Te(i, u, R);
        } finally {
          u.treeContext = x;
        }
      } else Te(i, u, R);
    }
    else if (typeof v == "string") {
      switch (R = u.blockedSegment, T = Q(R.chunks, v, x, i.responseState, R.formatContext), R.lastPushedText = !1, P = R.formatContext, R.formatContext = V(P, v, x), kt(i, u, T), R.formatContext = P, v) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          R.chunks.push("</", v, ">");
      }
      R.lastPushedText = !1;
    } else {
      switch (v) {
        case Ae:
        case ae:
        case U:
        case A:
        case q:
          Te(i, u, x.children);
          return;
        case ie:
          Te(i, u, x.children);
          return;
        case ye:
          throw Error(t(343));
        case re:
          e: {
            v = u.blockedBoundary, R = u.blockedSegment, T = x.fallback, x = x.children, P = /* @__PURE__ */ new Set();
            var H = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: P, errorDigest: null }, ee = G(i, R.chunks.length, H, R.formatContext, !1, !1);
            R.children.push(ee), R.lastPushedText = !1;
            var ne = G(i, 0, null, R.formatContext, !1, !1);
            ne.parentFlushed = !0, u.blockedBoundary = H, u.blockedSegment = ne;
            try {
              if (kt(
                i,
                u,
                x
              ), i.responseState.generateStaticMarkup || ne.lastPushedText && ne.textEmbedded && ne.chunks.push("<!-- -->"), ne.status = 1, Tt(H, ne), H.pendingTasks === 0) break e;
            } catch (oe) {
              ne.status = 4, H.forceClientRender = !0, H.errorDigest = S(i, oe);
            } finally {
              u.blockedBoundary = v, u.blockedSegment = R;
            }
            u = dn(i, T, v, ee, P, u.legacyContext, u.context, u.treeContext), i.pingedTasks.push(u);
          }
          return;
      }
      if (typeof v == "object" && v !== null) switch (v.$$typeof) {
        case pe:
          if (x = X(i, u, v.render, x, R), Pe !== 0) {
            v = u.treeContext, u.treeContext = Nt(v, 1, 0);
            try {
              Te(i, u, x);
            } finally {
              u.treeContext = v;
            }
          } else Te(i, u, x);
          return;
        case Z:
          v = v.type, x = We(v, x), ze(i, u, v, x, R);
          return;
        case ue:
          if (R = x.children, v = v._context, x = x.value, T = v._currentValue2, v._currentValue2 = x, P = Ge, Ge = x = { parent: P, depth: P === null ? 0 : P.depth + 1, context: v, parentValue: T, value: x }, u.context = x, Te(i, u, R), i = Ge, i === null) throw Error(t(403));
          x = i.parentValue, i.context._currentValue2 = x === le ? i.context._defaultValue : x, i = Ge = i.parent, u.context = i;
          return;
        case z:
          x = x.children, x = x(v._currentValue2), Te(i, u, x);
          return;
        case de:
          R = v._init, v = R(v._payload), x = We(v, x), ze(
            i,
            u,
            v,
            x,
            void 0
          );
          return;
      }
      throw Error(t(130, v == null ? v : typeof v, ""));
    }
  }
  function Te(i, u, v) {
    if (u.node = v, typeof v == "object" && v !== null) {
      switch (v.$$typeof) {
        case Y:
          ze(i, u, v.type, v.props, v.ref);
          return;
        case B:
          throw Error(t(257));
        case de:
          var x = v._init;
          v = x(v._payload), Te(i, u, v);
          return;
      }
      if (j(v)) {
        st(i, u, v);
        return;
      }
      if (v === null || typeof v != "object" ? x = null : (x = Ee && v[Ee] || v["@@iterator"], x = typeof x == "function" ? x : null), x && (x = x.call(v))) {
        if (v = x.next(), !v.done) {
          var R = [];
          do
            R.push(v.value), v = x.next();
          while (!v.done);
          st(i, u, R);
        }
        return;
      }
      throw i = Object.prototype.toString.call(v), Error(t(31, i === "[object Object]" ? "object with keys {" + Object.keys(v).join(", ") + "}" : i));
    }
    typeof v == "string" ? (x = u.blockedSegment, x.lastPushedText = ft(u.blockedSegment.chunks, v, i.responseState, x.lastPushedText)) : typeof v == "number" && (x = u.blockedSegment, x.lastPushedText = ft(u.blockedSegment.chunks, "" + v, i.responseState, x.lastPushedText));
  }
  function st(i, u, v) {
    for (var x = v.length, R = 0; R < x; R++) {
      var T = u.treeContext;
      u.treeContext = Nt(T, x, R);
      try {
        kt(i, u, v[R]);
      } finally {
        u.treeContext = T;
      }
    }
  }
  function kt(i, u, v) {
    var x = u.blockedSegment.formatContext, R = u.legacyContext, T = u.context;
    try {
      return Te(i, u, v);
    } catch (ee) {
      if (Jt(), typeof ee == "object" && ee !== null && typeof ee.then == "function") {
        v = ee;
        var P = u.blockedSegment, H = G(i, P.chunks.length, null, P.formatContext, P.lastPushedText, !0);
        P.children.push(H), P.lastPushedText = !1, i = dn(i, u.node, u.blockedBoundary, H, u.abortSet, u.legacyContext, u.context, u.treeContext).ping, v.then(i, i), u.blockedSegment.formatContext = x, u.legacyContext = R, u.context = T, Ke(T);
      } else throw u.blockedSegment.formatContext = x, u.legacyContext = R, u.context = T, Ke(T), ee;
    }
  }
  function Ue(i) {
    var u = i.blockedBoundary;
    i = i.blockedSegment, i.status = 3, en(this, u, i);
  }
  function fn(i, u, v) {
    var x = i.blockedBoundary;
    i.blockedSegment.status = 3, x === null ? (u.allPendingTasks--, u.status !== 2 && (u.status = 2, u.destination !== null && u.destination.push(null))) : (x.pendingTasks--, x.forceClientRender || (x.forceClientRender = !0, i = v === void 0 ? Error(t(432)) : v, x.errorDigest = u.onError(i), x.parentFlushed && u.clientRenderedBoundaries.push(x)), x.fallbackAbortableTasks.forEach(function(R) {
      return fn(R, u, v);
    }), x.fallbackAbortableTasks.clear(), u.allPendingTasks--, u.allPendingTasks === 0 && (x = u.onAllReady, x()));
  }
  function Tt(i, u) {
    if (u.chunks.length === 0 && u.children.length === 1 && u.children[0].boundary === null) {
      var v = u.children[0];
      v.id = u.id, v.parentFlushed = !0, v.status === 1 && Tt(i, v);
    } else i.completedSegments.push(u);
  }
  function en(i, u, v) {
    if (u === null) {
      if (v.parentFlushed) {
        if (i.completedRootSegment !== null) throw Error(t(389));
        i.completedRootSegment = v;
      }
      i.pendingRootTasks--, i.pendingRootTasks === 0 && (i.onShellError = Mt, u = i.onShellReady, u());
    } else u.pendingTasks--, u.forceClientRender || (u.pendingTasks === 0 ? (v.parentFlushed && v.status === 1 && Tt(u, v), u.parentFlushed && i.completedBoundaries.push(u), u.fallbackAbortableTasks.forEach(Ue, i), u.fallbackAbortableTasks.clear()) : v.parentFlushed && v.status === 1 && (Tt(u, v), u.completedSegments.length === 1 && u.parentFlushed && i.partialBoundaries.push(u)));
    i.allPendingTasks--, i.allPendingTasks === 0 && (i = i.onAllReady, i());
  }
  function sr(i) {
    if (i.status !== 2) {
      var u = Ge, v = Qt.current;
      Qt.current = un;
      var x = nt;
      nt = i.responseState;
      try {
        var R = i.pingedTasks, T;
        for (T = 0; T < R.length; T++) {
          var P = R[T], H = i, ee = P.blockedSegment;
          if (ee.status === 0) {
            Ke(P.context);
            try {
              Te(H, P, P.node), H.responseState.generateStaticMarkup || ee.lastPushedText && ee.textEmbedded && ee.chunks.push("<!-- -->"), P.abortSet.delete(P), ee.status = 1, en(H, P.blockedBoundary, ee);
            } catch (ht) {
              if (Jt(), typeof ht == "object" && ht !== null && typeof ht.then == "function") {
                var ne = P.ping;
                ht.then(ne, ne);
              } else {
                P.abortSet.delete(P), ee.status = 4;
                var oe = P.blockedBoundary, Me = ht, _t = S(H, Me);
                if (oe === null ? F(H, Me) : (oe.pendingTasks--, oe.forceClientRender || (oe.forceClientRender = !0, oe.errorDigest = _t, oe.parentFlushed && H.clientRenderedBoundaries.push(oe))), H.allPendingTasks--, H.allPendingTasks === 0) {
                  var Et = H.onAllReady;
                  Et();
                }
              }
            } finally {
            }
          }
        }
        R.splice(0, T), i.destination !== null && An(i, i.destination);
      } catch (ht) {
        S(i, ht), F(i, ht);
      } finally {
        nt = x, Qt.current = v, v === un && Ke(u);
      }
    }
  }
  function pn(i, u, v) {
    switch (v.parentFlushed = !0, v.status) {
      case 0:
        var x = v.id = i.nextSegmentId++;
        return v.lastPushedText = !1, v.textEmbedded = !1, i = i.responseState, u.push('<template id="'), u.push(i.placeholderPrefix), i = x.toString(16), u.push(i), u.push('"></template>');
      case 1:
        v.status = 2;
        var R = !0;
        x = v.chunks;
        var T = 0;
        v = v.children;
        for (var P = 0; P < v.length; P++) {
          for (R = v[P]; T < R.index; T++) u.push(x[T]);
          R = hn(i, u, R);
        }
        for (; T < x.length - 1; T++) u.push(x[T]);
        return T < x.length && (R = u.push(x[T])), R;
      default:
        throw Error(t(390));
    }
  }
  function hn(i, u, v) {
    var x = v.boundary;
    if (x === null) return pn(i, u, v);
    if (x.parentFlushed = !0, x.forceClientRender) return i.responseState.generateStaticMarkup || (x = x.errorDigest, u.push("<!--$!-->"), u.push("<template"), x && (u.push(' data-dgst="'), x = O(x), u.push(x), u.push('"')), u.push("></template>")), pn(i, u, v), i = i.responseState.generateStaticMarkup ? !0 : u.push("<!--/$-->"), i;
    if (0 < x.pendingTasks) {
      x.rootSegmentID = i.nextSegmentId++, 0 < x.completedSegments.length && i.partialBoundaries.push(x);
      var R = i.responseState, T = R.nextSuspenseID++;
      return R = R.boundaryPrefix + T.toString(16), x = x.id = R, he(u, i.responseState, x), pn(i, u, v), u.push("<!--/$-->");
    }
    if (x.byteSize > i.progressiveChunkSize) return x.rootSegmentID = i.nextSegmentId++, i.completedBoundaries.push(x), he(u, i.responseState, x.id), pn(i, u, v), u.push("<!--/$-->");
    if (i.responseState.generateStaticMarkup || u.push("<!--$-->"), v = x.completedSegments, v.length !== 1) throw Error(t(391));
    return hn(i, u, v[0]), i = i.responseState.generateStaticMarkup ? !0 : u.push("<!--/$-->"), i;
  }
  function $n(i, u, v) {
    return Ne(u, i.responseState, v.formatContext, v.id), hn(i, u, v), dt(u, v.formatContext);
  }
  function Bn(i, u, v) {
    for (var x = v.completedSegments, R = 0; R < x.length; R++) zn(i, u, v, x[R]);
    if (x.length = 0, i = i.responseState, x = v.id, v = v.rootSegmentID, u.push(i.startInlineScript), i.sentCompleteBoundaryFunction ? u.push('$RC("') : (i.sentCompleteBoundaryFunction = !0, u.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("')), x === null) throw Error(t(395));
    return v = v.toString(16), u.push(x), u.push('","'), u.push(i.segmentPrefix), u.push(v), u.push('")<\/script>');
  }
  function zn(i, u, v, x) {
    if (x.status === 2) return !0;
    var R = x.id;
    if (R === -1) {
      if ((x.id = v.rootSegmentID) === -1) throw Error(t(392));
      return $n(i, u, x);
    }
    return $n(i, u, x), i = i.responseState, u.push(i.startInlineScript), i.sentCompleteSegmentFunction ? u.push('$RS("') : (i.sentCompleteSegmentFunction = !0, u.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("')), u.push(i.segmentPrefix), R = R.toString(16), u.push(R), u.push('","'), u.push(i.placeholderPrefix), u.push(R), u.push('")<\/script>');
  }
  function An(i, u) {
    try {
      var v = i.completedRootSegment;
      if (v !== null && i.pendingRootTasks === 0) {
        hn(i, u, v), i.completedRootSegment = null;
        var x = i.responseState.bootstrapChunks;
        for (v = 0; v < x.length - 1; v++) u.push(x[v]);
        v < x.length && u.push(x[v]);
      }
      var R = i.clientRenderedBoundaries, T;
      for (T = 0; T < R.length; T++) {
        var P = R[T];
        x = u;
        var H = i.responseState, ee = P.id, ne = P.errorDigest, oe = P.errorMessage, Me = P.errorComponentStack;
        if (x.push(H.startInlineScript), H.sentClientRenderFunction ? x.push('$RX("') : (H.sentClientRenderFunction = !0, x.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("')), ee === null) throw Error(t(395));
        if (x.push(ee), x.push('"'), ne || oe || Me) {
          x.push(",");
          var _t = Be(ne || "");
          x.push(_t);
        }
        if (oe || Me) {
          x.push(",");
          var Et = Be(oe || "");
          x.push(Et);
        }
        if (Me) {
          x.push(",");
          var ht = Be(Me);
          x.push(ht);
        }
        if (!x.push(")<\/script>")) {
          i.destination = null, T++, R.splice(0, T);
          return;
        }
      }
      R.splice(0, T);
      var mn = i.completedBoundaries;
      for (T = 0; T < mn.length; T++) if (!Bn(i, u, mn[T])) {
        i.destination = null, T++, mn.splice(0, T);
        return;
      }
      mn.splice(0, T);
      var Bt = i.partialBoundaries;
      for (T = 0; T < Bt.length; T++) {
        var Vn = Bt[T];
        e: {
          R = i, P = u;
          var gn = Vn.completedSegments;
          for (H = 0; H < gn.length; H++) if (!zn(R, P, Vn, gn[H])) {
            H++, gn.splice(0, H);
            var cr = !1;
            break e;
          }
          gn.splice(0, H), cr = !0;
        }
        if (!cr) {
          i.destination = null, T++, Bt.splice(0, T);
          return;
        }
      }
      Bt.splice(0, T);
      var tn = i.completedBoundaries;
      for (T = 0; T < tn.length; T++) if (!Bn(i, u, tn[T])) {
        i.destination = null, T++, tn.splice(0, T);
        return;
      }
      tn.splice(0, T);
    } finally {
      i.allPendingTasks === 0 && i.pingedTasks.length === 0 && i.clientRenderedBoundaries.length === 0 && i.completedBoundaries.length === 0 && u.push(null);
    }
  }
  function ar(i, u) {
    try {
      var v = i.abortableTasks;
      v.forEach(function(x) {
        return fn(x, i, u);
      }), v.clear(), i.destination !== null && An(i, i.destination);
    } catch (x) {
      S(i, x), F(i, x);
    }
  }
  function lr() {
  }
  function Hn(i, u, v, x) {
    var R = !1, T = null, P = "", H = { push: function(ne) {
      return ne !== null && (P += ne), !0;
    }, destroy: function(ne) {
      R = !0, T = ne;
    } }, ee = !1;
    if (i = On(i, qe(v, u ? u.identifierPrefix : void 0), { insertionMode: 1, selectedValue: null }, 1 / 0, lr, void 0, function() {
      ee = !0;
    }), sr(i), ar(i, x), i.status === 1) i.status = 2, H.destroy(i.fatalError);
    else if (i.status !== 2 && i.destination === null) {
      i.destination = H;
      try {
        An(i, H);
      } catch (ne) {
        S(i, ne), F(i, ne);
      }
    }
    if (R) throw T;
    if (!ee) throw Error(t(426));
    return P;
  }
  return yn.renderToNodeStream = function() {
    throw Error(t(207));
  }, yn.renderToStaticMarkup = function(i, u) {
    return Hn(i, u, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, yn.renderToStaticNodeStream = function() {
    throw Error(t(208));
  }, yn.renderToString = function(i, u) {
    return Hn(i, u, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, yn.version = "18.3.1", yn;
}
var _r = {};
var Fo;
function hl() {
  if (Fo) return _r;
  Fo = 1;
  var e = He;
  function t(s) {
    for (var c = "https://reactjs.org/docs/error-decoder.html?invariant=" + s, g = 1; g < arguments.length; g++) c += "&args[]=" + encodeURIComponent(arguments[g]);
    return "Minified React error #" + s + "; visit " + c + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var n = null, r = 0;
  function o(s, c) {
    if (c.length !== 0) if (512 < c.length) 0 < r && (s.enqueue(new Uint8Array(n.buffer, 0, r)), n = new Uint8Array(512), r = 0), s.enqueue(c);
    else {
      var g = n.length - r;
      g < c.length && (g === 0 ? s.enqueue(n) : (n.set(c.subarray(0, g), r), s.enqueue(n), c = c.subarray(g)), n = new Uint8Array(512), r = 0), n.set(c, r), r += c.length;
    }
  }
  function a(s, c) {
    return o(s, c), !0;
  }
  function d(s) {
    n && 0 < r && (s.enqueue(new Uint8Array(n.buffer, 0, r)), n = null, r = 0);
  }
  var m = new TextEncoder();
  function h(s) {
    return m.encode(s);
  }
  function p(s) {
    return m.encode(s);
  }
  function b(s, c) {
    typeof s.error == "function" ? s.error(c) : s.close();
  }
  var w = Object.prototype.hasOwnProperty, C = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, L = {}, O = {};
  function k(s) {
    return w.call(O, s) ? !0 : w.call(L, s) ? !1 : C.test(s) ? O[s] = !0 : (L[s] = !0, !1);
  }
  function N(s, c, g, y, E, _, I) {
    this.acceptsBooleans = c === 2 || c === 3 || c === 4, this.attributeName = y, this.attributeNamespace = E, this.mustUseProperty = g, this.propertyName = s, this.type = c, this.sanitizeURL = _, this.removeEmptyString = I;
  }
  var j = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(s) {
    j[s] = new N(s, 0, !1, s, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(s) {
    var c = s[0];
    j[c] = new N(c, 1, !1, s[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(s) {
    j[s] = new N(s, 2, !1, s.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(s) {
    j[s] = new N(s, 2, !1, s, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(s) {
    j[s] = new N(s, 3, !1, s.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(s) {
    j[s] = new N(s, 3, !0, s, null, !1, !1);
  }), ["capture", "download"].forEach(function(s) {
    j[s] = new N(s, 4, !1, s, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(s) {
    j[s] = new N(s, 6, !1, s, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(s) {
    j[s] = new N(s, 5, !1, s.toLowerCase(), null, !1, !1);
  });
  var D = /[\-:]([a-z])/g;
  function V(s) {
    return s[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(s) {
    var c = s.replace(
      D,
      V
    );
    j[c] = new N(c, 1, !1, s, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(s) {
    var c = s.replace(D, V);
    j[c] = new N(c, 1, !1, s, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(s) {
    var c = s.replace(D, V);
    j[c] = new N(c, 1, !1, s, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(s) {
    j[s] = new N(s, 1, !1, s.toLowerCase(), null, !1, !1);
  }), j.xlinkHref = new N("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(s) {
    j[s] = new N(s, 1, !1, s.toLowerCase(), null, !0, !0);
  });
  var W = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, M = ["Webkit", "ms", "Moz", "O"];
  Object.keys(W).forEach(function(s) {
    M.forEach(function(c) {
      c = c + s.charAt(0).toUpperCase() + s.substring(1), W[c] = W[s];
    });
  });
  var J = /["'&<>]/;
  function se(s) {
    if (typeof s == "boolean" || typeof s == "number") return "" + s;
    s = "" + s;
    var c = J.exec(s);
    if (c) {
      var g = "", y, E = 0;
      for (y = c.index; y < s.length; y++) {
        switch (s.charCodeAt(y)) {
          case 34:
            c = "&quot;";
            break;
          case 38:
            c = "&amp;";
            break;
          case 39:
            c = "&#x27;";
            break;
          case 60:
            c = "&lt;";
            break;
          case 62:
            c = "&gt;";
            break;
          default:
            continue;
        }
        E !== y && (g += s.substring(E, y)), E = y + 1, g += c;
      }
      s = E !== y ? g + s.substring(E, y) : g;
    }
    return s;
  }
  var Oe = /([A-Z])/g, Fe = /^ms-/, Ve = Array.isArray, ke = p("<script>"), ve = p("<\/script>"), Q = p('<script src="'), he = p('<script type="module" src="'), Ne = p('" async=""><\/script>'), dt = /(<\/|<)(s)(cript)/gi;
  function $e(s, c, g, y) {
    return "" + c + (g === "s" ? "\\u0073" : "\\u0053") + y;
  }
  function Be(s, c, g, y, E) {
    s = s === void 0 ? "" : s, c = c === void 0 ? ke : p('<script nonce="' + se(c) + '">');
    var _ = [];
    if (g !== void 0 && _.push(c, h(("" + g).replace(dt, $e)), ve), y !== void 0) for (g = 0; g < y.length; g++) _.push(Q, h(se(y[g])), Ne);
    if (E !== void 0) for (y = 0; y < E.length; y++) _.push(he, h(se(E[y])), Ne);
    return { bootstrapChunks: _, startInlineScript: c, placeholderPrefix: p(s + "P:"), segmentPrefix: p(s + "S:"), boundaryPrefix: s + "B:", idPrefix: s, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1 };
  }
  function qe(s, c) {
    return { insertionMode: s, selectedValue: c };
  }
  function ft(s) {
    return qe(s === "http://www.w3.org/2000/svg" ? 2 : s === "http://www.w3.org/1998/Math/MathML" ? 3 : 0, null);
  }
  function be(s, c, g) {
    switch (c) {
      case "select":
        return qe(1, g.value != null ? g.value : g.defaultValue);
      case "svg":
        return qe(2, null);
      case "math":
        return qe(3, null);
      case "foreignObject":
        return qe(1, null);
      case "table":
        return qe(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return qe(5, null);
      case "colgroup":
        return qe(7, null);
      case "tr":
        return qe(6, null);
    }
    return 4 <= s.insertionMode || s.insertionMode === 0 ? qe(1, null) : s;
  }
  var Y = p("<!-- -->");
  function B(s, c, g, y) {
    return c === "" ? y : (y && s.push(Y), s.push(h(se(c))), !0);
  }
  var q = /* @__PURE__ */ new Map(), U = p(' style="'), A = p(":"), ue = p(";");
  function z(s, c, g) {
    if (typeof g != "object") throw Error(t(62));
    c = !0;
    for (var y in g) if (w.call(g, y)) {
      var E = g[y];
      if (E != null && typeof E != "boolean" && E !== "") {
        if (y.indexOf("--") === 0) {
          var _ = h(se(y));
          E = h(se(("" + E).trim()));
        } else {
          _ = y;
          var I = q.get(_);
          I !== void 0 || (I = p(se(_.replace(Oe, "-$1").toLowerCase().replace(Fe, "-ms-"))), q.set(_, I)), _ = I, E = typeof E == "number" ? E === 0 || w.call(W, y) ? h("" + E) : h(E + "px") : h(se(("" + E).trim()));
        }
        c ? (c = !1, s.push(U, _, A, E)) : s.push(ue, _, A, E);
      }
    }
    c || s.push(ie);
  }
  var pe = p(" "), re = p('="'), ie = p('"'), Z = p('=""');
  function de(s, c, g, y) {
    switch (g) {
      case "style":
        z(s, c, y);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < g.length) || g[0] !== "o" && g[0] !== "O" || g[1] !== "n" && g[1] !== "N") {
      if (c = j.hasOwnProperty(g) ? j[g] : null, c !== null) {
        switch (typeof y) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!c.acceptsBooleans) return;
        }
        switch (g = h(c.attributeName), c.type) {
          case 3:
            y && s.push(pe, g, Z);
            break;
          case 4:
            y === !0 ? s.push(pe, g, Z) : y !== !1 && s.push(pe, g, re, h(se(y)), ie);
            break;
          case 5:
            isNaN(y) || s.push(pe, g, re, h(se(y)), ie);
            break;
          case 6:
            !isNaN(y) && 1 <= y && s.push(pe, g, re, h(se(y)), ie);
            break;
          default:
            c.sanitizeURL && (y = "" + y), s.push(pe, g, re, h(se(y)), ie);
        }
      } else if (k(g)) {
        switch (typeof y) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (c = g.toLowerCase().slice(0, 5), c !== "data-" && c !== "aria-") return;
        }
        s.push(pe, h(g), re, h(se(y)), ie);
      }
    }
  }
  var ye = p(">"), ae = p("/>");
  function Ae(s, c, g) {
    if (c != null) {
      if (g != null) throw Error(t(60));
      if (typeof c != "object" || !("__html" in c)) throw Error(t(61));
      c = c.__html, c != null && s.push(h("" + c));
    }
  }
  function le(s) {
    var c = "";
    return e.Children.forEach(s, function(g) {
      g != null && (c += g);
    }), c;
  }
  var Ee = p(' selected=""');
  function Xe(s, c, g, y) {
    s.push(Se(g));
    var E = g = null, _;
    for (_ in c) if (w.call(c, _)) {
      var I = c[_];
      if (I != null) switch (_) {
        case "children":
          g = I;
          break;
        case "dangerouslySetInnerHTML":
          E = I;
          break;
        default:
          de(s, y, _, I);
      }
    }
    return s.push(ye), Ae(s, E, g), typeof g == "string" ? (s.push(h(se(g))), null) : g;
  }
  var je = p(`
`), vt = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Ge = /* @__PURE__ */ new Map();
  function Se(s) {
    var c = Ge.get(s);
    if (c === void 0) {
      if (!vt.test(s)) throw Error(t(65, s));
      c = p("<" + s), Ge.set(s, c);
    }
    return c;
  }
  var K = p("<!DOCTYPE html>");
  function xe(s, c, g, y, E) {
    switch (c) {
      case "select":
        s.push(Se("select"));
        var _ = null, I = null;
        for (ce in g) if (w.call(g, ce)) {
          var $ = g[ce];
          if ($ != null) switch (ce) {
            case "children":
              _ = $;
              break;
            case "dangerouslySetInnerHTML":
              I = $;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              de(s, y, ce, $);
          }
        }
        return s.push(ye), Ae(s, I, _), _;
      case "option":
        I = E.selectedValue, s.push(Se("option"));
        var te = $ = null, fe = null, ce = null;
        for (_ in g) if (w.call(g, _)) {
          var Le = g[_];
          if (Le != null) switch (_) {
            case "children":
              $ = Le;
              break;
            case "selected":
              fe = Le;
              break;
            case "dangerouslySetInnerHTML":
              ce = Le;
              break;
            case "value":
              te = Le;
            default:
              de(s, y, _, Le);
          }
        }
        if (I != null) if (g = te !== null ? "" + te : le($), Ve(I)) {
          for (y = 0; y < I.length; y++)
            if ("" + I[y] === g) {
              s.push(Ee);
              break;
            }
        } else "" + I === g && s.push(Ee);
        else fe && s.push(Ee);
        return s.push(ye), Ae(s, ce, $), $;
      case "textarea":
        s.push(Se("textarea")), ce = I = _ = null;
        for ($ in g) if (w.call(g, $) && (te = g[$], te != null)) switch ($) {
          case "children":
            ce = te;
            break;
          case "value":
            _ = te;
            break;
          case "defaultValue":
            I = te;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(91));
          default:
            de(s, y, $, te);
        }
        if (_ === null && I !== null && (_ = I), s.push(ye), ce != null) {
          if (_ != null) throw Error(t(92));
          if (Ve(ce) && 1 < ce.length) throw Error(t(93));
          _ = "" + ce;
        }
        return typeof _ == "string" && _[0] === `
` && s.push(je), _ !== null && s.push(h(se("" + _))), null;
      case "input":
        s.push(Se("input")), te = ce = $ = _ = null;
        for (I in g) if (w.call(g, I) && (fe = g[I], fe != null)) switch (I) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, "input"));
          case "defaultChecked":
            te = fe;
            break;
          case "defaultValue":
            $ = fe;
            break;
          case "checked":
            ce = fe;
            break;
          case "value":
            _ = fe;
            break;
          default:
            de(s, y, I, fe);
        }
        return ce !== null ? de(
          s,
          y,
          "checked",
          ce
        ) : te !== null && de(s, y, "checked", te), _ !== null ? de(s, y, "value", _) : $ !== null && de(s, y, "value", $), s.push(ae), null;
      case "menuitem":
        s.push(Se("menuitem"));
        for (var gt in g) if (w.call(g, gt) && (_ = g[gt], _ != null)) switch (gt) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(400));
          default:
            de(s, y, gt, _);
        }
        return s.push(ye), null;
      case "title":
        s.push(Se("title")), _ = null;
        for (Le in g) if (w.call(g, Le) && (I = g[Le], I != null)) switch (Le) {
          case "children":
            _ = I;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(434));
          default:
            de(s, y, Le, I);
        }
        return s.push(ye), _;
      case "listing":
      case "pre":
        s.push(Se(c)), I = _ = null;
        for (te in g) if (w.call(g, te) && ($ = g[te], $ != null)) switch (te) {
          case "children":
            _ = $;
            break;
          case "dangerouslySetInnerHTML":
            I = $;
            break;
          default:
            de(s, y, te, $);
        }
        if (s.push(ye), I != null) {
          if (_ != null) throw Error(t(60));
          if (typeof I != "object" || !("__html" in I)) throw Error(t(61));
          g = I.__html, g != null && (typeof g == "string" && 0 < g.length && g[0] === `
` ? s.push(je, h(g)) : s.push(h("" + g)));
        }
        return typeof _ == "string" && _[0] === `
` && s.push(je), _;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        s.push(Se(c));
        for (var Ct in g) if (w.call(g, Ct) && (_ = g[Ct], _ != null)) switch (Ct) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, c));
          default:
            de(s, y, Ct, _);
        }
        return s.push(ae), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return Xe(s, g, c, y);
      case "html":
        return E.insertionMode === 0 && s.push(K), Xe(s, g, c, y);
      default:
        if (c.indexOf("-") === -1 && typeof g.is != "string") return Xe(s, g, c, y);
        s.push(Se(c)), I = _ = null;
        for (fe in g) if (w.call(g, fe) && ($ = g[fe], $ != null)) switch (fe) {
          case "children":
            _ = $;
            break;
          case "dangerouslySetInnerHTML":
            I = $;
            break;
          case "style":
            z(s, y, $);
            break;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;
          default:
            k(fe) && typeof $ != "function" && typeof $ != "symbol" && s.push(pe, h(fe), re, h(se($)), ie);
        }
        return s.push(ye), Ae(s, I, _), _;
    }
  }
  var it = p("</"), wt = p(">"), Ke = p('<template id="'), an = p('"></template>'), qt = p("<!--$-->"), Tn = p('<!--$?--><template id="'), Nt = p('"></template>'), St = p("<!--$!-->"), pt = p("<!--/$-->"), Pt = p("<template"), ln = p('"'), cn = p(' data-dgst="');
  p(' data-msg="'), p(' data-stck="');
  var Fn = p("></template>");
  function Je(s, c, g) {
    if (o(s, Tn), g === null) throw Error(t(395));
    return o(s, g), a(s, Nt);
  }
  var It = p('<div hidden id="'), Yt = p('">'), ge = p("</div>"), Ft = p('<svg aria-hidden="true" style="display:none" id="'), Xt = p('">'), Pe = p("</svg>"), Qe = p('<math aria-hidden="true" style="display:none" id="'), Gt = p('">'), yt = p("</math>"), Kt = p('<table hidden id="'), Zt = p('">'), Jt = p("</table>"), _n = p('<table hidden><tbody id="'), ot = p('">'), $t = p("</tbody></table>"), En = p('<table hidden><tr id="'), Cn = p('">'), Lt = p("</tr></table>"), un = p('<table hidden><colgroup id="'), nt = p('">'), Qt = p("</colgroup></table>");
  function Rn(s, c, g, y) {
    switch (g.insertionMode) {
      case 0:
      case 1:
        return o(s, It), o(s, c.segmentPrefix), o(s, h(y.toString(16))), a(s, Yt);
      case 2:
        return o(s, Ft), o(s, c.segmentPrefix), o(s, h(y.toString(16))), a(s, Xt);
      case 3:
        return o(s, Qe), o(s, c.segmentPrefix), o(s, h(y.toString(16))), a(s, Gt);
      case 4:
        return o(s, Kt), o(s, c.segmentPrefix), o(s, h(y.toString(16))), a(s, Zt);
      case 5:
        return o(s, _n), o(s, c.segmentPrefix), o(s, h(y.toString(16))), a(s, ot);
      case 6:
        return o(s, En), o(s, c.segmentPrefix), o(s, h(y.toString(16))), a(s, Cn);
      case 7:
        return o(
          s,
          un
        ), o(s, c.segmentPrefix), o(s, h(y.toString(16))), a(s, nt);
      default:
        throw Error(t(397));
    }
  }
  function Mt(s, c) {
    switch (c.insertionMode) {
      case 0:
      case 1:
        return a(s, ge);
      case 2:
        return a(s, Pe);
      case 3:
        return a(s, yt);
      case 4:
        return a(s, Jt);
      case 5:
        return a(s, $t);
      case 6:
        return a(s, Lt);
      case 7:
        return a(s, Qt);
      default:
        throw Error(t(397));
    }
  }
  var On = p('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), dn = p('$RS("'), G = p('","'), S = p('")<\/script>'), F = p('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), X = p('$RC("'), Ce = p('","'), We = p('")<\/script>'), ze = p('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), Te = p('$RX("'), st = p('"'), kt = p(")<\/script>"), Ue = p(","), fn = /[<\u2028\u2029]/g;
  function Tt(s) {
    return JSON.stringify(s).replace(fn, function(c) {
      switch (c) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  var en = Object.assign, sr = Symbol.for("react.element"), pn = Symbol.for("react.portal"), hn = Symbol.for("react.fragment"), $n = Symbol.for("react.strict_mode"), Bn = Symbol.for("react.profiler"), zn = Symbol.for("react.provider"), An = Symbol.for("react.context"), ar = Symbol.for("react.forward_ref"), lr = Symbol.for("react.suspense"), Hn = Symbol.for("react.suspense_list"), i = Symbol.for("react.memo"), u = Symbol.for("react.lazy"), v = Symbol.for("react.scope"), x = Symbol.for("react.debug_trace_mode"), R = Symbol.for("react.legacy_hidden"), T = Symbol.for("react.default_value"), P = Symbol.iterator;
  function H(s) {
    if (s == null) return null;
    if (typeof s == "function") return s.displayName || s.name || null;
    if (typeof s == "string") return s;
    switch (s) {
      case hn:
        return "Fragment";
      case pn:
        return "Portal";
      case Bn:
        return "Profiler";
      case $n:
        return "StrictMode";
      case lr:
        return "Suspense";
      case Hn:
        return "SuspenseList";
    }
    if (typeof s == "object") switch (s.$$typeof) {
      case An:
        return (s.displayName || "Context") + ".Consumer";
      case zn:
        return (s._context.displayName || "Context") + ".Provider";
      case ar:
        var c = s.render;
        return s = s.displayName, s || (s = c.displayName || c.name || "", s = s !== "" ? "ForwardRef(" + s + ")" : "ForwardRef"), s;
      case i:
        return c = s.displayName || null, c !== null ? c : H(s.type) || "Memo";
      case u:
        c = s._payload, s = s._init;
        try {
          return H(s(c));
        } catch {
        }
    }
    return null;
  }
  var ee = {};
  function ne(s, c) {
    if (s = s.contextTypes, !s) return ee;
    var g = {}, y;
    for (y in s) g[y] = c[y];
    return g;
  }
  var oe = null;
  function Me(s, c) {
    if (s !== c) {
      s.context._currentValue = s.parentValue, s = s.parent;
      var g = c.parent;
      if (s === null) {
        if (g !== null) throw Error(t(401));
      } else {
        if (g === null) throw Error(t(401));
        Me(s, g);
      }
      c.context._currentValue = c.value;
    }
  }
  function _t(s) {
    s.context._currentValue = s.parentValue, s = s.parent, s !== null && _t(s);
  }
  function Et(s) {
    var c = s.parent;
    c !== null && Et(c), s.context._currentValue = s.value;
  }
  function ht(s, c) {
    if (s.context._currentValue = s.parentValue, s = s.parent, s === null) throw Error(t(402));
    s.depth === c.depth ? Me(s, c) : ht(s, c);
  }
  function mn(s, c) {
    var g = c.parent;
    if (g === null) throw Error(t(402));
    s.depth === g.depth ? Me(s, g) : mn(s, g), c.context._currentValue = c.value;
  }
  function Bt(s) {
    var c = oe;
    c !== s && (c === null ? Et(s) : s === null ? _t(c) : c.depth === s.depth ? Me(c, s) : c.depth > s.depth ? ht(c, s) : mn(c, s), oe = s);
  }
  var Vn = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(s, c) {
    s = s._reactInternals, s.queue !== null && s.queue.push(c);
  }, enqueueReplaceState: function(s, c) {
    s = s._reactInternals, s.replace = !0, s.queue = [c];
  }, enqueueForceUpdate: function() {
  } };
  function gn(s, c, g, y) {
    var E = s.state !== void 0 ? s.state : null;
    s.updater = Vn, s.props = g, s.state = E;
    var _ = { queue: [], replace: !1 };
    s._reactInternals = _;
    var I = c.contextType;
    if (s.context = typeof I == "object" && I !== null ? I._currentValue : y, I = c.getDerivedStateFromProps, typeof I == "function" && (I = I(g, E), E = I == null ? E : en({}, E, I), s.state = E), typeof c.getDerivedStateFromProps != "function" && typeof s.getSnapshotBeforeUpdate != "function" && (typeof s.UNSAFE_componentWillMount == "function" || typeof s.componentWillMount == "function")) if (c = s.state, typeof s.componentWillMount == "function" && s.componentWillMount(), typeof s.UNSAFE_componentWillMount == "function" && s.UNSAFE_componentWillMount(), c !== s.state && Vn.enqueueReplaceState(s, s.state, null), _.queue !== null && 0 < _.queue.length) if (c = _.queue, I = _.replace, _.queue = null, _.replace = !1, I && c.length === 1) s.state = c[0];
    else {
      for (_ = I ? c[0] : s.state, E = !0, I = I ? 1 : 0; I < c.length; I++) {
        var $ = c[I];
        $ = typeof $ == "function" ? $.call(s, _, g, y) : $, $ != null && (E ? (E = !1, _ = en({}, _, $)) : en(_, $));
      }
      s.state = _;
    }
    else _.queue = null;
  }
  var cr = { id: 1, overflow: "" };
  function tn(s, c, g) {
    var y = s.id;
    s = s.overflow;
    var E = 32 - ur(y) - 1;
    y &= ~(1 << E), g += 1;
    var _ = 32 - ur(c) + E;
    if (30 < _) {
      var I = E - E % 5;
      return _ = (y & (1 << I) - 1).toString(32), y >>= I, E -= I, { id: 1 << 32 - ur(c) + E | g << E | y, overflow: _ + s };
    }
    return { id: 1 << _ | g << E | y, overflow: s };
  }
  var ur = Math.clz32 ? Math.clz32 : Sa, ba = Math.log, wa = Math.LN2;
  function Sa(s) {
    return s >>>= 0, s === 0 ? 32 : 31 - (ba(s) / wa | 0) | 0;
  }
  function ka(s, c) {
    return s === c && (s !== 0 || 1 / s === 1 / c) || s !== s && c !== c;
  }
  var Ta = typeof Object.is == "function" ? Object.is : ka, zt = null, Kr = null, dr = null, Ie = null, Wn = !1, fr = !1, Un = 0, nn = null, pr = 0;
  function vn() {
    if (zt === null) throw Error(t(321));
    return zt;
  }
  function ro() {
    if (0 < pr) throw Error(t(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function Zr() {
    return Ie === null ? dr === null ? (Wn = !1, dr = Ie = ro()) : (Wn = !0, Ie = dr) : Ie.next === null ? (Wn = !1, Ie = Ie.next = ro()) : (Wn = !0, Ie = Ie.next), Ie;
  }
  function Jr() {
    Kr = zt = null, fr = !1, dr = null, pr = 0, Ie = nn = null;
  }
  function io(s, c) {
    return typeof c == "function" ? c(s) : c;
  }
  function oo(s, c, g) {
    if (zt = vn(), Ie = Zr(), Wn) {
      var y = Ie.queue;
      if (c = y.dispatch, nn !== null && (g = nn.get(y), g !== void 0)) {
        nn.delete(y), y = Ie.memoizedState;
        do
          y = s(y, g.action), g = g.next;
        while (g !== null);
        return Ie.memoizedState = y, [y, c];
      }
      return [Ie.memoizedState, c];
    }
    return s = s === io ? typeof c == "function" ? c() : c : g !== void 0 ? g(c) : c, Ie.memoizedState = s, s = Ie.queue = { last: null, dispatch: null }, s = s.dispatch = _a.bind(null, zt, s), [Ie.memoizedState, s];
  }
  function so(s, c) {
    if (zt = vn(), Ie = Zr(), c = c === void 0 ? null : c, Ie !== null) {
      var g = Ie.memoizedState;
      if (g !== null && c !== null) {
        var y = g[1];
        e: if (y === null) y = !1;
        else {
          for (var E = 0; E < y.length && E < c.length; E++) if (!Ta(c[E], y[E])) {
            y = !1;
            break e;
          }
          y = !0;
        }
        if (y) return g[0];
      }
    }
    return s = s(), Ie.memoizedState = [s, c], s;
  }
  function _a(s, c, g) {
    if (25 <= pr) throw Error(t(301));
    if (s === zt) if (fr = !0, s = { action: g, next: null }, nn === null && (nn = /* @__PURE__ */ new Map()), g = nn.get(c), g === void 0) nn.set(c, s);
    else {
      for (c = g; c.next !== null; ) c = c.next;
      c.next = s;
    }
  }
  function Ea() {
    throw Error(t(394));
  }
  function hr() {
  }
  var ao = { readContext: function(s) {
    return s._currentValue;
  }, useContext: function(s) {
    return vn(), s._currentValue;
  }, useMemo: so, useReducer: oo, useRef: function(s) {
    zt = vn(), Ie = Zr();
    var c = Ie.memoizedState;
    return c === null ? (s = { current: s }, Ie.memoizedState = s) : c;
  }, useState: function(s) {
    return oo(io, s);
  }, useInsertionEffect: hr, useLayoutEffect: function() {
  }, useCallback: function(s, c) {
    return so(function() {
      return s;
    }, c);
  }, useImperativeHandle: hr, useEffect: hr, useDebugValue: hr, useDeferredValue: function(s) {
    return vn(), s;
  }, useTransition: function() {
    return vn(), [!1, Ea];
  }, useId: function() {
    var s = Kr.treeContext, c = s.overflow;
    s = s.id, s = (s & ~(1 << 32 - ur(s) - 1)).toString(32) + c;
    var g = mr;
    if (g === null) throw Error(t(404));
    return c = Un++, s = ":" + g.idPrefix + "R" + s, 0 < c && (s += "H" + c.toString(32)), s + ":";
  }, useMutableSource: function(s, c) {
    return vn(), c(s._source);
  }, useSyncExternalStore: function(s, c, g) {
    if (g === void 0) throw Error(t(407));
    return g();
  } }, mr = null, Qr = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function Ca(s) {
    return console.error(s), null;
  }
  function qn() {
  }
  function Ra(s, c, g, y, E, _, I, $, te) {
    var fe = [], ce = /* @__PURE__ */ new Set();
    return c = { destination: null, responseState: c, progressiveChunkSize: y === void 0 ? 12800 : y, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: ce, pingedTasks: fe, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: E === void 0 ? Ca : E, onAllReady: _ === void 0 ? qn : _, onShellReady: I === void 0 ? qn : I, onShellError: $ === void 0 ? qn : $, onFatalError: te === void 0 ? qn : te }, g = gr(c, 0, null, g, !1, !1), g.parentFlushed = !0, s = ei(c, s, null, g, ce, ee, null, cr), fe.push(s), c;
  }
  function ei(s, c, g, y, E, _, I, $) {
    s.allPendingTasks++, g === null ? s.pendingRootTasks++ : g.pendingTasks++;
    var te = { node: c, ping: function() {
      var fe = s.pingedTasks;
      fe.push(te), fe.length === 1 && mo(s);
    }, blockedBoundary: g, blockedSegment: y, abortSet: E, legacyContext: _, context: I, treeContext: $ };
    return E.add(te), te;
  }
  function gr(s, c, g, y, E, _) {
    return { status: 0, id: -1, index: c, parentFlushed: !1, chunks: [], children: [], formatContext: y, boundary: g, lastPushedText: E, textEmbedded: _ };
  }
  function Yn(s, c) {
    if (s = s.onError(c), s != null && typeof s != "string") throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof s + '" instead');
    return s;
  }
  function vr(s, c) {
    var g = s.onShellError;
    g(c), g = s.onFatalError, g(c), s.destination !== null ? (s.status = 2, b(s.destination, c)) : (s.status = 1, s.fatalError = c);
  }
  function lo(s, c, g, y, E) {
    for (zt = {}, Kr = c, Un = 0, s = g(y, E); fr; ) fr = !1, Un = 0, pr += 1, Ie = null, s = g(y, E);
    return Jr(), s;
  }
  function co(s, c, g, y) {
    var E = g.render(), _ = y.childContextTypes;
    if (_ != null) {
      var I = c.legacyContext;
      if (typeof g.getChildContext != "function") y = I;
      else {
        g = g.getChildContext();
        for (var $ in g) if (!($ in _)) throw Error(t(108, H(y) || "Unknown", $));
        y = en({}, I, g);
      }
      c.legacyContext = y, mt(s, c, E), c.legacyContext = I;
    } else mt(s, c, E);
  }
  function uo(s, c) {
    if (s && s.defaultProps) {
      c = en({}, c), s = s.defaultProps;
      for (var g in s) c[g] === void 0 && (c[g] = s[g]);
      return c;
    }
    return c;
  }
  function ti(s, c, g, y, E) {
    if (typeof g == "function") if (g.prototype && g.prototype.isReactComponent) {
      E = ne(g, c.legacyContext);
      var _ = g.contextType;
      _ = new g(y, typeof _ == "object" && _ !== null ? _._currentValue : E), gn(_, g, y, E), co(s, c, _, g);
    } else {
      _ = ne(g, c.legacyContext), E = lo(s, c, g, y, _);
      var I = Un !== 0;
      if (typeof E == "object" && E !== null && typeof E.render == "function" && E.$$typeof === void 0) gn(E, g, y, _), co(s, c, E, g);
      else if (I) {
        y = c.treeContext, c.treeContext = tn(y, 1, 0);
        try {
          mt(s, c, E);
        } finally {
          c.treeContext = y;
        }
      } else mt(s, c, E);
    }
    else if (typeof g == "string") {
      switch (E = c.blockedSegment, _ = xe(E.chunks, g, y, s.responseState, E.formatContext), E.lastPushedText = !1, I = E.formatContext, E.formatContext = be(I, g, y), ni(s, c, _), E.formatContext = I, g) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          E.chunks.push(it, h(g), wt);
      }
      E.lastPushedText = !1;
    } else {
      switch (g) {
        case R:
        case x:
        case $n:
        case Bn:
        case hn:
          mt(s, c, y.children);
          return;
        case Hn:
          mt(s, c, y.children);
          return;
        case v:
          throw Error(t(343));
        case lr:
          e: {
            g = c.blockedBoundary, E = c.blockedSegment, _ = y.fallback, y = y.children, I = /* @__PURE__ */ new Set();
            var $ = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: I, errorDigest: null }, te = gr(s, E.chunks.length, $, E.formatContext, !1, !1);
            E.children.push(te), E.lastPushedText = !1;
            var fe = gr(s, 0, null, E.formatContext, !1, !1);
            fe.parentFlushed = !0, c.blockedBoundary = $, c.blockedSegment = fe;
            try {
              if (ni(
                s,
                c,
                y
              ), fe.lastPushedText && fe.textEmbedded && fe.chunks.push(Y), fe.status = 1, yr($, fe), $.pendingTasks === 0) break e;
            } catch (ce) {
              fe.status = 4, $.forceClientRender = !0, $.errorDigest = Yn(s, ce);
            } finally {
              c.blockedBoundary = g, c.blockedSegment = E;
            }
            c = ei(s, _, g, te, I, c.legacyContext, c.context, c.treeContext), s.pingedTasks.push(c);
          }
          return;
      }
      if (typeof g == "object" && g !== null) switch (g.$$typeof) {
        case ar:
          if (y = lo(s, c, g.render, y, E), Un !== 0) {
            g = c.treeContext, c.treeContext = tn(g, 1, 0);
            try {
              mt(s, c, y);
            } finally {
              c.treeContext = g;
            }
          } else mt(s, c, y);
          return;
        case i:
          g = g.type, y = uo(g, y), ti(s, c, g, y, E);
          return;
        case zn:
          if (E = y.children, g = g._context, y = y.value, _ = g._currentValue, g._currentValue = y, I = oe, oe = y = { parent: I, depth: I === null ? 0 : I.depth + 1, context: g, parentValue: _, value: y }, c.context = y, mt(s, c, E), s = oe, s === null) throw Error(t(403));
          y = s.parentValue, s.context._currentValue = y === T ? s.context._defaultValue : y, s = oe = s.parent, c.context = s;
          return;
        case An:
          y = y.children, y = y(g._currentValue), mt(s, c, y);
          return;
        case u:
          E = g._init, g = E(g._payload), y = uo(g, y), ti(s, c, g, y, void 0);
          return;
      }
      throw Error(t(
        130,
        g == null ? g : typeof g,
        ""
      ));
    }
  }
  function mt(s, c, g) {
    if (c.node = g, typeof g == "object" && g !== null) {
      switch (g.$$typeof) {
        case sr:
          ti(s, c, g.type, g.props, g.ref);
          return;
        case pn:
          throw Error(t(257));
        case u:
          var y = g._init;
          g = y(g._payload), mt(s, c, g);
          return;
      }
      if (Ve(g)) {
        fo(s, c, g);
        return;
      }
      if (g === null || typeof g != "object" ? y = null : (y = P && g[P] || g["@@iterator"], y = typeof y == "function" ? y : null), y && (y = y.call(g))) {
        if (g = y.next(), !g.done) {
          var E = [];
          do
            E.push(g.value), g = y.next();
          while (!g.done);
          fo(s, c, E);
        }
        return;
      }
      throw s = Object.prototype.toString.call(g), Error(t(31, s === "[object Object]" ? "object with keys {" + Object.keys(g).join(", ") + "}" : s));
    }
    typeof g == "string" ? (y = c.blockedSegment, y.lastPushedText = B(c.blockedSegment.chunks, g, s.responseState, y.lastPushedText)) : typeof g == "number" && (y = c.blockedSegment, y.lastPushedText = B(c.blockedSegment.chunks, "" + g, s.responseState, y.lastPushedText));
  }
  function fo(s, c, g) {
    for (var y = g.length, E = 0; E < y; E++) {
      var _ = c.treeContext;
      c.treeContext = tn(_, y, E);
      try {
        ni(s, c, g[E]);
      } finally {
        c.treeContext = _;
      }
    }
  }
  function ni(s, c, g) {
    var y = c.blockedSegment.formatContext, E = c.legacyContext, _ = c.context;
    try {
      return mt(s, c, g);
    } catch (te) {
      if (Jr(), typeof te == "object" && te !== null && typeof te.then == "function") {
        g = te;
        var I = c.blockedSegment, $ = gr(s, I.chunks.length, null, I.formatContext, I.lastPushedText, !0);
        I.children.push($), I.lastPushedText = !1, s = ei(s, c.node, c.blockedBoundary, $, c.abortSet, c.legacyContext, c.context, c.treeContext).ping, g.then(s, s), c.blockedSegment.formatContext = y, c.legacyContext = E, c.context = _, Bt(_);
      } else throw c.blockedSegment.formatContext = y, c.legacyContext = E, c.context = _, Bt(_), te;
    }
  }
  function Oa(s) {
    var c = s.blockedBoundary;
    s = s.blockedSegment, s.status = 3, ho(this, c, s);
  }
  function po(s, c, g) {
    var y = s.blockedBoundary;
    s.blockedSegment.status = 3, y === null ? (c.allPendingTasks--, c.status !== 2 && (c.status = 2, c.destination !== null && c.destination.close())) : (y.pendingTasks--, y.forceClientRender || (y.forceClientRender = !0, s = g === void 0 ? Error(t(432)) : g, y.errorDigest = c.onError(s), y.parentFlushed && c.clientRenderedBoundaries.push(y)), y.fallbackAbortableTasks.forEach(function(E) {
      return po(E, c, g);
    }), y.fallbackAbortableTasks.clear(), c.allPendingTasks--, c.allPendingTasks === 0 && (y = c.onAllReady, y()));
  }
  function yr(s, c) {
    if (c.chunks.length === 0 && c.children.length === 1 && c.children[0].boundary === null) {
      var g = c.children[0];
      g.id = c.id, g.parentFlushed = !0, g.status === 1 && yr(s, g);
    } else s.completedSegments.push(c);
  }
  function ho(s, c, g) {
    if (c === null) {
      if (g.parentFlushed) {
        if (s.completedRootSegment !== null) throw Error(t(389));
        s.completedRootSegment = g;
      }
      s.pendingRootTasks--, s.pendingRootTasks === 0 && (s.onShellError = qn, c = s.onShellReady, c());
    } else c.pendingTasks--, c.forceClientRender || (c.pendingTasks === 0 ? (g.parentFlushed && g.status === 1 && yr(c, g), c.parentFlushed && s.completedBoundaries.push(c), c.fallbackAbortableTasks.forEach(Oa, s), c.fallbackAbortableTasks.clear()) : g.parentFlushed && g.status === 1 && (yr(c, g), c.completedSegments.length === 1 && c.parentFlushed && s.partialBoundaries.push(c)));
    s.allPendingTasks--, s.allPendingTasks === 0 && (s = s.onAllReady, s());
  }
  function mo(s) {
    if (s.status !== 2) {
      var c = oe, g = Qr.current;
      Qr.current = ao;
      var y = mr;
      mr = s.responseState;
      try {
        var E = s.pingedTasks, _;
        for (_ = 0; _ < E.length; _++) {
          var I = E[_], $ = s, te = I.blockedSegment;
          if (te.status === 0) {
            Bt(I.context);
            try {
              mt($, I, I.node), te.lastPushedText && te.textEmbedded && te.chunks.push(Y), I.abortSet.delete(I), te.status = 1, ho($, I.blockedBoundary, te);
            } catch (Rt) {
              if (Jr(), typeof Rt == "object" && Rt !== null && typeof Rt.then == "function") {
                var fe = I.ping;
                Rt.then(fe, fe);
              } else {
                I.abortSet.delete(I), te.status = 4;
                var ce = I.blockedBoundary, Le = Rt, gt = Yn($, Le);
                if (ce === null ? vr($, Le) : (ce.pendingTasks--, ce.forceClientRender || (ce.forceClientRender = !0, ce.errorDigest = gt, ce.parentFlushed && $.clientRenderedBoundaries.push(ce))), $.allPendingTasks--, $.allPendingTasks === 0) {
                  var Ct = $.onAllReady;
                  Ct();
                }
              }
            } finally {
            }
          }
        }
        E.splice(0, _), s.destination !== null && ri(s, s.destination);
      } catch (Rt) {
        Yn(s, Rt), vr(s, Rt);
      } finally {
        mr = y, Qr.current = g, g === ao && Bt(c);
      }
    }
  }
  function xr(s, c, g) {
    switch (g.parentFlushed = !0, g.status) {
      case 0:
        var y = g.id = s.nextSegmentId++;
        return g.lastPushedText = !1, g.textEmbedded = !1, s = s.responseState, o(c, Ke), o(c, s.placeholderPrefix), s = h(y.toString(16)), o(c, s), a(c, an);
      case 1:
        g.status = 2;
        var E = !0;
        y = g.chunks;
        var _ = 0;
        g = g.children;
        for (var I = 0; I < g.length; I++) {
          for (E = g[I]; _ < E.index; _++) o(c, y[_]);
          E = br(s, c, E);
        }
        for (; _ < y.length - 1; _++) o(c, y[_]);
        return _ < y.length && (E = a(c, y[_])), E;
      default:
        throw Error(t(390));
    }
  }
  function br(s, c, g) {
    var y = g.boundary;
    if (y === null) return xr(s, c, g);
    if (y.parentFlushed = !0, y.forceClientRender) y = y.errorDigest, a(c, St), o(c, Pt), y && (o(c, cn), o(c, h(se(y))), o(c, ln)), a(c, Fn), xr(s, c, g);
    else if (0 < y.pendingTasks) {
      y.rootSegmentID = s.nextSegmentId++, 0 < y.completedSegments.length && s.partialBoundaries.push(y);
      var E = s.responseState, _ = E.nextSuspenseID++;
      E = p(E.boundaryPrefix + _.toString(16)), y = y.id = E, Je(c, s.responseState, y), xr(s, c, g);
    } else if (y.byteSize > s.progressiveChunkSize) y.rootSegmentID = s.nextSegmentId++, s.completedBoundaries.push(y), Je(c, s.responseState, y.id), xr(s, c, g);
    else {
      if (a(c, qt), g = y.completedSegments, g.length !== 1) throw Error(t(391));
      br(s, c, g[0]);
    }
    return a(c, pt);
  }
  function go(s, c, g) {
    return Rn(c, s.responseState, g.formatContext, g.id), br(s, c, g), Mt(c, g.formatContext);
  }
  function vo(s, c, g) {
    for (var y = g.completedSegments, E = 0; E < y.length; E++) yo(s, c, g, y[E]);
    if (y.length = 0, s = s.responseState, y = g.id, g = g.rootSegmentID, o(c, s.startInlineScript), s.sentCompleteBoundaryFunction ? o(c, X) : (s.sentCompleteBoundaryFunction = !0, o(c, F)), y === null) throw Error(t(395));
    return g = h(g.toString(16)), o(c, y), o(c, Ce), o(c, s.segmentPrefix), o(c, g), a(c, We);
  }
  function yo(s, c, g, y) {
    if (y.status === 2) return !0;
    var E = y.id;
    if (E === -1) {
      if ((y.id = g.rootSegmentID) === -1) throw Error(t(392));
      return go(s, c, y);
    }
    return go(s, c, y), s = s.responseState, o(c, s.startInlineScript), s.sentCompleteSegmentFunction ? o(c, dn) : (s.sentCompleteSegmentFunction = !0, o(c, On)), o(c, s.segmentPrefix), E = h(E.toString(16)), o(c, E), o(c, G), o(c, s.placeholderPrefix), o(c, E), a(c, S);
  }
  function ri(s, c) {
    n = new Uint8Array(512), r = 0;
    try {
      var g = s.completedRootSegment;
      if (g !== null && s.pendingRootTasks === 0) {
        br(s, c, g), s.completedRootSegment = null;
        var y = s.responseState.bootstrapChunks;
        for (g = 0; g < y.length - 1; g++) o(c, y[g]);
        g < y.length && a(c, y[g]);
      }
      var E = s.clientRenderedBoundaries, _;
      for (_ = 0; _ < E.length; _++) {
        var I = E[_];
        y = c;
        var $ = s.responseState, te = I.id, fe = I.errorDigest, ce = I.errorMessage, Le = I.errorComponentStack;
        if (o(y, $.startInlineScript), $.sentClientRenderFunction ? o(y, Te) : ($.sentClientRenderFunction = !0, o(
          y,
          ze
        )), te === null) throw Error(t(395));
        o(y, te), o(y, st), (fe || ce || Le) && (o(y, Ue), o(y, h(Tt(fe || "")))), (ce || Le) && (o(y, Ue), o(y, h(Tt(ce || "")))), Le && (o(y, Ue), o(y, h(Tt(Le)))), a(y, kt);
      }
      E.splice(0, _);
      var gt = s.completedBoundaries;
      for (_ = 0; _ < gt.length; _++) vo(s, c, gt[_]);
      gt.splice(0, _), d(c), n = new Uint8Array(512), r = 0;
      var Ct = s.partialBoundaries;
      for (_ = 0; _ < Ct.length; _++) {
        var Rt = Ct[_];
        e: {
          E = s, I = c;
          var wr = Rt.completedSegments;
          for ($ = 0; $ < wr.length; $++) if (!yo(
            E,
            I,
            Rt,
            wr[$]
          )) {
            $++, wr.splice(0, $);
            var bo = !1;
            break e;
          }
          wr.splice(0, $), bo = !0;
        }
        if (!bo) {
          s.destination = null, _++, Ct.splice(0, _);
          return;
        }
      }
      Ct.splice(0, _);
      var ii = s.completedBoundaries;
      for (_ = 0; _ < ii.length; _++) vo(s, c, ii[_]);
      ii.splice(0, _);
    } finally {
      d(c), s.allPendingTasks === 0 && s.pingedTasks.length === 0 && s.clientRenderedBoundaries.length === 0 && s.completedBoundaries.length === 0 && c.close();
    }
  }
  function xo(s, c) {
    try {
      var g = s.abortableTasks;
      g.forEach(function(y) {
        return po(y, s, c);
      }), g.clear(), s.destination !== null && ri(s, s.destination);
    } catch (y) {
      Yn(s, y), vr(s, y);
    }
  }
  return _r.renderToReadableStream = function(s, c) {
    return new Promise(function(g, y) {
      var E, _, I = new Promise(function(ce, Le) {
        _ = ce, E = Le;
      }), $ = Ra(s, Be(c ? c.identifierPrefix : void 0, c ? c.nonce : void 0, c ? c.bootstrapScriptContent : void 0, c ? c.bootstrapScripts : void 0, c ? c.bootstrapModules : void 0), ft(c ? c.namespaceURI : void 0), c ? c.progressiveChunkSize : void 0, c ? c.onError : void 0, _, function() {
        var ce = new ReadableStream({ type: "bytes", pull: function(Le) {
          if ($.status === 1) $.status = 2, b(Le, $.fatalError);
          else if ($.status !== 2 && $.destination === null) {
            $.destination = Le;
            try {
              ri($, Le);
            } catch (gt) {
              Yn($, gt), vr($, gt);
            }
          }
        }, cancel: function() {
          xo($);
        } }, { highWaterMark: 0 });
        ce.allReady = I, g(ce);
      }, function(ce) {
        I.catch(function() {
        }), y(ce);
      }, E);
      if (c && c.signal) {
        var te = c.signal, fe = function() {
          xo($, te.reason), te.removeEventListener("abort", fe);
        };
        te.addEventListener("abort", fe);
      }
      mo($);
    });
  }, _r.version = "18.3.1", _r;
}
var Dn, Cs;
Dn = pl(), Cs = hl();
Dn.version;
Dn.renderToString;
Dn.renderToStaticMarkup;
Dn.renderToNodeStream;
Dn.renderToStaticNodeStream;
Cs.renderToReadableStream;
const ml = "staticMarkup";
function kn() {
  const t = Fi().indexOf(ml) > -1 ? !0 : void 0;
  return {
    isBootstrap: t,
    isReact: t ? void 0 : !0
  };
}
const tt = ({ gaData: e, prefix: t = "", children: n }) => {
  const { isReact: r } = kn(), { onClick: o, ...a } = n.props;
  if (r)
    return He.cloneElement(n, {
      ...a,
      onClick: (h) => (ks(e), o ? o(h) : !0)
    });
  let d = "";
  ["input", "header", "header-input"].includes(t) && (d = `-${t}`);
  const m = {
    [`data-ga${d}`]: e.text,
    [`data-ga${d}-name`]: e.name,
    [`data-ga${d}-event`]: e.event,
    [`data-ga${d}-action`]: e.action,
    [`data-ga${d}-type`]: e.type,
    [`data-ga${d}-region`]: e.region,
    [`data-ga${d}-section`]: e.section,
    [`data-ga${d}-component`]: e.component
  };
  return He.cloneElement(n, {
    ...a,
    onClick: o,
    ...m
  });
}, Rs = $i(
  ({
    id: e,
    parentId: t,
    /** @type {AccordionCard} */
    item: n,
    openCard: r,
    onClick: o,
    gaData: a
  }, d) => {
    var p, b, w, C, L, O;
    const m = e === r, h = m ? "open" : "close";
    return /* @__PURE__ */ f.jsxs(
      "div",
      {
        ref: d,
        className: we("accordion-item", "mt-3", {
          [`accordion-item-${n.color}`]: n.color,
          "accordion-header-icon": (p = n.content) == null ? void 0 : p.icon
        }),
        children: [
          /* @__PURE__ */ f.jsx("div", { className: "accordion-header", children: /* @__PURE__ */ f.jsx("h4", { children: /* @__PURE__ */ f.jsx(
            tt,
            {
              gaData: {
                ...a,
                action: h,
                text: n.content.header
              },
              children: /* @__PURE__ */ f.jsxs(
                "button",
                {
                  "data-testid": "accordion-opener",
                  className: we({ collapsed: !m }),
                  "data-bs-toggle": "collapse",
                  href: `#card-body-${e}`,
                  type: "button",
                  "aria-expanded": m,
                  "aria-controls": `card-body-${e}`,
                  onClick: (k) => o(k, e),
                  children: [
                    (b = n.content) != null && b.icon ? /* @__PURE__ */ f.jsxs("span", { className: "accordion-icon", children: [
                      /* @__PURE__ */ f.jsx(
                        "i",
                        {
                          className: `${(w = n.content.icon) == null ? void 0 : w[0]} fa-${(C = n.content.icon) == null ? void 0 : C[1]} me-2`
                        }
                      ),
                      n.content.header
                    ] }) : (L = n.content) == null ? void 0 : L.header,
                    /* @__PURE__ */ f.jsx("i", { className: "fas fa-chevron-up" })
                  ]
                }
              )
            }
          ) }) }),
          ((O = n.content) == null ? void 0 : O.body) && /* @__PURE__ */ f.jsx(
            "div",
            {
              "data-bs-parent": `#${t}`,
              id: `card-body-${e}`,
              className: we("collapse", { show: m }),
              children: /* @__PURE__ */ f.jsx(
                "div",
                {
                  className: "accordion-body",
                  dangerouslySetInnerHTML: xt(
                    n.content.body
                  )
                }
              )
            }
          )
        ]
      }
    );
  }
);
Rs.propTypes = {
  id: l.number,
  // @ts-ignore a technical type mismatch between PropTypes definition and your TypeScript
  item: Es,
  parentId: l.string,
  openCard: l.number,
  onClick: l.func,
  gaData: l.object
};
const gl = {
  event: "collapse",
  name: "onclick",
  type: "click",
  region: "main content"
}, Os = ({ cards: e, openedCard: t }) => {
  const [n, r] = Ze(t), o = `accordion-${Fi()}`, a = on(
    /** @type { HTMLDivElement[]} */
    []
  ), d = (m, h) => {
    if (m.preventDefault(), n !== h) {
      const p = a.current[n - 1], b = p == null ? void 0 : p.lastElementChild;
      ul(b), r(h);
    } else
      r(null);
  };
  return /* @__PURE__ */ f.jsx("div", { className: "accordion", id: o, children: e == null ? void 0 : e.map(
    (m, h) => m.content.body && m.content.header && /* @__PURE__ */ f.jsx(
      Rs,
      {
        ref: (p) => {
          a.current[h] = p;
        },
        id: h + 1,
        parentId: o,
        item: m,
        openCard: n,
        onClick: d,
        gaData: gl
      },
      h + 1
    )
  ) });
};
Os.propTypes = {
  /**
   * Cards to show in the accordion component
   */
  cards: l.arrayOf(Es).isRequired,
  /**
   * Opened card based on rendered card position
   */
  openedCard: l.number
};
const vl = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, wn = ({
  label: e = "",
  cardTitle: t = "",
  gaData: n,
  ariaLabel: r,
  block: o,
  color: a = "gray",
  disabled: d,
  element: m = "button",
  href: h,
  icon: p,
  innerRef: b,
  onClick: w,
  size: C = "default",
  classes: L,
  target: O = "_self",
  ...k
}) => {
  const N = we("btn", {
    [`btn-${a}`]: !0,
    "btn-md": C === "small",
    "btn-sm": C === "xsmall",
    "btn-block": o,
    disabled: d
  });
  let j = m;
  return h && m === "button" && (j = "a"), /* @__PURE__ */ f.jsx(
    tt,
    {
      gaData: {
        ...vl,
        section: t,
        // @deprecated - remove at some point
        ...n,
        text: e
      },
      children: /* @__PURE__ */ f.jsxs(
        j,
        {
          type: j === "button" && w ? "button" : void 0,
          ...k,
          className: we(L) || N,
          href: h,
          ref: b,
          onClick: w,
          "aria-label": r,
          target: j === "a" ? O : null,
          children: [
            p && /* @__PURE__ */ f.jsx("i", { className: `${p == null ? void 0 : p[0]} fa-${p == null ? void 0 : p[1]} me-1` }),
            e
          ]
        }
      )
    }
  );
};
wn.propTypes = {
  /**
   * Button label
   */
  label: l.string,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: l.string,
  /**
   * Google Analytics event data
   */
  gaData: Hi,
  /**
    ARIA label for accessibility
  */
  ariaLabel: l.string,
  /**
    Render button as a block-button?
  */
  block: l.bool,
  /**
    Button background color
  */
  color: l.oneOf(["gold", "maroon", "gray", "dark"]),
  /**
    Disable the button?
  */
  disabled: l.bool,
  /**
    Pass in a Component to override default button element.
    For example: react-router Link
  */
  element: l.oneOfType([
    l.func,
    l.string,
    l.shape({ $$typeof: l.symbol, render: l.func }),
    l.arrayOf(
      l.oneOfType([
        l.func,
        l.string,
        l.shape({ $$typeof: l.symbol, render: l.func })
      ])
    )
  ]),
  /**
    Link target url; will cause button to be rendered as `<a>` link
  */
  href: l.string,
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: l.arrayOf(l.string),
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: l.oneOfType([
    l.object,
    l.func,
    l.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: l.func,
  /**
    Button size
  */
  size: l.oneOf(["default", "small", "xsmall"]),
  /**
    Classes to add to button
  */
  classes: l.arrayOf(l.string),
  /**
   Link target type
   */
  target: l.oneOf(["_blank", "_self", "_top", "_parent"])
};
var As = { exports: {} }, Re = {};
var $o;
function yl() {
  if ($o) return Re;
  $o = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.consumer"), d = Symbol.for("react.context"), m = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), C = Symbol.for("react.offscreen"), L = Symbol.for("react.client.reference");
  function O(k) {
    if (typeof k == "object" && k !== null) {
      var N = k.$$typeof;
      switch (N) {
        case e:
          switch (k = k.type, k) {
            case n:
            case o:
            case r:
            case h:
            case p:
              return k;
            default:
              switch (k = k && k.$$typeof, k) {
                case d:
                case m:
                case w:
                case b:
                  return k;
                case a:
                  return k;
                default:
                  return N;
              }
          }
        case t:
          return N;
      }
    }
  }
  return Re.ContextConsumer = a, Re.ContextProvider = d, Re.Element = e, Re.ForwardRef = m, Re.Fragment = n, Re.Lazy = w, Re.Memo = b, Re.Portal = t, Re.Profiler = o, Re.StrictMode = r, Re.Suspense = h, Re.SuspenseList = p, Re.isContextConsumer = function(k) {
    return O(k) === a;
  }, Re.isContextProvider = function(k) {
    return O(k) === d;
  }, Re.isElement = function(k) {
    return typeof k == "object" && k !== null && k.$$typeof === e;
  }, Re.isForwardRef = function(k) {
    return O(k) === m;
  }, Re.isFragment = function(k) {
    return O(k) === n;
  }, Re.isLazy = function(k) {
    return O(k) === w;
  }, Re.isMemo = function(k) {
    return O(k) === b;
  }, Re.isPortal = function(k) {
    return O(k) === t;
  }, Re.isProfiler = function(k) {
    return O(k) === o;
  }, Re.isStrictMode = function(k) {
    return O(k) === r;
  }, Re.isSuspense = function(k) {
    return O(k) === h;
  }, Re.isSuspenseList = function(k) {
    return O(k) === p;
  }, Re.isValidElementType = function(k) {
    return typeof k == "string" || typeof k == "function" || k === n || k === o || k === r || k === h || k === p || k === C || typeof k == "object" && k !== null && (k.$$typeof === w || k.$$typeof === b || k.$$typeof === d || k.$$typeof === a || k.$$typeof === m || k.$$typeof === L || k.getModuleId !== void 0);
  }, Re.typeOf = O, Re;
}
As.exports = yl();
var js = As.exports;
function xl(e) {
  function t(Y, B, q, U, A) {
    for (var ue = 0, z = 0, pe = 0, re = 0, ie, Z, de = 0, ye = 0, ae, Ae = ae = ie = 0, le = 0, Ee = 0, Xe = 0, je = 0, vt = q.length, Ge = vt - 1, Se, K = "", xe = "", it = "", wt = "", Ke; le < vt; ) {
      if (Z = q.charCodeAt(le), le === Ge && z + re + pe + ue !== 0 && (z !== 0 && (Z = z === 47 ? 10 : 47), re = pe = ue = 0, vt++, Ge++), z + re + pe + ue === 0) {
        if (le === Ge && (0 < Ee && (K = K.replace(C, "")), 0 < K.trim().length)) {
          switch (Z) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              K += q.charAt(le);
          }
          Z = 59;
        }
        switch (Z) {
          case 123:
            for (K = K.trim(), ie = K.charCodeAt(0), ae = 1, je = ++le; le < vt; ) {
              switch (Z = q.charCodeAt(le)) {
                case 123:
                  ae++;
                  break;
                case 125:
                  ae--;
                  break;
                case 47:
                  switch (Z = q.charCodeAt(le + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (Ae = le + 1; Ae < Ge; ++Ae)
                          switch (q.charCodeAt(Ae)) {
                            case 47:
                              if (Z === 42 && q.charCodeAt(Ae - 1) === 42 && le + 2 !== Ae) {
                                le = Ae + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (Z === 47) {
                                le = Ae + 1;
                                break e;
                              }
                          }
                        le = Ae;
                      }
                  }
                  break;
                case 91:
                  Z++;
                case 40:
                  Z++;
                case 34:
                case 39:
                  for (; le++ < Ge && q.charCodeAt(le) !== Z; )
                    ;
              }
              if (ae === 0) break;
              le++;
            }
            switch (ae = q.substring(je, le), ie === 0 && (ie = (K = K.replace(w, "").trim()).charCodeAt(0)), ie) {
              case 64:
                switch (0 < Ee && (K = K.replace(C, "")), Z = K.charCodeAt(1), Z) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    Ee = B;
                    break;
                  default:
                    Ee = dt;
                }
                if (ae = t(B, Ee, ae, Z, A + 1), je = ae.length, 0 < Be && (Ee = n(dt, K, Xe), Ke = m(3, ae, Ee, B, Q, ve, je, Z, A, U), K = Ee.join(""), Ke !== void 0 && (je = (ae = Ke.trim()).length) === 0 && (Z = 0, ae = "")), 0 < je) switch (Z) {
                  case 115:
                    K = K.replace(J, d);
                  case 100:
                  case 109:
                  case 45:
                    ae = K + "{" + ae + "}";
                    break;
                  case 107:
                    K = K.replace(D, "$1 $2"), ae = K + "{" + ae + "}", ae = Ne === 1 || Ne === 2 && a("@" + ae, 3) ? "@-webkit-" + ae + "@" + ae : "@" + ae;
                    break;
                  default:
                    ae = K + ae, U === 112 && (ae = (xe += ae, ""));
                }
                else ae = "";
                break;
              default:
                ae = t(B, n(B, K, Xe), ae, U, A + 1);
            }
            it += ae, ae = Xe = Ee = Ae = ie = 0, K = "", Z = q.charCodeAt(++le);
            break;
          case 125:
          case 59:
            if (K = (0 < Ee ? K.replace(C, "") : K).trim(), 1 < (je = K.length)) switch (Ae === 0 && (ie = K.charCodeAt(0), ie === 45 || 96 < ie && 123 > ie) && (je = (K = K.replace(" ", ":")).length), 0 < Be && (Ke = m(1, K, B, Y, Q, ve, xe.length, U, A, U)) !== void 0 && (je = (K = Ke.trim()).length) === 0 && (K = "\0\0"), ie = K.charCodeAt(0), Z = K.charCodeAt(1), ie) {
              case 0:
                break;
              case 64:
                if (Z === 105 || Z === 99) {
                  wt += K + q.charAt(le);
                  break;
                }
              default:
                K.charCodeAt(je - 1) !== 58 && (xe += o(K, ie, Z, K.charCodeAt(2)));
            }
            Xe = Ee = Ae = ie = 0, K = "", Z = q.charCodeAt(++le);
        }
      }
      switch (Z) {
        case 13:
        case 10:
          z === 47 ? z = 0 : 1 + ie === 0 && U !== 107 && 0 < K.length && (Ee = 1, K += "\0"), 0 < Be * ft && m(0, K, B, Y, Q, ve, xe.length, U, A, U), ve = 1, Q++;
          break;
        case 59:
        case 125:
          if (z + re + pe + ue === 0) {
            ve++;
            break;
          }
        default:
          switch (ve++, Se = q.charAt(le), Z) {
            case 9:
            case 32:
              if (re + ue + z === 0) switch (de) {
                case 44:
                case 58:
                case 9:
                case 32:
                  Se = "";
                  break;
                default:
                  Z !== 32 && (Se = " ");
              }
              break;
            case 0:
              Se = "\\0";
              break;
            case 12:
              Se = "\\f";
              break;
            case 11:
              Se = "\\v";
              break;
            case 38:
              re + z + ue === 0 && (Ee = Xe = 1, Se = "\f" + Se);
              break;
            case 108:
              if (re + z + ue + he === 0 && 0 < Ae) switch (le - Ae) {
                case 2:
                  de === 112 && q.charCodeAt(le - 3) === 58 && (he = de);
                case 8:
                  ye === 111 && (he = ye);
              }
              break;
            case 58:
              re + z + ue === 0 && (Ae = le);
              break;
            case 44:
              z + pe + re + ue === 0 && (Ee = 1, Se += "\r");
              break;
            case 34:
            case 39:
              z === 0 && (re = re === Z ? 0 : re === 0 ? Z : re);
              break;
            case 91:
              re + z + pe === 0 && ue++;
              break;
            case 93:
              re + z + pe === 0 && ue--;
              break;
            case 41:
              re + z + ue === 0 && pe--;
              break;
            case 40:
              if (re + z + ue === 0) {
                if (ie === 0) switch (2 * de + 3 * ye) {
                  case 533:
                    break;
                  default:
                    ie = 1;
                }
                pe++;
              }
              break;
            case 64:
              z + pe + re + ue + Ae + ae === 0 && (ae = 1);
              break;
            case 42:
            case 47:
              if (!(0 < re + ue + pe)) switch (z) {
                case 0:
                  switch (2 * Z + 3 * q.charCodeAt(le + 1)) {
                    case 235:
                      z = 47;
                      break;
                    case 220:
                      je = le, z = 42;
                  }
                  break;
                case 42:
                  Z === 47 && de === 42 && je + 2 !== le && (q.charCodeAt(je + 2) === 33 && (xe += q.substring(je, le + 1)), Se = "", z = 0);
              }
          }
          z === 0 && (K += Se);
      }
      ye = de, de = Z, le++;
    }
    if (je = xe.length, 0 < je) {
      if (Ee = B, 0 < Be && (Ke = m(2, xe, Ee, Y, Q, ve, je, U, A, U), Ke !== void 0 && (xe = Ke).length === 0)) return wt + xe + it;
      if (xe = Ee.join(",") + "{" + xe + "}", Ne * he !== 0) {
        switch (Ne !== 2 || a(xe, 2) || (he = 0), he) {
          case 111:
            xe = xe.replace(W, ":-moz-$1") + xe;
            break;
          case 112:
            xe = xe.replace(V, "::-webkit-input-$1") + xe.replace(V, "::-moz-$1") + xe.replace(V, ":-ms-input-$1") + xe;
        }
        he = 0;
      }
    }
    return wt + xe + it;
  }
  function n(Y, B, q) {
    var U = B.trim().split(N);
    B = U;
    var A = U.length, ue = Y.length;
    switch (ue) {
      case 0:
      case 1:
        var z = 0;
        for (Y = ue === 0 ? "" : Y[0] + " "; z < A; ++z)
          B[z] = r(Y, B[z], q).trim();
        break;
      default:
        var pe = z = 0;
        for (B = []; z < A; ++z)
          for (var re = 0; re < ue; ++re)
            B[pe++] = r(Y[re] + " ", U[z], q).trim();
    }
    return B;
  }
  function r(Y, B, q) {
    var U = B.charCodeAt(0);
    switch (33 > U && (U = (B = B.trim()).charCodeAt(0)), U) {
      case 38:
        return B.replace(j, "$1" + Y.trim());
      case 58:
        return Y.trim() + B.replace(j, "$1" + Y.trim());
      default:
        if (0 < 1 * q && 0 < B.indexOf("\f")) return B.replace(j, (Y.charCodeAt(0) === 58 ? "" : "$1") + Y.trim());
    }
    return Y + B;
  }
  function o(Y, B, q, U) {
    var A = Y + ";", ue = 2 * B + 3 * q + 4 * U;
    if (ue === 944) {
      Y = A.indexOf(":", 9) + 1;
      var z = A.substring(Y, A.length - 1).trim();
      return z = A.substring(0, Y).trim() + z + ";", Ne === 1 || Ne === 2 && a(z, 1) ? "-webkit-" + z + z : z;
    }
    if (Ne === 0 || Ne === 2 && !a(A, 1)) return A;
    switch (ue) {
      case 1015:
        return A.charCodeAt(10) === 97 ? "-webkit-" + A + A : A;
      case 951:
        return A.charCodeAt(3) === 116 ? "-webkit-" + A + A : A;
      case 963:
        return A.charCodeAt(5) === 110 ? "-webkit-" + A + A : A;
      case 1009:
        if (A.charCodeAt(4) !== 100) break;
      case 969:
      case 942:
        return "-webkit-" + A + A;
      case 978:
        return "-webkit-" + A + "-moz-" + A + A;
      case 1019:
      case 983:
        return "-webkit-" + A + "-moz-" + A + "-ms-" + A + A;
      case 883:
        if (A.charCodeAt(8) === 45) return "-webkit-" + A + A;
        if (0 < A.indexOf("image-set(", 11)) return A.replace(ke, "$1-webkit-$2") + A;
        break;
      case 932:
        if (A.charCodeAt(4) === 45) switch (A.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + A.replace("-grow", "") + "-webkit-" + A + "-ms-" + A.replace("grow", "positive") + A;
          case 115:
            return "-webkit-" + A + "-ms-" + A.replace("shrink", "negative") + A;
          case 98:
            return "-webkit-" + A + "-ms-" + A.replace("basis", "preferred-size") + A;
        }
        return "-webkit-" + A + "-ms-" + A + A;
      case 964:
        return "-webkit-" + A + "-ms-flex-" + A + A;
      case 1023:
        if (A.charCodeAt(8) !== 99) break;
        return z = A.substring(A.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + z + "-webkit-" + A + "-ms-flex-pack" + z + A;
      case 1005:
        return O.test(A) ? A.replace(L, ":-webkit-") + A.replace(L, ":-moz-") + A : A;
      case 1e3:
        switch (z = A.substring(13).trim(), B = z.indexOf("-") + 1, z.charCodeAt(0) + z.charCodeAt(B)) {
          case 226:
            z = A.replace(M, "tb");
            break;
          case 232:
            z = A.replace(M, "tb-rl");
            break;
          case 220:
            z = A.replace(M, "lr");
            break;
          default:
            return A;
        }
        return "-webkit-" + A + "-ms-" + z + A;
      case 1017:
        if (A.indexOf("sticky", 9) === -1) break;
      case 975:
        switch (B = (A = Y).length - 10, z = (A.charCodeAt(B) === 33 ? A.substring(0, B) : A).substring(Y.indexOf(":", 7) + 1).trim(), ue = z.charCodeAt(0) + (z.charCodeAt(7) | 0)) {
          case 203:
            if (111 > z.charCodeAt(8)) break;
          case 115:
            A = A.replace(z, "-webkit-" + z) + ";" + A;
            break;
          case 207:
          case 102:
            A = A.replace(z, "-webkit-" + (102 < ue ? "inline-" : "") + "box") + ";" + A.replace(z, "-webkit-" + z) + ";" + A.replace(z, "-ms-" + z + "box") + ";" + A;
        }
        return A + ";";
      case 938:
        if (A.charCodeAt(5) === 45) switch (A.charCodeAt(6)) {
          case 105:
            return z = A.replace("-items", ""), "-webkit-" + A + "-webkit-box-" + z + "-ms-flex-" + z + A;
          case 115:
            return "-webkit-" + A + "-ms-flex-item-" + A.replace(Oe, "") + A;
          default:
            return "-webkit-" + A + "-ms-flex-line-pack" + A.replace("align-content", "").replace(Oe, "") + A;
        }
        break;
      case 973:
      case 989:
        if (A.charCodeAt(3) !== 45 || A.charCodeAt(4) === 122) break;
      case 931:
      case 953:
        if (Ve.test(Y) === !0) return (z = Y.substring(Y.indexOf(":") + 1)).charCodeAt(0) === 115 ? o(Y.replace("stretch", "fill-available"), B, q, U).replace(":fill-available", ":stretch") : A.replace(z, "-webkit-" + z) + A.replace(z, "-moz-" + z.replace("fill-", "")) + A;
        break;
      case 962:
        if (A = "-webkit-" + A + (A.charCodeAt(5) === 102 ? "-ms-" + A : "") + A, q + U === 211 && A.charCodeAt(13) === 105 && 0 < A.indexOf("transform", 10)) return A.substring(0, A.indexOf(";", 27) + 1).replace(k, "$1-webkit-$2") + A;
    }
    return A;
  }
  function a(Y, B) {
    var q = Y.indexOf(B === 1 ? ":" : "{"), U = Y.substring(0, B !== 3 ? q : 10);
    return q = Y.substring(q + 1, Y.length - 1), qe(B !== 2 ? U : U.replace(Fe, "$1"), q, B);
  }
  function d(Y, B) {
    var q = o(B, B.charCodeAt(0), B.charCodeAt(1), B.charCodeAt(2));
    return q !== B + ";" ? q.replace(se, " or ($1)").substring(4) : "(" + B + ")";
  }
  function m(Y, B, q, U, A, ue, z, pe, re, ie) {
    for (var Z = 0, de = B, ye; Z < Be; ++Z)
      switch (ye = $e[Z].call(b, Y, de, q, U, A, ue, z, pe, re, ie)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          de = ye;
      }
    if (de !== B) return de;
  }
  function h(Y) {
    switch (Y) {
      case void 0:
      case null:
        Be = $e.length = 0;
        break;
      default:
        if (typeof Y == "function") $e[Be++] = Y;
        else if (typeof Y == "object") for (var B = 0, q = Y.length; B < q; ++B)
          h(Y[B]);
        else ft = !!Y | 0;
    }
    return h;
  }
  function p(Y) {
    return Y = Y.prefix, Y !== void 0 && (qe = null, Y ? typeof Y != "function" ? Ne = 1 : (Ne = 2, qe = Y) : Ne = 0), p;
  }
  function b(Y, B) {
    var q = Y;
    if (33 > q.charCodeAt(0) && (q = q.trim()), be = q, q = [be], 0 < Be) {
      var U = m(-1, B, q, q, Q, ve, 0, 0, 0, 0);
      U !== void 0 && typeof U == "string" && (B = U);
    }
    var A = t(dt, q, B, 0, 0);
    return 0 < Be && (U = m(-2, A, q, q, Q, ve, A.length, 0, 0, 0), U !== void 0 && (A = U)), be = "", he = 0, ve = Q = 1, A;
  }
  var w = /^\0+/g, C = /[\0\r\f]/g, L = /: */g, O = /zoo|gra/, k = /([,: ])(transform)/g, N = /,\r+?/g, j = /([\t\r\n ])*\f?&/g, D = /@(k\w+)\s*(\S*)\s*/, V = /::(place)/g, W = /:(read-only)/g, M = /[svh]\w+-[tblr]{2}/, J = /\(\s*(.*)\s*\)/g, se = /([\s\S]*?);/g, Oe = /-self|flex-/g, Fe = /[^]*?(:[rp][el]a[\w-]+)[^]*/, Ve = /stretch|:\s*\w+\-(?:conte|avail)/, ke = /([^-])(image-set\()/, ve = 1, Q = 1, he = 0, Ne = 1, dt = [], $e = [], Be = 0, qe = null, ft = 0, be = "";
  return b.use = h, b.set = p, e !== void 0 && p(e), b;
}
var bl = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function wl(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var Sl = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Bo = /* @__PURE__ */ wl(
  function(e) {
    return Sl.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Ns = { exports: {} }, _e = {};
var zo;
function kl() {
  if (zo) return _e;
  zo = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, d = e ? Symbol.for("react.provider") : 60109, m = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, w = e ? Symbol.for("react.suspense") : 60113, C = e ? Symbol.for("react.suspense_list") : 60120, L = e ? Symbol.for("react.memo") : 60115, O = e ? Symbol.for("react.lazy") : 60116, k = e ? Symbol.for("react.block") : 60121, N = e ? Symbol.for("react.fundamental") : 60117, j = e ? Symbol.for("react.responder") : 60118, D = e ? Symbol.for("react.scope") : 60119;
  function V(M) {
    if (typeof M == "object" && M !== null) {
      var J = M.$$typeof;
      switch (J) {
        case t:
          switch (M = M.type, M) {
            case h:
            case p:
            case r:
            case a:
            case o:
            case w:
              return M;
            default:
              switch (M = M && M.$$typeof, M) {
                case m:
                case b:
                case O:
                case L:
                case d:
                  return M;
                default:
                  return J;
              }
          }
        case n:
          return J;
      }
    }
  }
  function W(M) {
    return V(M) === p;
  }
  return _e.AsyncMode = h, _e.ConcurrentMode = p, _e.ContextConsumer = m, _e.ContextProvider = d, _e.Element = t, _e.ForwardRef = b, _e.Fragment = r, _e.Lazy = O, _e.Memo = L, _e.Portal = n, _e.Profiler = a, _e.StrictMode = o, _e.Suspense = w, _e.isAsyncMode = function(M) {
    return W(M) || V(M) === h;
  }, _e.isConcurrentMode = W, _e.isContextConsumer = function(M) {
    return V(M) === m;
  }, _e.isContextProvider = function(M) {
    return V(M) === d;
  }, _e.isElement = function(M) {
    return typeof M == "object" && M !== null && M.$$typeof === t;
  }, _e.isForwardRef = function(M) {
    return V(M) === b;
  }, _e.isFragment = function(M) {
    return V(M) === r;
  }, _e.isLazy = function(M) {
    return V(M) === O;
  }, _e.isMemo = function(M) {
    return V(M) === L;
  }, _e.isPortal = function(M) {
    return V(M) === n;
  }, _e.isProfiler = function(M) {
    return V(M) === a;
  }, _e.isStrictMode = function(M) {
    return V(M) === o;
  }, _e.isSuspense = function(M) {
    return V(M) === w;
  }, _e.isValidElementType = function(M) {
    return typeof M == "string" || typeof M == "function" || M === r || M === p || M === a || M === o || M === w || M === C || typeof M == "object" && M !== null && (M.$$typeof === O || M.$$typeof === L || M.$$typeof === d || M.$$typeof === m || M.$$typeof === b || M.$$typeof === N || M.$$typeof === j || M.$$typeof === D || M.$$typeof === k);
  }, _e.typeOf = V, _e;
}
Ns.exports = kl();
var Tl = Ns.exports, Vi = Tl, _l = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, El = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Cl = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Ps = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Wi = {};
Wi[Vi.ForwardRef] = Cl;
Wi[Vi.Memo] = Ps;
function Ho(e) {
  return Vi.isMemo(e) ? Ps : Wi[e.$$typeof] || _l;
}
var Rl = Object.defineProperty, Ol = Object.getOwnPropertyNames, Vo = Object.getOwnPropertySymbols, Al = Object.getOwnPropertyDescriptor, jl = Object.getPrototypeOf, Wo = Object.prototype;
function Is(e, t, n) {
  if (typeof t != "string") {
    if (Wo) {
      var r = jl(t);
      r && r !== Wo && Is(e, r, n);
    }
    var o = Ol(t);
    Vo && (o = o.concat(Vo(t)));
    for (var a = Ho(e), d = Ho(t), m = 0; m < o.length; ++m) {
      var h = o[m];
      if (!El[h] && !(n && n[h]) && !(d && d[h]) && !(a && a[h])) {
        var p = Al(t, h);
        try {
          Rl(e, h, p);
        } catch {
        }
      }
    }
  }
  return e;
}
var Nl = Is;
const Pl = /* @__PURE__ */ zi(Nl);
var rt = { env: { NODE_ENV: "production" } };
function Wt() {
  return (Wt = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
var Uo = function(e, t) {
  for (var n = [e[0]], r = 0, o = t.length; r < o; r += 1) n.push(t[r], e[r + 1]);
  return n;
}, bi = function(e) {
  return e !== null && typeof e == "object" && (e.toString ? e.toString() : Object.prototype.toString.call(e)) === "[object Object]" && !js.typeOf(e);
}, Fr = Object.freeze([]), rn = Object.freeze({});
function nr(e) {
  return typeof e == "function";
}
function qo(e) {
  return e.displayName || e.name || "Component";
}
function Ui(e) {
  return e && typeof e.styledComponentId == "string";
}
var Pn = typeof rt < "u" && rt.env !== void 0 && (rt.env.REACT_APP_SC_ATTR || rt.env.SC_ATTR) || "data-styled", qi = typeof window < "u" && "HTMLElement" in window, Il = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof rt < "u" && rt.env !== void 0 && (rt.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && rt.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? rt.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && rt.env.REACT_APP_SC_DISABLE_SPEEDY : rt.env.SC_DISABLE_SPEEDY !== void 0 && rt.env.SC_DISABLE_SPEEDY !== "" ? rt.env.SC_DISABLE_SPEEDY !== "false" && rt.env.SC_DISABLE_SPEEDY : rt.env.NODE_ENV !== "production"));
function ir(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var Ll = function() {
  function e(n) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = n;
  }
  var t = e.prototype;
  return t.indexOfGroup = function(n) {
    for (var r = 0, o = 0; o < n; o++) r += this.groupSizes[o];
    return r;
  }, t.insertRules = function(n, r) {
    if (n >= this.groupSizes.length) {
      for (var o = this.groupSizes, a = o.length, d = a; n >= d; ) (d <<= 1) < 0 && ir(16, "" + n);
      this.groupSizes = new Uint32Array(d), this.groupSizes.set(o), this.length = d;
      for (var m = a; m < d; m++) this.groupSizes[m] = 0;
    }
    for (var h = this.indexOfGroup(n + 1), p = 0, b = r.length; p < b; p++) this.tag.insertRule(h, r[p]) && (this.groupSizes[n]++, h++);
  }, t.clearGroup = function(n) {
    if (n < this.length) {
      var r = this.groupSizes[n], o = this.indexOfGroup(n), a = o + r;
      this.groupSizes[n] = 0;
      for (var d = o; d < a; d++) this.tag.deleteRule(o);
    }
  }, t.getGroup = function(n) {
    var r = "";
    if (n >= this.length || this.groupSizes[n] === 0) return r;
    for (var o = this.groupSizes[n], a = this.indexOfGroup(n), d = a + o, m = a; m < d; m++) r += this.tag.getRule(m) + `/*!sc*/
`;
    return r;
  }, e;
}(), Nr = /* @__PURE__ */ new Map(), $r = /* @__PURE__ */ new Map(), er = 1, Er = function(e) {
  if (Nr.has(e)) return Nr.get(e);
  for (; $r.has(er); ) er++;
  var t = er++;
  return Nr.set(e, t), $r.set(t, e), t;
}, Ml = function(e) {
  return $r.get(e);
}, Dl = function(e, t) {
  t >= er && (er = t + 1), Nr.set(e, t), $r.set(t, e);
}, Fl = "style[" + Pn + '][data-styled-version="5.3.11"]', $l = new RegExp("^" + Pn + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), Bl = function(e, t, n) {
  for (var r, o = n.split(","), a = 0, d = o.length; a < d; a++) (r = o[a]) && e.registerName(t, r);
}, zl = function(e, t) {
  for (var n = (t.textContent || "").split(`/*!sc*/
`), r = [], o = 0, a = n.length; o < a; o++) {
    var d = n[o].trim();
    if (d) {
      var m = d.match($l);
      if (m) {
        var h = 0 | parseInt(m[1], 10), p = m[2];
        h !== 0 && (Dl(p, h), Bl(e, p, m[3]), e.getTag().insertRules(h, r)), r.length = 0;
      } else r.push(d);
    }
  }
}, Hl = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}, Ls = function(e) {
  var t = document.head, n = e || t, r = document.createElement("style"), o = function(m) {
    for (var h = m.childNodes, p = h.length; p >= 0; p--) {
      var b = h[p];
      if (b && b.nodeType === 1 && b.hasAttribute(Pn)) return b;
    }
  }(n), a = o !== void 0 ? o.nextSibling : null;
  r.setAttribute(Pn, "active"), r.setAttribute("data-styled-version", "5.3.11");
  var d = Hl();
  return d && r.setAttribute("nonce", d), n.insertBefore(r, a), r;
}, Vl = function() {
  function e(n) {
    var r = this.element = Ls(n);
    r.appendChild(document.createTextNode("")), this.sheet = function(o) {
      if (o.sheet) return o.sheet;
      for (var a = document.styleSheets, d = 0, m = a.length; d < m; d++) {
        var h = a[d];
        if (h.ownerNode === o) return h;
      }
      ir(17);
    }(r), this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    try {
      return this.sheet.insertRule(r, n), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.deleteRule = function(n) {
    this.sheet.deleteRule(n), this.length--;
  }, t.getRule = function(n) {
    var r = this.sheet.cssRules[n];
    return r !== void 0 && typeof r.cssText == "string" ? r.cssText : "";
  }, e;
}(), Wl = function() {
  function e(n) {
    var r = this.element = Ls(n);
    this.nodes = r.childNodes, this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    if (n <= this.length && n >= 0) {
      var o = document.createTextNode(r), a = this.nodes[n];
      return this.element.insertBefore(o, a || null), this.length++, !0;
    }
    return !1;
  }, t.deleteRule = function(n) {
    this.element.removeChild(this.nodes[n]), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.nodes[n].textContent : "";
  }, e;
}(), Ul = function() {
  function e(n) {
    this.rules = [], this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    return n <= this.length && (this.rules.splice(n, 0, r), this.length++, !0);
  }, t.deleteRule = function(n) {
    this.rules.splice(n, 1), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.rules[n] : "";
  }, e;
}(), Yo = qi, ql = { isServer: !qi, useCSSOMInjection: !Il }, Ms = function() {
  function e(n, r, o) {
    n === void 0 && (n = rn), r === void 0 && (r = {}), this.options = Wt({}, ql, {}, n), this.gs = r, this.names = new Map(o), this.server = !!n.isServer, !this.server && qi && Yo && (Yo = !1, function(a) {
      for (var d = document.querySelectorAll(Fl), m = 0, h = d.length; m < h; m++) {
        var p = d[m];
        p && p.getAttribute(Pn) !== "active" && (zl(a, p), p.parentNode && p.parentNode.removeChild(p));
      }
    }(this));
  }
  e.registerId = function(n) {
    return Er(n);
  };
  var t = e.prototype;
  return t.reconstructWithOptions = function(n, r) {
    return r === void 0 && (r = !0), new e(Wt({}, this.options, {}, n), this.gs, r && this.names || void 0);
  }, t.allocateGSInstance = function(n) {
    return this.gs[n] = (this.gs[n] || 0) + 1;
  }, t.getTag = function() {
    return this.tag || (this.tag = (o = (r = this.options).isServer, a = r.useCSSOMInjection, d = r.target, n = o ? new Ul(d) : a ? new Vl(d) : new Wl(d), new Ll(n)));
    var n, r, o, a, d;
  }, t.hasNameForId = function(n, r) {
    return this.names.has(n) && this.names.get(n).has(r);
  }, t.registerName = function(n, r) {
    if (Er(n), this.names.has(n)) this.names.get(n).add(r);
    else {
      var o = /* @__PURE__ */ new Set();
      o.add(r), this.names.set(n, o);
    }
  }, t.insertRules = function(n, r, o) {
    this.registerName(n, r), this.getTag().insertRules(Er(n), o);
  }, t.clearNames = function(n) {
    this.names.has(n) && this.names.get(n).clear();
  }, t.clearRules = function(n) {
    this.getTag().clearGroup(Er(n)), this.clearNames(n);
  }, t.clearTag = function() {
    this.tag = void 0;
  }, t.toString = function() {
    return function(n) {
      for (var r = n.getTag(), o = r.length, a = "", d = 0; d < o; d++) {
        var m = Ml(d);
        if (m !== void 0) {
          var h = n.names.get(m), p = r.getGroup(d);
          if (h && p && h.size) {
            var b = Pn + ".g" + d + '[id="' + m + '"]', w = "";
            h !== void 0 && h.forEach(function(C) {
              C.length > 0 && (w += C + ",");
            }), a += "" + p + b + '{content:"' + w + `"}/*!sc*/
`;
          }
        }
      }
      return a;
    }(this);
  }, e;
}(), Yl = /(a)(d)/gi, Xo = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function wi(e) {
  var t, n = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0) n = Xo(t % 52) + n;
  return (Xo(t % 52) + n).replace(Yl, "$1-$2");
}
var Nn = function(e, t) {
  for (var n = t.length; n; ) e = 33 * e ^ t.charCodeAt(--n);
  return e;
}, Ds = function(e) {
  return Nn(5381, e);
};
function Xl(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (nr(n) && !Ui(n)) return !1;
  }
  return !0;
}
var Gl = Ds("5.3.11"), Kl = function() {
  function e(t, n, r) {
    this.rules = t, this.staticRulesId = "", this.isStatic = (r === void 0 || r.isStatic) && Xl(t), this.componentId = n, this.baseHash = Nn(Gl, n), this.baseStyle = r, Ms.registerId(n);
  }
  return e.prototype.generateAndInjectStyles = function(t, n, r) {
    var o = this.componentId, a = [];
    if (this.baseStyle && a.push(this.baseStyle.generateAndInjectStyles(t, n, r)), this.isStatic && !r.hash) if (this.staticRulesId && n.hasNameForId(o, this.staticRulesId)) a.push(this.staticRulesId);
    else {
      var d = In(this.rules, t, n, r).join(""), m = wi(Nn(this.baseHash, d) >>> 0);
      if (!n.hasNameForId(o, m)) {
        var h = r(d, "." + m, void 0, o);
        n.insertRules(o, m, h);
      }
      a.push(m), this.staticRulesId = m;
    }
    else {
      for (var p = this.rules.length, b = Nn(this.baseHash, r.hash), w = "", C = 0; C < p; C++) {
        var L = this.rules[C];
        if (typeof L == "string") w += L;
        else if (L) {
          var O = In(L, t, n, r), k = Array.isArray(O) ? O.join("") : O;
          b = Nn(b, k + C), w += k;
        }
      }
      if (w) {
        var N = wi(b >>> 0);
        if (!n.hasNameForId(o, N)) {
          var j = r(w, "." + N, void 0, o);
          n.insertRules(o, N, j);
        }
        a.push(N);
      }
    }
    return a.join(" ");
  }, e;
}(), Zl = /^\s*\/\/.*$/gm, Jl = [":", "[", ".", "#"];
function Ql(e) {
  var t, n, r, o, a = rn, d = a.options, m = d === void 0 ? rn : d, h = a.plugins, p = h === void 0 ? Fr : h, b = new xl(m), w = [], C = /* @__PURE__ */ function(k) {
    function N(j) {
      if (j) try {
        k(j + "}");
      } catch {
      }
    }
    return function(j, D, V, W, M, J, se, Oe, Fe, Ve) {
      switch (j) {
        case 1:
          if (Fe === 0 && D.charCodeAt(0) === 64) return k(D + ";"), "";
          break;
        case 2:
          if (Oe === 0) return D + "/*|*/";
          break;
        case 3:
          switch (Oe) {
            case 102:
            case 112:
              return k(V[0] + D), "";
            default:
              return D + (Ve === 0 ? "/*|*/" : "");
          }
        case -2:
          D.split("/*|*/}").forEach(N);
      }
    };
  }(function(k) {
    w.push(k);
  }), L = function(k, N, j) {
    return N === 0 && Jl.indexOf(j[n.length]) !== -1 || j.match(o) ? k : "." + t;
  };
  function O(k, N, j, D) {
    D === void 0 && (D = "&");
    var V = k.replace(Zl, ""), W = N && j ? j + " " + N + " { " + V + " }" : V;
    return t = D, n = N, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), b(j || !N ? "" : N, W);
  }
  return b.use([].concat(p, [function(k, N, j) {
    k === 2 && j.length && j[0].lastIndexOf(n) > 0 && (j[0] = j[0].replace(r, L));
  }, C, function(k) {
    if (k === -2) {
      var N = w;
      return w = [], N;
    }
  }])), O.hash = p.length ? p.reduce(function(k, N) {
    return N.name || ir(15), Nn(k, N.name);
  }, 5381).toString() : "", O;
}
var Fs = He.createContext();
Fs.Consumer;
var $s = He.createContext(), ec = ($s.Consumer, new Ms()), Si = Ql();
function tc() {
  return Bi(Fs) || ec;
}
function nc() {
  return Bi($s) || Si;
}
var rc = function() {
  function e(t, n) {
    var r = this;
    this.inject = function(o, a) {
      a === void 0 && (a = Si);
      var d = r.name + a.hash;
      o.hasNameForId(r.id, d) || o.insertRules(r.id, d, a(r.rules, d, "@keyframes"));
    }, this.toString = function() {
      return ir(12, String(r.name));
    }, this.name = t, this.id = "sc-keyframes-" + t, this.rules = n;
  }
  return e.prototype.getName = function(t) {
    return t === void 0 && (t = Si), this.name + t.hash;
  }, e;
}(), ic = /([A-Z])/, oc = /([A-Z])/g, sc = /^ms-/, ac = function(e) {
  return "-" + e.toLowerCase();
};
function Go(e) {
  return ic.test(e) ? e.replace(oc, ac).replace(sc, "-ms-") : e;
}
var Ko = function(e) {
  return e == null || e === !1 || e === "";
};
function In(e, t, n, r) {
  if (Array.isArray(e)) {
    for (var o, a = [], d = 0, m = e.length; d < m; d += 1) (o = In(e[d], t, n, r)) !== "" && (Array.isArray(o) ? a.push.apply(a, o) : a.push(o));
    return a;
  }
  if (Ko(e)) return "";
  if (Ui(e)) return "." + e.styledComponentId;
  if (nr(e)) {
    if (typeof (p = e) != "function" || p.prototype && p.prototype.isReactComponent || !t) return e;
    var h = e(t);
    return In(h, t, n, r);
  }
  var p;
  return e instanceof rc ? n ? (e.inject(n, r), e.getName(r)) : e : bi(e) ? function b(w, C) {
    var L, O, k = [];
    for (var N in w) w.hasOwnProperty(N) && !Ko(w[N]) && (Array.isArray(w[N]) && w[N].isCss || nr(w[N]) ? k.push(Go(N) + ":", w[N], ";") : bi(w[N]) ? k.push.apply(k, b(w[N], N)) : k.push(Go(N) + ": " + (L = N, (O = w[N]) == null || typeof O == "boolean" || O === "" ? "" : typeof O != "number" || O === 0 || L in bl || L.startsWith("--") ? String(O).trim() : O + "px") + ";"));
    return C ? [C + " {"].concat(k, ["}"]) : k;
  }(e) : e.toString();
}
var Zo = function(e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function lc(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  return nr(e) || bi(e) ? Zo(In(Uo(Fr, [e].concat(n)))) : n.length === 0 && e.length === 1 && typeof e[0] == "string" ? e : Zo(In(Uo(e, n)));
}
var cc = function(e, t, n) {
  return n === void 0 && (n = rn), e.theme !== n.theme && e.theme || t || n.theme;
}, uc = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, dc = /(^-|-$)/g;
function hi(e) {
  return e.replace(uc, "-").replace(dc, "");
}
var fc = function(e) {
  return wi(Ds(e) >>> 0);
};
function Cr(e) {
  return typeof e == "string" && rt.env.NODE_ENV === "production";
}
var ki = function(e) {
  return typeof e == "function" || typeof e == "object" && e !== null && !Array.isArray(e);
}, pc = function(e) {
  return e !== "__proto__" && e !== "constructor" && e !== "prototype";
};
function hc(e, t, n) {
  var r = e[n];
  ki(t) && ki(r) ? Bs(r, t) : e[n] = t;
}
function Bs(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  for (var o = 0, a = n; o < a.length; o++) {
    var d = a[o];
    if (ki(d)) for (var m in d) pc(m) && hc(e, d[m], m);
  }
  return e;
}
var zs = He.createContext();
zs.Consumer;
var mi = {};
function Hs(e, t, n) {
  var r = Ui(e), o = !Cr(e), a = t.attrs, d = a === void 0 ? Fr : a, m = t.componentId, h = m === void 0 ? function(D, V) {
    var W = typeof D != "string" ? "sc" : hi(D);
    mi[W] = (mi[W] || 0) + 1;
    var M = W + "-" + fc("5.3.11" + W + mi[W]);
    return V ? V + "-" + M : M;
  }(t.displayName, t.parentComponentId) : m, p = t.displayName, b = p === void 0 ? function(D) {
    return Cr(D) ? "styled." + D : "Styled(" + qo(D) + ")";
  }(e) : p, w = t.displayName && t.componentId ? hi(t.displayName) + "-" + t.componentId : t.componentId || h, C = r && e.attrs ? Array.prototype.concat(e.attrs, d).filter(Boolean) : d, L = t.shouldForwardProp;
  r && e.shouldForwardProp && (L = t.shouldForwardProp ? function(D, V, W) {
    return e.shouldForwardProp(D, V, W) && t.shouldForwardProp(D, V, W);
  } : e.shouldForwardProp);
  var O, k = new Kl(n, w, r ? e.componentStyle : void 0), N = k.isStatic && d.length === 0, j = function(D, V) {
    return function(W, M, J, se) {
      var Oe = W.attrs, Fe = W.componentStyle, Ve = W.defaultProps, ke = W.foldedComponentIds, ve = W.shouldForwardProp, Q = W.styledComponentId, he = W.target, Ne = function(U, A, ue) {
        U === void 0 && (U = rn);
        var z = Wt({}, A, { theme: U }), pe = {};
        return ue.forEach(function(re) {
          var ie, Z, de, ye = re;
          for (ie in nr(ye) && (ye = ye(z)), ye) z[ie] = pe[ie] = ie === "className" ? (Z = pe[ie], de = ye[ie], Z && de ? Z + " " + de : Z || de) : ye[ie];
        }), [z, pe];
      }(cc(M, Bi(zs), Ve) || rn, M, Oe), dt = Ne[0], $e = Ne[1], Be = function(U, A, ue, z) {
        var pe = tc(), re = nc(), ie = A ? U.generateAndInjectStyles(rn, pe, re) : U.generateAndInjectStyles(ue, pe, re);
        return ie;
      }(Fe, se, dt), qe = J, ft = $e.$as || M.$as || $e.as || M.as || he, be = Cr(ft), Y = $e !== M ? Wt({}, M, {}, $e) : M, B = {};
      for (var q in Y) q[0] !== "$" && q !== "as" && (q === "forwardedAs" ? B.as = Y[q] : (ve ? ve(q, Bo, ft) : !be || Bo(q)) && (B[q] = Y[q]));
      return M.style && $e.style !== M.style && (B.style = Wt({}, M.style, {}, $e.style)), B.className = Array.prototype.concat(ke, Q, Be !== Q ? Be : null, M.className, $e.className).filter(Boolean).join(" "), B.ref = qe, Aa(ft, B);
    }(O, D, V, N);
  };
  return j.displayName = b, (O = He.forwardRef(j)).attrs = C, O.componentStyle = k, O.displayName = b, O.shouldForwardProp = L, O.foldedComponentIds = r ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : Fr, O.styledComponentId = w, O.target = r ? e.target : e, O.withComponent = function(D) {
    var V = t.componentId, W = function(J, se) {
      if (J == null) return {};
      var Oe, Fe, Ve = {}, ke = Object.keys(J);
      for (Fe = 0; Fe < ke.length; Fe++) Oe = ke[Fe], se.indexOf(Oe) >= 0 || (Ve[Oe] = J[Oe]);
      return Ve;
    }(t, ["componentId"]), M = V && V + "-" + (Cr(D) ? D : hi(qo(D)));
    return Hs(D, Wt({}, W, { attrs: C, componentId: M }), n);
  }, Object.defineProperty(O, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(D) {
    this._foldedDefaultProps = r ? Bs({}, e.defaultProps, D) : D;
  } }), Object.defineProperty(O, "toString", { value: function() {
    return "." + O.styledComponentId;
  } }), o && Pl(O, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0, withComponent: !0 }), O;
}
var jt = function(e) {
  return function t(n, r, o) {
    if (o === void 0 && (o = rn), !js.isValidElementType(r)) return ir(1, String(r));
    var a = function() {
      return n(r, o, lc.apply(void 0, arguments));
    };
    return a.withConfig = function(d) {
      return t(n, r, Wt({}, o, {}, d));
    }, a.attrs = function(d) {
      return t(n, r, Wt({}, o, { attrs: Array.prototype.concat(o.attrs, d).filter(Boolean) }));
    }, a;
  }(Hs, e);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e) {
  jt[e] = jt(e);
});
const mc = jt.div`
  &.sticky {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    &.with-header {
      top: ${({ requiresAltMenuSpacing: e }) => e ? "112px" : "142px"};
      @media (max-width: 992px) {
        top: 110px;
      }
    }
  }
  .mobile-menu-toggler {
    background-color: transparent;
    border: none;
    cursor: default;
    h4 {
      align-items: center;
    }
    i {
      transition: all 0.3s;
    }
  }
  .show-menu i {
    transform: rotate(-180deg);
  }
  .nav-link {
    border: none;
    background-color: #ffffff;
    i {
      width: 2rem !important;
      text-align: center !important;
    }
  }
`, Pr = "On This Page", gc = {
  event: "collapse",
  name: "onclick",
  type: "click",
  text: Pr
}, Vs = ({
  items: e,
  firstElementId: t,
  focusFirstFocusableElement: n = !1
}) => {
  const { isReact: r, isBootstrap: o } = kn(), a = on(null), d = Ba("(max-width: 991px)"), [m, h] = Ze({
    hasHeader: !1,
    hasAltMenuSpacing: !1,
    containerClass: "container-xl",
    activeContainer: "",
    showMenu: !1,
    sticky: !1
  }), p = d ? 110 : 142, b = () => {
    var J;
    const j = {}, D = window.scrollY, V = (J = document.getElementById(t)) == null ? void 0 : J.getBoundingClientRect().top, W = 103;
    V >= 0 && (j.sticky = !1, j.activeContainer = ""), D > a.current.getBoundingClientRect().top && (j.sticky = !0);
    const M = m.hasHeader ? p + W : W;
    e == null || e.forEach(({ targetIdName: se }) => {
      const Oe = document.getElementById(se), Fe = (Oe == null ? void 0 : Oe.getBoundingClientRect().top) - M, Ve = (Oe == null ? void 0 : Oe.getBoundingClientRect().bottom) - M;
      Fe < 0 && Ve > 0 && (j.activeContainer = se);
    }), h((se) => ({
      ...se,
      ...j
    }));
  }, w = () => {
    yi(b, 150), xi(b, 150);
  }, C = () => !!(document.getElementById("asu-header") || document.getElementById("headerContainer") || document.getElementById("asuHeader")), L = () => !!document.getElementById(
    "degreeDetailPageContainer"
  );
  function O(j = null) {
    if (j === null) return m.containerClass;
    const D = Object.values(j.classList).filter(
      (V) => [
        "container-sm",
        "container-md",
        "container",
        "container-lg",
        "container-xl",
        "container-fluid"
      ].includes(V)
    );
    return D.length > 0 ? D.join(" ") : O(j.parentElement);
  }
  lt(() => {
    const j = document.getElementById(t) || null, D = {
      hasHeader: C(),
      hasAltMenuSpacing: L(),
      containerClass: O(j)
    };
    h((V) => ({
      ...V,
      ...D
    }));
  }, []), lt(() => (window == null || window.addEventListener("scroll", w), () => window.removeEventListener("scroll", w)), [m.hasHeader]);
  const k = (j) => {
    var M, J;
    const D = window.scrollY - (m.hasHeader ? p + 100 : 100), V = d ? 410 : 90;
    let W = ((M = document.getElementById(j)) == null ? void 0 : M.getBoundingClientRect().top) + D;
    a.current.classList.contains("sticky") || (W -= V), n && ((J = cl(`#${j}`)) == null || J.focus()), window.scrollTo({ top: W, behavior: "smooth" });
  }, N = () => {
    h((j) => ({
      ...j,
      showMenu: !j.showMenu
    }));
  };
  return (e == null ? void 0 : e.length) > 0 && /* @__PURE__ */ f.jsx(
    mc,
    {
      requiresAltMenuSpacing: m.hasAltMenuSpacing,
      ref: a,
      id: "uds-anchor-menu",
      className: we(
        "uds-anchor-menu",
        "uds-anchor-menu-expanded-lg",
        "mb-4",
        {
          sticky: m.sticky,
          "with-header": m.hasHeader
        }
      ),
      style: m.showMenu ? { borderBottom: 0 } : {},
      children: /* @__PURE__ */ f.jsxs("div", { className: `${m.containerClass} uds-anchor-menu-wrapper`, children: [
        d ? /* @__PURE__ */ f.jsx(
          tt,
          {
            gaData: {
              ...gc,
              action: m.showMenu ? "close" : "open"
            },
            children: /* @__PURE__ */ f.jsx(
              "button",
              {
                className: we("mobile-menu-toggler", {
                  "show-menu": m.showMenu
                }),
                type: "button",
                onClick: N,
                "data-bs-toggle": "collapse",
                "data-bs-target": "#collapseAnchorMenu",
                "aria-controls": "collapseAnchorMenu",
                children: /* @__PURE__ */ f.jsxs("h4", { children: [
                  Pr,
                  ":",
                  /* @__PURE__ */ f.jsx("i", { className: "fas fa-chevron-down" })
                ] })
              }
            )
          }
        ) : /* @__PURE__ */ f.jsxs("h4", { children: [
          Pr,
          ":"
        ] }),
        /* @__PURE__ */ f.jsx(
          "div",
          {
            "data-testid": "anchor-menu-container",
            id: "collapseAnchorMenu",
            className: we("card", "card-body", "collapse", {
              show: m.showMenu
            }),
            children: /* @__PURE__ */ f.jsx(
              "nav",
              {
                "data-testid": "anchor-menu",
                className: "nav",
                "aria-label": Pr,
                children: e == null ? void 0 : e.map((j) => (
                  // Use this package button
                  // @ts-ignore
                  /* @__PURE__ */ f.jsx(
                    wn,
                    {
                      "data-testid": `anchor-item-${j.targetIdName}`,
                      classes: we("nav-link", {
                        active: m.activeContainer === j.targetIdName
                      }).split(" "),
                      ariaLabel: j.text,
                      label: j.text,
                      icon: j.icon,
                      onClick: r && (() => k(j.targetIdName)),
                      href: o && `#${j.targetIdName}`
                    },
                    j.targetIdName
                  )
                ))
              }
            )
          }
        )
      ] })
    }
  );
};
Vs.propTypes = {
  /**
   * Anchor menu items
   */
  items: l.arrayOf(
    l.shape({
      text: l.string.isRequired,
      targetIdName: l.string.isRequired,
      icon: l.arrayOf(l.string)
    })
  ).isRequired,
  /**
   * First next sibling element of the anchor menu
   */
  firstElementId: l.string.isRequired,
  /**
   * If true it focus the first focusable element into the section
   * If false it focus the next menu item into the nav bar
   */
  focusFirstFocusableElement: l.bool
};
var Ti = function() {
  return Ti = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Ti.apply(this, arguments);
}, vc = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function Vr(e) {
  var t = function(n) {
    var r = n.bgStyle, o = n.borderRadius, a = n.iconFillColor, d = n.round, m = n.size, h = vc(n, ["bgStyle", "borderRadius", "iconFillColor", "round", "size"]);
    return He.createElement(
      "svg",
      Ti({ viewBox: "0 0 64 64", width: m, height: m }, h),
      d ? He.createElement("circle", { cx: "32", cy: "32", r: "31", fill: e.color, style: r }) : He.createElement("rect", { width: "64", height: "64", rx: o, ry: o, fill: e.color, style: r }),
      He.createElement("path", { d: e.path, fill: a })
    );
  };
  return t.defaultProps = {
    bgStyle: {},
    borderRadius: 0,
    iconFillColor: "white",
    size: 64
  }, t;
}
var yc = Vr({
  color: "#7f7f7f",
  path: "M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z"
});
function Wr(e) {
  var t = Object.entries(e).filter(function(n) {
    var r = n[1];
    return r != null;
  }).map(function(n) {
    var r = n[0], o = n[1];
    return "".concat(encodeURIComponent(r), "=").concat(encodeURIComponent(String(o)));
  });
  return t.length > 0 ? "?".concat(t.join("&")) : "";
}
var xc = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var a in o) Object.prototype.hasOwnProperty.call(o, a) && (r[a] = o[a]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Ht = function() {
  return Ht = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Ht.apply(this, arguments);
}, bc = function(e, t, n, r) {
  function o(a) {
    return a instanceof n ? a : new n(function(d) {
      d(a);
    });
  }
  return new (n || (n = Promise))(function(a, d) {
    function m(b) {
      try {
        p(r.next(b));
      } catch (w) {
        d(w);
      }
    }
    function h(b) {
      try {
        p(r.throw(b));
      } catch (w) {
        d(w);
      }
    }
    function p(b) {
      b.done ? a(b.value) : o(b.value).then(m, h);
    }
    p((r = r.apply(e, t || [])).next());
  });
}, wc = function(e, t) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, o, a, d;
  return d = { next: m(0), throw: m(1), return: m(2) }, typeof Symbol == "function" && (d[Symbol.iterator] = function() {
    return this;
  }), d;
  function m(p) {
    return function(b) {
      return h([p, b]);
    };
  }
  function h(p) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, o && (a = p[0] & 2 ? o.return : p[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, p[1])).done) return a;
      switch (o = 0, a && (p = [p[0] & 2, a.value]), p[0]) {
        case 0:
        case 1:
          a = p;
          break;
        case 4:
          return n.label++, { value: p[1], done: !1 };
        case 5:
          n.label++, o = p[1], p = [0];
          continue;
        case 7:
          p = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (p[0] === 6 || p[0] === 2)) {
            n = 0;
            continue;
          }
          if (p[0] === 3 && (!a || p[1] > a[0] && p[1] < a[3])) {
            n.label = p[1];
            break;
          }
          if (p[0] === 6 && n.label < a[1]) {
            n.label = a[1], a = p;
            break;
          }
          if (a && n.label < a[2]) {
            n.label = a[2], n.ops.push(p);
            break;
          }
          a[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      p = t.call(e, n);
    } catch (b) {
      p = [6, b], o = 0;
    } finally {
      r = a = 0;
    }
    if (p[0] & 5) throw p[1];
    return { value: p[0] ? p[1] : void 0, done: !0 };
  }
}, Ws = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}, Sc = function(e) {
  return !!e && (typeof e == "object" || typeof e == "function") && typeof e.then == "function";
}, kc = function(e, t) {
  return {
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - e / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - t / 2
  };
}, Tc = function(e, t) {
  return {
    top: (window.screen.height - t) / 2,
    left: (window.screen.width - e) / 2
  };
};
function _c(e, t, n) {
  var r = t.height, o = t.width, a = Ws(t, ["height", "width"]), d = Ht({ height: r, width: o, location: "no", toolbar: "no", status: "no", directories: "no", menubar: "no", scrollbars: "yes", resizable: "no", centerscreen: "yes", chrome: "yes" }, a), m = window.open(e, "", Object.keys(d).map(function(p) {
    return "".concat(p, "=").concat(d[p]);
  }).join(", "));
  if (n)
    var h = window.setInterval(function() {
      try {
        (m === null || m.closed) && (window.clearInterval(h), n(m));
      } catch (p) {
        console.error(p);
      }
    }, 1e3);
  return m;
}
var Ec = (
  /** @class */
  function(e) {
    xc(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.openShareDialog = function(r) {
        var o = n.props, a = o.onShareWindowClose, d = o.windowHeight, m = d === void 0 ? 400 : d, h = o.windowPosition, p = h === void 0 ? "windowCenter" : h, b = o.windowWidth, w = b === void 0 ? 550 : b, C = Ht({ height: m, width: w }, p === "windowCenter" ? kc(w, m) : Tc(w, m));
        _c(r, C, a);
      }, n.handleClick = function(r) {
        return bc(n, void 0, void 0, function() {
          var o, a, d, m, h, p, b, w, C, L;
          return wc(this, function(O) {
            switch (O.label) {
              case 0:
                return o = this.props, a = o.beforeOnClick, d = o.disabled, m = o.networkLink, h = o.onClick, p = o.url, b = o.openShareDialogOnClick, w = o.opts, C = m(p, w), d ? [
                  2
                  /*return*/
                ] : (r.preventDefault(), a ? (L = a(), Sc(L) ? [4, L] : [3, 2]) : [3, 2]);
              case 1:
                O.sent(), O.label = 2;
              case 2:
                return b && this.openShareDialog(C), h && h(r, C), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, n;
    }
    return t.prototype.render = function() {
      var n = this.props;
      n.beforeOnClick;
      var r = n.children, o = n.className, a = n.disabled, d = n.disabledStyle, m = n.forwardedRef;
      n.networkLink;
      var h = n.networkName;
      n.onShareWindowClose, n.openShareDialogOnClick, n.opts;
      var p = n.resetButtonStyle, b = n.style;
      n.url, n.windowHeight, n.windowPosition, n.windowWidth;
      var w = Ws(n, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]), C = we("react-share__ShareButton", {
        "react-share__ShareButton--disabled": !!a,
        disabled: !!a
      }, o), L = Ht(Ht(p ? { backgroundColor: "transparent", border: "none", padding: 0, font: "inherit", color: "inherit", cursor: "pointer" } : {}, b), a && d);
      return He.createElement("button", Ht({}, w, { "aria-label": w["aria-label"] || h, className: C, onClick: this.handleClick, ref: m, style: L }), r);
    }, t.defaultProps = {
      disabledStyle: { opacity: 0.6 },
      openShareDialogOnClick: !0,
      resetButtonStyle: !0
    }, t;
  }(ja)
), Br = function() {
  return Br = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Br.apply(this, arguments);
};
function Ur(e, t, n, r) {
  function o(a, d) {
    var m = n(a), h = Br({}, a), p = Object.keys(m);
    return p.forEach(function(b) {
      delete h[b];
    }), He.createElement(Ec, Br({}, r, h, { forwardedRef: d, networkName: e, networkLink: t, opts: n(a) }));
  }
  return o.displayName = "ShareButton-".concat(e), $i(o);
}
function Cc(e, t) {
  var n = t.subject, r = t.body, o = t.separator;
  return "mailto:" + Wr({ subject: n, body: r ? r + o + e : e });
}
var Rc = Ur("email", Cc, function(e) {
  return {
    subject: e.subject,
    body: e.body,
    separator: e.separator || " "
  };
}, {
  openShareDialogOnClick: !1,
  onClick: function(e, t) {
    window.location.href = t;
  }
}), Jo = Vr({
  color: "#3b5998",
  path: "M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"
}), Oc = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var a in o) Object.prototype.hasOwnProperty.call(o, a) && (r[a] = o[a]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Ac = (
  /** @class */
  function(e) {
    Oc(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.name = "AssertionError", r;
    }
    return t;
  }(Error)
);
function tr(e, t) {
  if (!e)
    throw new Ac(t);
}
function jc(e, t) {
  var n = t.quote, r = t.hashtag;
  return tr(e, "facebook.url"), "https://www.facebook.com/sharer/sharer.php" + Wr({
    u: e,
    quote: n,
    hashtag: r
  });
}
var Qo = Ur("facebook", jc, function(e) {
  return {
    quote: e.quote,
    hashtag: e.hashtag
  };
}, {
  windowWidth: 550,
  windowHeight: 400
}), es = Vr({
  color: "#007fb1",
  path: "M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z"
});
function Nc(e, t) {
  var n = t.title, r = t.summary, o = t.source;
  return tr(e, "linkedin.url"), "https://linkedin.com/shareArticle" + Wr({ url: e, mini: "true", title: n, summary: r, source: o });
}
var ts = Ur("linkedin", Nc, function(e) {
  var t = e.title, n = e.summary, r = e.source;
  return { title: t, summary: n, source: r };
}, {
  windowWidth: 750,
  windowHeight: 600
}), ns = Vr({
  color: "#00aced",
  path: "M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z"
});
function Pc(e, t) {
  var n = t.title, r = t.via, o = t.hashtags, a = o === void 0 ? [] : o, d = t.related, m = d === void 0 ? [] : d;
  return tr(e, "twitter.url"), tr(Array.isArray(a), "twitter.hashtags is not an array"), tr(Array.isArray(m), "twitter.related is not an array"), "https://twitter.com/share" + Wr({
    url: e,
    text: n,
    via: r,
    hashtags: a.length > 0 ? a.join(",") : void 0,
    related: m.length > 0 ? m.join(",") : void 0
  });
}
var rs = Ur("twitter", Pc, function(e) {
  return {
    hashtags: e.hashtags,
    title: e.title,
    via: e.via,
    related: e.related
  };
}, {
  windowWidth: 550,
  windowHeight: 400
});
function _i(e) {
  "@babel/helpers - typeof";
  return _i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _i(e);
}
var Ic;
function Ei() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ic;
  return t ? e.split(" ").map(function(n) {
    return t[n] || n;
  }).join(" ") : e;
}
var Lc = (typeof window > "u" ? "undefined" : _i(window)) === "object" && window.Element || function() {
};
function Mc(e, t, n) {
  if (!(e[t] instanceof Lc))
    return new Error("Invalid prop `" + t + "` supplied to `" + n + "`. Expected prop to be an instance of Element. Validation failed.");
}
l.oneOfType([l.string, l.func, Mc, l.shape({
  current: l.any
})]);
var Ci = l.oneOfType([l.func, l.string, l.shape({
  $$typeof: l.symbol,
  render: l.func
}), l.arrayOf(l.oneOfType([l.func, l.string, l.shape({
  $$typeof: l.symbol,
  render: l.func
})]))]), Dc = ["className", "listClassName", "cssModule", "children", "tag", "listTag", "aria-label"];
function Ri() {
  return Ri = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ri.apply(this, arguments);
}
function Fc(e, t) {
  if (e == null) return {};
  var n = $c(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      r = a[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function $c(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var Bc = {
  /** Aria label */
  "aria-label": l.string,
  /** Pass children so this component can wrap them */
  children: l.node,
  /** Add custom class */
  className: l.string,
  /** Change existing className with a new className */
  cssModule: l.object,
  /** Add custom class to list tag */
  listClassName: l.string,
  /** Set a custom element for list tag */
  listTag: Ci,
  /** Set a custom element for this component */
  tag: Ci
};
function Us(e) {
  var t = e.className, n = e.listClassName, r = e.cssModule, o = e.children, a = e.tag, d = a === void 0 ? "nav" : a, m = e.listTag, h = m === void 0 ? "ol" : m, p = e["aria-label"], b = p === void 0 ? "breadcrumb" : p, w = Fc(e, Dc), C = Ei(we(t), r), L = Ei(we("breadcrumb", n), r);
  return /* @__PURE__ */ He.createElement(d, Ri({}, w, {
    className: C,
    "aria-label": b
  }), /* @__PURE__ */ He.createElement(h, {
    className: L
  }, o));
}
Us.propTypes = Bc;
var zc = ["className", "cssModule", "active", "tag"];
function Oi() {
  return Oi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Oi.apply(this, arguments);
}
function Hc(e, t) {
  if (e == null) return {};
  var n = Vc(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      r = a[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Vc(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var Wc = {
  /** Adds a visual "active" state to a Breadcrumb Item */
  active: l.bool,
  /** Add custom class to the element */
  className: l.string,
  /** Change existing className with a new className */
  cssModule: l.object,
  /** Set a custom element for this component */
  tag: Ci
};
function Ai(e) {
  var t = e.className, n = e.cssModule, r = e.active, o = e.tag, a = o === void 0 ? "li" : o, d = Hc(e, zc), m = Ei(we(t, r ? "active" : !1, "breadcrumb-item"), n);
  return /* @__PURE__ */ He.createElement(a, Oi({}, d, {
    className: m,
    "aria-current": r ? "page" : void 0
  }));
}
Ai.propTypes = Wc;
const Uc = jt.div`
  &.news-container h2 {
    font-size: 48px;
  }

  &.event-container h2 {
    font-size: 40px;
  }

  &.news-container img,
  &.event-container img {
    width: 100%;
    max-width: fit-content;
  }

  &.wrapper-container h4 {
    margin-top: 0;
  }

  &.wrapper-container {
    max-width: 1300px;
    margin: 0 auto;
    padding: 0 10%;
  }

  &.event-container.wrapper-container {
    max-width: 1500px;
  }

  &.news-container {
    background: #fff;
  }

  ol.breadcrumb {
    padding: 0;
    margin: 0;
  }

  ol.breadcrumb > li {
    margin-bottom: 0;
  }

  .article-social-media {
    margin-bottom: 24px;
  }

  .react-share__ShareButton {
    margin-right: 12px;
  }

  i.news-date {
    display: inline-block;
    margin-bottom: 24px;
  }

  .highlight-gold {
    box-shadow:
      -0.15em 0 0 #ffc627,
      0.15em 0 0 #ffc627;
    background: #ffc627;
  }

  .author {
    display: inline-block;
    margin-top: 30px;
    margin-left: -7px;
    padding: 0 6px;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  .icon-bg {
    display: inline-block;
    position: relative;
    padding: 1px 3.5px;
    background-color: maroon;
    margin-right: 4px;
    border-radius: 4px;
    color: white;
    font-size: 0.65rem;
  }

  .uds-button {
    margin-top: 17px;
    padding: 0;
  }

  .author-title {
    max-width: 250px;
    margin-top: 10px;
    margin-bottom: 11px;
    font-size: 16px;
  }

  .author-contact {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 500;
  }

  ol.breadcrumb a {
    text-decoration: none;
  }

  i.fa-calendar,
  i.fa-map-marker-alt {
    font-size: 1.17rem;
    margin-right: 8px;
  }

  .event-author {
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  .event-author-title {
    margin-top: 4px;
  }

  .event-author-info {
    margin-top: 24px;
  }
`, qc = jt.div`
  border-top: 1px solid black;
  h4 {
    margin-top: 0;
  }
  .react-share__ShareButton {
    margin-right: 24px;
  }
`, qs = ({
  type: e = "news",
  articleUrl: t,
  publicationDate: n,
  title: r,
  body: o,
  authorEmail: a,
  authorName: d,
  authorPhone: m,
  authorTitle: h,
  breadcrumbs: p,
  calendarUrl: b,
  eventLocation: w,
  eventTime: C,
  headerImageUrl: L,
  registrationUrl: O,
  zoomUrl: k
}) => {
  const N = we("col", "col-12", {
    "col-lg-8": e === "event" && (O || k || b)
  }), j = () => O ? /* @__PURE__ */ f.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ f.jsx(wn, { color: "maroon", href: O, label: "Register" }) }) : /* @__PURE__ */ f.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ f.jsx(wn, { color: "maroon", href: k, label: "Attend on Zoom" }) }), D = () => /* @__PURE__ */ f.jsx("div", { className: "row pb-2", "data-testid": "author-info", children: /* @__PURE__ */ f.jsxs("div", { className: "col col-12", children: [
    /* @__PURE__ */ f.jsx("div", { className: "author highlight-gold", children: d }),
    h && /* @__PURE__ */ f.jsx("div", { className: "author-title", children: h }),
    a && /* @__PURE__ */ f.jsxs("div", { className: "author-contact", children: [
      /* @__PURE__ */ f.jsx("span", { className: "icon-bg", children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-envelope" }) }),
      /* @__PURE__ */ f.jsx("a", { href: `mailto: ${a}`, children: a })
    ] }),
    m && /* @__PURE__ */ f.jsxs("div", { className: "author-contact", children: [
      /* @__PURE__ */ f.jsx("span", { className: "icon-bg", children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-phone" }) }),
      /* @__PURE__ */ f.jsx("a", { href: `tel: ${m}`, children: m })
    ] })
  ] }) }), V = () => /* @__PURE__ */ f.jsxs(
    qc,
    {
      className: "row row-spaced mt-3 pt-6 pb-2 event-info",
      "data-testid": "event-info",
      children: [
        /* @__PURE__ */ f.jsxs("div", { className: "col col-lg-4 col-md-6 col-12", children: [
          /* @__PURE__ */ f.jsx("h4", { children: "For more information contact:" }),
          /* @__PURE__ */ f.jsx("div", { className: "event-author", children: d }),
          /* @__PURE__ */ f.jsx("div", { className: "event-author-title", children: h }),
          (a || m) && /* @__PURE__ */ f.jsxs("div", { className: "event-author-info", children: [
            a && /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("a", { href: `mailto: ${a}`, children: a }) }),
            m && /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("a", { href: `tel: ${m}`, children: m }) })
          ] })
        ] }),
        /* @__PURE__ */ f.jsxs("div", { className: "col col-lg-4 col-md-6 col-12", children: [
          /* @__PURE__ */ f.jsx("h4", { children: "Share this event:" }),
          /* @__PURE__ */ f.jsxs("div", { className: "article-social-media", children: [
            /* @__PURE__ */ f.jsx(Qo, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
              Jo,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" }
              }
            ) }),
            /* @__PURE__ */ f.jsx(rs, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
              ns,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" }
              }
            ) }),
            /* @__PURE__ */ f.jsx(Rc, { url: a, quote: r, children: /* @__PURE__ */ f.jsx(
              yc,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" }
              }
            ) }),
            /* @__PURE__ */ f.jsx(ts, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
              es,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" }
              }
            ) })
          ] })
        ] })
      ]
    }
  ), W = () => /* @__PURE__ */ f.jsxs("div", { className: "col col-12 col-lg-4 col-md-6", children: [
    /* @__PURE__ */ f.jsxs("h4", { children: [
      /* @__PURE__ */ f.jsx("i", { className: "fas fa-map-marker-alt" }),
      "Location:"
    ] }),
    /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: xt(w) }),
    O && k && /* @__PURE__ */ f.jsx("a", { href: k, children: "Attend on Zoom" })
  ] }), M = (J) => /* @__PURE__ */ f.jsx(
    Ai,
    {
      active: J.active,
      tag: "li",
      className: "breadcrumb-item",
      children: /* @__PURE__ */ f.jsx(Ai, { tag: "a", href: J.url, children: J.title })
    },
    J.title
  );
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    L && e !== "event" && /* @__PURE__ */ f.jsx(
      "div",
      {
        "data-testid": "uds-hero",
        className: "uds-hero uds-hero-md",
        style: {
          // @ts-ignore
          "--color1": "#19191900",
          "--color2": "#191919c9",
          // moved colors to variable because hex color in linear-gradient breaks react
          backgroundImage: `linear-gradient(180deg, var(--color1) 0%, var(--color2) 100%), url(${L})`
        }
      }
    ),
    /* @__PURE__ */ f.jsxs(Uc, { className: `container ${e}-container wrapper-container`, children: [
      p && /* @__PURE__ */ f.jsx("div", { className: "row pt-4", "data-testid": "breadcrumbs", children: /* @__PURE__ */ f.jsx("div", { className: "col col-12", children: /* @__PURE__ */ f.jsx(Us, { listClassName: "breadcrumb", children: p.map((J) => M(J)) }) }) }),
      /* @__PURE__ */ f.jsxs("div", { className: "row pb-2 pt-3", children: [
        /* @__PURE__ */ f.jsx("div", { className: N, children: /* @__PURE__ */ f.jsx("h2", { "data-testid": "title", children: r }) }),
        e === "event" && /* @__PURE__ */ f.jsxs("div", { className: "col col-lg-4 col-xs-12", children: [
          (O || k) && j(),
          b && /* @__PURE__ */ f.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ f.jsx(
            wn,
            {
              color: "gray",
              size: "small",
              href: b,
              label: "Add to calendar"
            }
          ) })
        ] })
      ] }),
      e === "event" ? /* @__PURE__ */ f.jsxs("div", { className: "row row-spaced pt-3 mb-2", children: [
        C && /* @__PURE__ */ f.jsxs("div", { className: "col col-lg-4 col-md-6 col-sm-12", children: [
          /* @__PURE__ */ f.jsxs("h4", { children: [
            /* @__PURE__ */ f.jsx("i", { className: "far fa-calendar" }),
            "Date and time:"
          ] }),
          /* @__PURE__ */ f.jsx(
            "div",
            {
              dangerouslySetInnerHTML: xt(C)
            }
          )
        ] }),
        (O && k || w) && W()
      ] }) : /* @__PURE__ */ f.jsx("div", { className: "row row-spaced pt-2", children: /* @__PURE__ */ f.jsxs("div", { className: "col col-12", children: [
        /* @__PURE__ */ f.jsxs("div", { className: "article-social-media", children: [
          /* @__PURE__ */ f.jsx(Qo, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
            Jo,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" }
            }
          ) }),
          /* @__PURE__ */ f.jsx(rs, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
            ns,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" }
            }
          ) }),
          /* @__PURE__ */ f.jsx(ts, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
            es,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" }
            }
          ) })
        ] }),
        n && /* @__PURE__ */ f.jsx("i", { className: "news-date", children: n })
      ] }) }),
      /* @__PURE__ */ f.jsx("div", { className: "row", children: /* @__PURE__ */ f.jsx(
        "div",
        {
          className: "col col-12",
          dangerouslySetInnerHTML: xt(o),
          "data-testid": "body"
        }
      ) }),
      e === "news" && D(),
      e === "event" && V()
    ] })
  ] });
};
qs.propTypes = {
  /**
   * Type of article
   */
  type: l.oneOf(["event", "news"]),
  /**
   * This is the relative or absolute url to the full-page article
   */
  articleUrl: l.string.isRequired,
  /**
   * Date for the article
   */
  publicationDate: l.string.isRequired,
  /**
   * Title
   */
  title: l.string.isRequired,
  /**
   * Body content for the article
   */
  body: l.string.isRequired,
  /**
   * Article author email
   */
  authorEmail: l.string,
  /**
   * Article author full name
   */
  authorName: l.string.isRequired,
  /**
   * Article author phone number
   */
  authorPhone: l.string,
  /**
   * Article author title
   */
  authorTitle: l.string,
  /**
   * Breadcrumbs array
   */
  breadcrumbs: l.arrayOf(
    l.shape({
      title: l.string,
      url: l.string,
      active: l.bool
    })
  ),
  /**
   * URL for an "add to calendar" button
   */
  calendarUrl: l.string,
  /**
   * Article image
   */
  headerImageUrl: l.string,
  /**
   * Event location
   */
  eventLocation: l.string,
  /**
   * Event time
   */
  eventTime: l.string,
  /**
   * URL for a registation button
   */
  registrationUrl: l.string,
  /**
   * URL for a Zoom button
   */
  zoomUrl: l.string
};
const Yc = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Yi = ({
  color: e = "gray",
  icon: t = void 0,
  innerRef: n = void 0,
  onClick: r = void 0,
  size: o = "small",
  cardTitle: a = "",
  className: d,
  gaData: m,
  ...h
}) => {
  const p = () => {
    r == null || r();
  };
  return /* @__PURE__ */ f.jsx(
    tt,
    {
      gaData: {
        ...Yc,
        section: a,
        // @deprecated - remove at some point
        ...m,
        text: `${t == null ? void 0 : t[1]} icon`
      },
      children: /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          className: `btn btn-circle btn-circle-alt-${e} ${o === "large" && "btn-circle-large"} ${d}`,
          ref: n,
          "aria-label": "Close",
          onClick: p,
          ...h,
          children: /* @__PURE__ */ f.jsx("i", { className: `${t == null ? void 0 : t[0]} fa-${t == null ? void 0 : t[1]}` })
        }
      )
    }
  );
};
Yi.propTypes = {
  /**
    Color the button based on the background color
  */
  color: l.oneOf(["white", "gray", "black"]),
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: l.arrayOf(l.string),
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: l.oneOfType([
    l.object,
    l.func,
    l.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: l.func,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: l.string,
  /**
   * Google Analytics event data
   */
  gaData: Hi,
  /**
    Button size
  */
  size: l.oneOf(["large", "small"]),
  className: l.string
};
const Xc = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Xi = ({
  label: e = "",
  cardTitle: t = "",
  gaData: n,
  ariaLabel: r,
  color: o = "gray",
  disabled: a,
  element: d = "button",
  innerRef: m,
  href: h,
  onClick: p,
  ...b
}) => {
  const w = we("btn", "btn-tag", {
    "btn-tag-alt-white": o === "white",
    "btn-tag-alt-gray": o === "gray",
    "btn-tag-alt-dark": o === "dark",
    disabled: a
  });
  let C = d;
  return h && d === "button" && (C = "a"), /* @__PURE__ */ f.jsx(
    tt,
    {
      gaData: {
        ...Xc,
        section: t,
        // @deprecated - remove at some point
        ...n,
        text: e
      },
      children: /* @__PURE__ */ f.jsx(
        C,
        {
          type: C === "button" && p ? "button" : void 0,
          ...b,
          className: w,
          href: h,
          ref: m,
          onClick: p,
          "aria-label": r,
          children: e
        }
      )
    }
  );
};
Xi.propTypes = {
  /**
    Button tag label
  */
  label: l.string,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: l.string,
  /**
   * Google Analytics event data
   */
  gaData: Hi,
  /**
    ARIA label for accessibility
  */
  ariaLabel: l.string,
  /**
    Button background color
  */
  color: l.oneOf(["white", "gray", "dark"]),
  /**
    Disable the button?
  */
  disabled: l.bool,
  /**
    Pass in a Component to override default button element.
    For example: react-router Link
  */
  element: l.oneOfType([
    l.func,
    l.string,
    l.shape({ $$typeof: l.symbol, render: l.func }),
    l.arrayOf(
      l.oneOfType([
        l.func,
        l.string,
        l.shape({ $$typeof: l.symbol, render: l.func })
      ])
    )
  ]),
  /**
    Link target url; will cause button to be rendered as `<a>` link
  */
  href: l.string,
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: l.oneOfType([
    l.object,
    l.func,
    l.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: l.func
};
const Sn = ({
  src: e,
  alt: t,
  cssClasses: n,
  loading: r = "lazy",
  decoding: o = "async",
  dataTestId: a,
  fetchPriority: d = "auto",
  width: m,
  height: h,
  cardLink: p,
  title: b,
  caption: w,
  captionTitle: C,
  border: L,
  dropShadow: O
}) => {
  const k = {
    src: e,
    alt: t,
    loading: r,
    decoding: o,
    fetchpriority: d,
    // React attribute bug workaround
    ...(n == null ? void 0 : n.length) > 0 && { className: Ar(n) },
    ...a && { "data-testid": a },
    ...m && { width: m },
    ...h && { height: h }
  }, N = we("uds-img", {
    borderless: !L,
    "uds-img-drop-shadow": O
  }), j = (V) => {
    const W = V ? `${k.className} ${V}` : k.className;
    return p ? /* @__PURE__ */ f.jsxs("a", { href: p, children: [
      /* @__PURE__ */ f.jsx("img", { ...k, className: W }),
      /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: b })
    ] }) : /* @__PURE__ */ f.jsx("img", { ...k, className: W });
  }, D = () => /* @__PURE__ */ f.jsx("div", { className: N, children: /* @__PURE__ */ f.jsxs("figure", { className: "figure uds-figure", children: [
    j(),
    w && /* @__PURE__ */ f.jsxs("figcaption", { className: "figure-caption uds-figure-caption", children: [
      C && /* @__PURE__ */ f.jsx("h3", { children: C }),
      /* @__PURE__ */ f.jsx(
        "span",
        {
          className: "uds-caption-text",
          dangerouslySetInnerHTML: xt(w)
        }
      )
    ] })
  ] }) });
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: w ? D() : j(N) });
};
Sn.propTypes = {
  /**
   * Image source (We keep the same name as in the whole project)
   */
  src: l.string.isRequired,
  /**
   * Image alt text
   */
  alt: l.string.isRequired,
  /**
   * Array classes for the image
   */
  cssClasses: l.arrayOf(l.string),
  /**
   * Image loading mode
   */
  loading: l.oneOf(["lazy", "eager"]),
  /**
   * Image decoding mode
   */
  decoding: l.oneOf(["sync", "async", "auto"]),
  /**
   * Image fetch priority mode
   */
  fetchPriority: l.oneOf(["auto", "high", "low"]),
  /**
   * Width of the image
   */
  width: l.string,
  /**
   * Height of the image
   */
  height: l.string,
  dataTestId: l.string,
  cardLink: l.string,
  title: l.string,
  caption: l.string,
  captionTitle: l.string,
  border: l.bool,
  dropShadow: l.bool
};
const Gc = jt.div`
  &.cards-components a + &.cards-components a {
    margin-left: 5px;
  }
  .card-button {
    column-gap: 1rem;
  }
  .card-button .btn {
    margin: 0;
  }
`, Kc = (e) => /^[A-Z0-9._+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(e), Zc = (e) => !e.startsWith("https://") && !e.startsWith("http://") && Kc(e) ? `mailto:${e}` : e, Jc = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Vt = ({
  type: e = "default",
  width: t = "100%",
  horizontal: n = !1,
  image: r,
  imageAltText: o,
  title: a,
  icon: d,
  body: m,
  eventFormat: h = "stack",
  eventLocation: p,
  eventTime: b,
  buttons: w,
  linkLabel: C,
  linkUrl: L,
  tags: O,
  showBorders: k = !0,
  cardLink: N
}) => /* @__PURE__ */ f.jsx(
  Ys,
  {
    type: e,
    width: t,
    horizontal: n,
    image: r,
    imageAltText: o,
    title: a,
    icon: d,
    body: m,
    eventFormat: h,
    eventLocation: p,
    eventTime: b,
    buttons: w,
    linkLabel: C,
    linkUrl: L,
    tags: O,
    showBorders: k,
    cardLink: N
  }
);
Vt.propTypes = {
  /**
   * Type of card
   */
  type: l.oneOf(["default", "degree", "event", "news", "story"]),
  /**
   * Width of card
   */
  width: l.oneOf(["25%", "50%", "75%", "100%"]),
  /**
   * Enable horizontal mode
   */
  horizontal: l.bool,
  /**
   * Card title
   */
  title: l.string.isRequired,
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: l.arrayOf(l.string),
  /**
   * Card body content
   */
  body: l.string,
  /**
   * Event info format
   */
  eventFormat: l.oneOf(["stack", "inline"]),
  /**
   * Location
   */
  eventLocation: l.string,
  /**
   * Event start time
   */
  eventTime: l.string,
  /**
   * Card header image
   */
  image: l.string,
  /**
   * Card header image alt text
   */
  imageAltText: l.string,
  /**
   * Buttons
   */
  buttons: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: l.arrayOf(l.string),
      href: l.string,
      label: l.string,
      onClick: l.func,
      size: l.oneOf(["default", "small", "xsmall"]),
      target: l.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: l.string,
  linkUrl: l.string,
  /**
   * Tags
   */
  tags: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["white", "gray", "dark"]),
      href: l.string,
      label: l.string,
      onClick: l.func
    })
  ),
  /**
   * Remove card borders
   */
  showBorders: l.bool,
  /**
   * Card link
   */
  cardLink: l.string
};
const Ys = ({
  type: e = "default",
  width: t = "100%",
  horizontal: n = !1,
  image: r = "",
  imageAltText: o = "",
  title: a,
  icon: d = void 0,
  body: m = "",
  eventFormat: h = "stack",
  eventLocation: p = "",
  eventTime: b = "",
  buttons: w = void 0,
  linkLabel: C = void 0,
  linkUrl: L = void 0,
  tags: O = void 0,
  showBorders: k = !0,
  cardLink: N
}) => {
  const j = we("card", "cards-components", {
    "card-degree": e === "degree",
    "card-event": e === "event",
    "card-story": e === "story",
    [`w-${t.replace("%", "")}`]: t !== "100%",
    "card-horizontal": n,
    borderless: !k
  });
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsxs(Gc, { className: j, "data-testid": "card-container", children: [
    !!r && /* @__PURE__ */ f.jsx(
      Sn,
      {
        src: r,
        alt: o,
        dataTestId: "card-image",
        cssClasses: ["card-img-top"],
        cardLink: N,
        title: a
      }
    ),
    !r && d && /* @__PURE__ */ f.jsx(
      "i",
      {
        className: `${d == null ? void 0 : d[0]} fa-${d == null ? void 0 : d[1]} fa-2x card-icon-top`,
        "data-testid": "card-icon"
      }
    ),
    n ? /* @__PURE__ */ f.jsx("div", { className: "card-content-wrapper", children: /* @__PURE__ */ f.jsx(
      ji,
      {
        type: e,
        body: m,
        eventFormat: h,
        eventLocation: p,
        eventTime: b,
        title: a,
        buttons: w,
        linkLabel: C,
        linkUrl: L,
        tags: O,
        cardLink: N
      }
    ) }) : /* @__PURE__ */ f.jsx(
      ji,
      {
        type: e,
        body: m,
        eventFormat: h,
        eventLocation: p,
        eventTime: b,
        title: a,
        buttons: w,
        linkLabel: C,
        linkUrl: L,
        tags: O,
        cardLink: N
      }
    )
  ] }) });
};
Ys.propTypes = {
  type: l.oneOf(["default", "degree", "event", "news", "story"]),
  width: l.oneOf(["25%", "50%", "75%", "100%"]),
  horizontal: l.bool,
  title: l.string.isRequired,
  icon: l.arrayOf(l.string),
  // React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  body: l.string,
  eventFormat: l.oneOf(["stack", "inline"]),
  eventLocation: l.string,
  eventTime: l.string,
  image: l.string,
  imageAltText: l.string,
  buttons: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: l.arrayOf(l.string),
      href: l.string,
      label: l.string,
      onClick: l.func,
      size: l.oneOf(["default", "small", "xsmall"]),
      target: l.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: l.string,
  linkUrl: l.string,
  tags: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["white", "gray", "dark"]),
      href: l.string,
      label: l.string,
      onClick: l.func
    })
  ),
  showBorders: l.bool,
  cardLink: l.string
};
const ji = ({
  type: e = "default",
  body: t = "",
  eventFormat: n = "stack",
  eventLocation: r = "",
  eventTime: o = "",
  title: a,
  buttons: d = void 0,
  linkLabel: m = void 0,
  linkUrl: h = void 0,
  tags: p = void 0,
  cardLink: b
}) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  !!a && /* @__PURE__ */ f.jsx("div", { className: "card-header", "data-testid": "card-title", children: /* @__PURE__ */ f.jsx("h3", { className: "card-title", children: b ? /* @__PURE__ */ f.jsx("a", { href: b, children: a }) : a }) }),
  !!t && /* @__PURE__ */ f.jsx("div", { className: "card-body", "data-testid": "card-body", children: /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: xt(t) }) }),
  e === "event" && (o || r) && /* @__PURE__ */ f.jsx(
    Xs,
    {
      eventFormat: n,
      eventTime: o,
      eventLocation: r
    }
  ),
  d && /* @__PURE__ */ f.jsx("div", { className: "card-buttons", children: d.map((w) => /* @__PURE__ */ f.jsx(
    "div",
    {
      className: "card-button",
      "data-testid": "card-button",
      children: /* @__PURE__ */ f.jsx(
        wn,
        {
          ariaLabel: w.ariaLabel,
          color: w.color,
          icon: w.icon,
          href: w.href,
          label: w.label,
          onClick: w.onClick,
          size: w.size,
          target: w.target,
          cardTitle: a
        }
      )
    },
    `${w.label}-${w.href}`
  )) }),
  h && m && /* @__PURE__ */ f.jsx("div", { className: "card-link", "data-testid": "card-link", children: /* @__PURE__ */ f.jsx(
    tt,
    {
      gaData: {
        ...Jc,
        section: a,
        text: m
      },
      children: /* @__PURE__ */ f.jsx("a", { href: Zc(h), children: m })
    }
  ) }),
  p && /* @__PURE__ */ f.jsx("div", { className: "card-tags", "data-testid": "card-tags", children: p.map((w) => (
    // @ts-ignore
    /* @__PURE__ */ f.jsx(
      Xi,
      {
        ariaLabel: w.ariaLabel,
        color: w.color,
        href: w.href,
        label: w.label,
        onClick: w.onClick,
        cardTitle: a
      },
      `${w.label}-${w.href}`
    )
  )) })
] });
ji.propTypes = {
  type: l.oneOf(["default", "degree", "event", "news", "story"]),
  body: l.string,
  eventFormat: l.oneOf(["stack", "inline"]),
  eventLocation: l.string,
  eventTime: l.string,
  title: l.string.isRequired,
  buttons: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: l.arrayOf(l.string),
      href: l.string,
      label: l.string,
      onClick: l.func,
      size: l.oneOf(["default", "small", "xsmall"]),
      target: l.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: l.string,
  linkUrl: l.string,
  tags: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["white", "gray", "dark"]),
      href: l.string,
      label: l.string,
      onClick: l.func
    })
  ),
  cardLink: l.string
};
const Xs = ({
  eventFormat: e = "stack",
  eventLocation: t = "",
  eventTime: n = ""
}) => e === "inline" ? /* @__PURE__ */ f.jsxs("div", { className: "card-event-details", children: [
  n && /* @__PURE__ */ f.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("i", { className: "far fa-calendar" }) }),
    /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: xt(n) })
  ] }),
  t && /* @__PURE__ */ f.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-map-marker-alt" }) }),
    /* @__PURE__ */ f.jsx(
      "div",
      {
        dangerouslySetInnerHTML: xt(t)
      }
    )
  ] })
] }) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  n && /* @__PURE__ */ f.jsx("div", { className: "card-event-details", children: /* @__PURE__ */ f.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("i", { className: "far fa-calendar" }) }),
    /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: xt(n) })
  ] }) }),
  t && /* @__PURE__ */ f.jsx("div", { className: "card-event-details", children: /* @__PURE__ */ f.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-map-marker-alt" }) }),
    /* @__PURE__ */ f.jsx("span", { children: /* @__PURE__ */ f.jsx(
      "div",
      {
        dangerouslySetInnerHTML: xt(t)
      }
    ) })
  ] }) })
] });
Xs.propTypes = {
  eventFormat: l.oneOf(["stack", "inline"]),
  eventLocation: l.string,
  eventTime: l.string
};
const is = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, os = {
  OPEN: "open",
  CLOSE: "close"
}, Qc = {
  SMALL: "small"
}, Gs = (e) => e === Qc.SMALL, Ks = ({ imageSize: e, body: t, heading: n, readMoreLink: r }) => {
  const [o, a] = Ze(!1), d = Fi(), { isReact: m, isBootstrap: h } = kn(), p = `info-layer-${d}`, b = Gs(e), w = (C) => {
    (C.type === "click" || C.key === "Enter" || C.key === " ") && a(!o);
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: we("info-layer", { show: o }),
      "data-testid": "info-layer",
      id: p,
      children: /* @__PURE__ */ f.jsxs("div", { className: "content", children: [
        /* @__PURE__ */ f.jsxs(
          "div",
          {
            className: we("header", {
              closed: b && !o
            }),
            children: [
              b && /* @__PURE__ */ f.jsx("p", { dangerouslySetInnerHTML: xt(t) }),
              /* @__PURE__ */ f.jsx(
                tt,
                {
                  gaData: {
                    ...is,
                    text: "Expand ranking",
                    // TODO: for bootstrap can we use aria-expanded value of the button to populate the "action" field
                    action: o ? os.OPEN : os.CLOSE,
                    section: n
                  },
                  children: /* @__PURE__ */ f.jsxs(
                    "button",
                    {
                      "data-bs-toggle": h && "collapse",
                      "data-bs-target": h && `#${p}`,
                      onClick: m && w,
                      className: we("btn-expand", {
                        btn: b
                      }),
                      type: "button",
                      "aria-expanded": o,
                      "aria-controls": p,
                      children: [
                        b ? /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: n }) : /* @__PURE__ */ f.jsx("h4", { children: n }),
                        /* @__PURE__ */ f.jsx("i", { className: "fas fa-chevron-up" })
                      ]
                    }
                  )
                }
              )
            ]
          }
        ),
        !b && /* @__PURE__ */ f.jsx("p", { dangerouslySetInnerHTML: xt(t) }),
        r && /* @__PURE__ */ f.jsx(
          tt,
          {
            gaData: {
              ...is,
              section: n,
              text: "read more"
            },
            children: /* @__PURE__ */ f.jsxs("a", { href: r, className: "read-more", children: [
              "Read more ",
              /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: n }),
              /* @__PURE__ */ f.jsx(
                "span",
                {
                  className: "fas icon-small fa-arrow-right",
                  "aria-hidden": "true"
                }
              )
            ] })
          }
        )
      ] })
    }
  );
};
Ks.propTypes = {
  imageSize: l.oneOf(["small", "large"]),
  body: l.string.isRequired,
  heading: l.string.isRequired,
  readMoreLink: l.string
};
const Gi = ({
  imageSize: e = "large",
  image: t,
  imageAlt: n,
  heading: r,
  body: o,
  readMoreLink: a = "",
  citation: d
}) => {
  const m = Gs(e);
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: we("card-ranking", {
        "large-image": !m,
        "small-image": m
      }),
      children: [
        m ? /* @__PURE__ */ f.jsx("div", { className: "image-wrapper", children: /* @__PURE__ */ f.jsx(Sn, { src: t, alt: n, fetchPriority: "high" }) }) : /* @__PURE__ */ f.jsx(Sn, { src: t, alt: n, fetchPriority: "high" }),
        m && /* @__PURE__ */ f.jsxs("div", { className: "citation", children: [
          /* @__PURE__ */ f.jsx("h4", { children: r }),
          /* @__PURE__ */ f.jsxs("p", { children: [
            "— ",
            d
          ] })
        ] }),
        /* @__PURE__ */ f.jsx(
          Ks,
          {
            imageSize: e,
            body: o,
            heading: r,
            readMoreLink: a
          }
        )
      ]
    }
  );
};
Gi.propTypes = {
  /**
   * Size of ranking card
   */
  imageSize: l.oneOf(["small", "large"]).isRequired,
  /**
   * Ranking card image
   */
  image: l.string.isRequired,
  /**
   * Card header image alt text
   */
  imageAlt: l.string.isRequired,
  /**
   * Ranking card heading
   */
  heading: l.string.isRequired,
  /**
   * Ranking card body content
   */
  body: l.string.isRequired,
  /**
   * Link for read more
   */
  readMoreLink: l.string,
  /**
   * Ranking card citation content (Required for small size only)
   */
  citation: l.string
};
const eu = {
  1: "col-12",
  2: "col-12 col-md-6",
  3: "col-12 col-md-6 col-lg-4",
  4: "col-12 col-md-6 col-lg-4 col-xl-3"
}, Zs = ({ cards: e, cardType: t = "card", columns: n }) => {
  if (!e || e.length === 0)
    return null;
  let r;
  switch (t) {
    case "ranking":
      r = Gi;
      break;
    case "image":
      r = Sn;
      break;
    default:
      r = Vt;
      break;
  }
  const o = eu[n] || "col-12 col-md-auto";
  return /* @__PURE__ */ f.jsx("div", { className: "row", "data-testid": "card-arrangement", children: e.map((a, d) => /* @__PURE__ */ f.jsx(
    "div",
    {
      "data-testid": "uds-card-arrangement-content-container",
      className: `${a.horizontal ? "col-12 col-md-6" : o} mb-4`,
      children: /* @__PURE__ */ f.jsx(r, { ...a })
    },
    d
  )) });
};
Zs.propTypes = {
  /**
   * Array of card objects to render. Each object should contain props for the
   * Card or RankingCard component. Cards will wrap naturally based on their
   * intrinsic min/max widths.
   */
  cards: l.arrayOf(l.object).isRequired,
  /**
   * Type of card to render - either "card" (default), "ranking", or "image"
   */
  cardType: l.oneOf(["card", "ranking", "image"]),
  /**
   * Number of columns to display.
   */
  columns: l.oneOf([1, 2, 3, 4, "1", "2", "3", "4"])
};
var tu = /* @__PURE__ */ ((e) => (e.COPY = "copy", e))(tu || {});
const nu = ({ type: e }) => e == "copy" ? /* @__PURE__ */ f.jsx("hr", { className: "copy-divider" }) : /* @__PURE__ */ f.jsx("hr", {}), ru = jt.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    margin: 3px;
    border: 3px solid #1b1b1b;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #1b1b1b transparent transparent transparent;
  }
  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, iu = () => /* @__PURE__ */ f.jsxs(ru, { children: [
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {})
] }), ou = jt.section``, su = Na(null), au = ({
  defaultProps: e,
  dataSource: t,
  noFeedText: n,
  renderHeader: r,
  renderBody: o,
  dataTransformer: a,
  dataFilter: d,
  maxItems: m
}) => {
  const [{ data: h, loading: p, error: b }, w] = $a(), [C, L] = Ze([]), O = { ...e.dataSource, ...t };
  return lt(() => {
    w(O == null ? void 0 : O.url);
  }, [O == null ? void 0 : O.url]), lt(() => {
    const k = h == null ? void 0 : h.nodes.map(a), N = k == null ? void 0 : k.filter(
      (j) => d(j, t == null ? void 0 : t.filters)
    );
    L(m ? N == null ? void 0 : N.slice(0, m) : N);
  }, [h]), // Init the context to be used on its childrens
  /* @__PURE__ */ f.jsx(su.Provider, { value: { feeds: C }, children: /* @__PURE__ */ f.jsxs(ou, { children: [
    r,
    b ? /* @__PURE__ */ f.jsx("span", { children: "Error, try again!" }) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      p && !(C != null && C.length) && /* @__PURE__ */ f.jsx("div", { className: "text-center mt-4", children: /* @__PURE__ */ f.jsx(iu, {}) }),
      C != null && C.length ? o : !p && /* @__PURE__ */ f.jsx("p", { className: "text-center", children: n })
    ] })
  ] }) });
};
au.propTypes = {
  renderHeader: l.element,
  renderBody: l.element,
  maxItems: l.number,
  dataTransformer: l.func,
  dataFilter: l.func,
  noFeedText: l.string
};
const Js = l.shape({
  color: l.oneOf(["white", "dark"]),
  text: l.string
}), Qs = l.shape({
  color: l.oneOf(["gold", "maroon", "gray", "dark"]),
  text: l.string
}), $d = l.shape({
  color: l.oneOf(["gold", "maroon", "gray", "dark"]),
  text: l.string,
  size: l.string
}), lu = l.shape({
  url: l.string,
  filters: l.string
}), cu = l.shape({
  header: Js,
  ctaButton: Qs,
  dataSource: lu,
  maxItems: l.number
}), uu = jt.div`
  @media screen and (min-width: 768px) {
    & {
      display: inline-flex;
      justify-content: flex-end;
    }
  }
`, du = ({
  defaultProps: e,
  header: t,
  ctaButton: n
}) => {
  const r = { ...e.header, ...t }, o = { ...e.ctaButton, ...n }, a = r.tag || "h2", d = a !== "h2", m = `text-${r.color} ${d ? "h2" : ""}`.trim();
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: "row justify-content-between align-items-center pb-6",
      "data-testid": "feed-header",
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "col-sm-12 col-md-9", children: /* @__PURE__ */ f.jsx(a, { className: m, children: r.text }) }),
        /* @__PURE__ */ f.jsx(uu, { className: "col-sm-12 col-md-3", children: /* @__PURE__ */ f.jsx(
          tt,
          {
            gaData: {
              event: "link",
              action: "click",
              name: "onclick",
              type: "internal link",
              region: "main content",
              section: r.text,
              text: o.text
            },
            children: /* @__PURE__ */ f.jsx("a", { className: `btn btn-${o.color}`, href: o.url, children: o.text })
          }
        ) })
      ]
    }
  );
};
du.propTypes = {
  defaultProps: cu,
  header: Js,
  ctaButton: Qs
};
const fu = ({ children: e }) => /* @__PURE__ */ f.jsx("div", { className: "row", "data-testid": "feed-body", children: /* @__PURE__ */ f.jsx("div", { className: "col", children: e }) });
fu.propTypes = {
  children: l.element
};
const pu = jt.img`
  width: 100%;
`;
function hu({ image: e, title: t, contents: n }) {
  return console.log({ image: e, title: t, contents: n }), /* @__PURE__ */ f.jsx("div", { children: "TODO: to be implemented" });
}
function mu({
  image: e,
  subTitle: t,
  title: n,
  contents: r,
  contentsColor: o
}) {
  const a = {
    small: "uds-hero-sm",
    medium: "uds-hero-md",
    large: "uds-hero-lg",
    undefined: ""
  }, d = {
    gold: "highlight-gold",
    black: "highlight-black",
    white: "highlight-white",
    none: "text-white",
    undefined: ""
  }, m = {
    black: "text-dark",
    white: "text-white",
    undefined: ""
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: we("uds-hero", {
        [a[e == null ? void 0 : e.size]]: e == null ? void 0 : e.size
      }),
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "hero-overlay" }),
        /* @__PURE__ */ f.jsx(
          pu,
          {
            className: "hero",
            src: e == null ? void 0 : e.url,
            alt: e == null ? void 0 : e.altText,
            "data-testid": "hero-image"
          }
        ),
        t && /* @__PURE__ */ f.jsx("div", { role: "doc-subtitle", "data-testid": "hero-subtitle", children: /* @__PURE__ */ f.jsx(
          "span",
          {
            className: we({
              [m[t.color]]: t.color,
              [d[t.highlightColor]]: t.highlightColor
            }),
            children: t.text
          }
        ) }),
        n && /* @__PURE__ */ f.jsx("h1", { style: { maxWidth: n.maxWidth || "" }, "data-testid": "hero-title", children: /* @__PURE__ */ f.jsx(
          "span",
          {
            className: we({
              [m[n.color]]: n.color,
              [d[n.highlightColor]]: n.highlightColor
            }),
            children: n.text
          }
        ) }),
        r && /* @__PURE__ */ f.jsx(
          "div",
          {
            "data-testid": "hero-content",
            className: we("content", {
              [m[o]]: o
            }),
            children: r.map((h, p) => /* @__PURE__ */ f.jsx("p", { children: h.text }, `content-${p}`))
          }
        )
      ]
    }
  );
}
const ea = (e) => {
  const t = e.type || "heading-hero";
  return {
    "heading-hero": () => mu(e),
    "story-hero": () => hu(e),
    undefined: () => (console.error(
      `the type '${t}' is not supported by the 'Hero' component.`
    ), null)
  }[t]();
};
ea.propTypes = {
  type: l.oneOf(["heading-hero", "story-hero"]),
  image: fl,
  title: pi,
  subTitle: pi,
  contents: l.arrayOf(pi),
  contentsColor: l.string
};
const Ot = ({
  dataId: e,
  isClickeable: t = !1,
  disabled: n = !1,
  pageLinkIcon: r = !1,
  selectedPage: o = !1,
  onClick: a = () => {
  },
  ellipses: d,
  ariaLabel: m,
  children: h,
  ariaDisabled: p
}) => /* @__PURE__ */ f.jsx(
  "li",
  {
    className: we("page-item", {
      disabled: n,
      active: o,
      elipses: d
    }),
    children: t ? /* @__PURE__ */ f.jsxs(
      "button",
      {
        type: "button",
        "aria-label": m,
        className: we("page-link", {
          "page-link-icon": r
        }),
        onClick: a,
        "data-testid": e ? `pagination-${e}` : "page-link",
        "data-id": e,
        "aria-current": o ? "page" : null,
        "aria-disabled": p,
        children: [
          h,
          o && /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: "(current)" })
        ]
      }
    ) : /* @__PURE__ */ f.jsx("span", { className: "page-link", "data-testid": "page-link", children: h })
  }
);
Ot.propTypes = {
  isClickeable: l.bool,
  disabled: l.bool,
  pageLinkIcon: l.bool,
  selectedPage: l.bool,
  dataId: l.string,
  onClick: l.func,
  children: l.node,
  ellipses: l.bool,
  ariaLabel: l.string,
  ariaDisabled: l.bool
};
const gu = {
  event: "select",
  action: "click",
  name: "onclick",
  type: "pagination",
  region: "main content"
}, ta = ({
  type: e,
  background: t,
  currentPage: n = 1,
  totalPages: r = 10,
  onChange: o
}) => {
  const [a, d] = Ze(null);
  lt(() => {
    d(n);
  }, [n]);
  const m = (b) => {
    ks({ ...gu, text: `page ${b}` });
  }, h = (b, w) => {
    const L = {
      first: 1,
      prev: a === 1 ? 1 : a - 1,
      next: a === r ? r : a + 1,
      last: r
    }[w] ?? w;
    d(L), m(L), o == null || o(b, L);
  }, p = () => {
    if (r < 5)
      return /* @__PURE__ */ f.jsx(f.Fragment, { children: Array.from({ length: r }, (N, j) => {
        const D = j + 1;
        return /* @__PURE__ */ f.jsx(
          Ot,
          {
            ariaLabel: `Page ${D} of ${r}`,
            isClickeable: !0,
            selectedPage: a === D,
            onClick: (V) => h(V, D),
            children: D
          },
          D
        );
      }) });
    const b = 2, w = To(
      a === r - 1,
      1,
      a === r ? 2 : 1
    ), C = To(
      a === 1,
      2,
      1
    ), L = Lo(
      a - w,
      a,
      r
    ), O = Lo(
      a,
      a + 1 + C,
      r
    ), k = [...L, ...O];
    return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      k[0] !== 1 && /* @__PURE__ */ f.jsx(
        Ot,
        {
          ariaLabel: `Page 1 of ${r}`,
          isClickeable: !0,
          selectedPage: a === 1,
          onClick: (N) => h(N, "first"),
          children: "1"
        }
      ),
      a > r - b && /* @__PURE__ */ f.jsx(
        Ot,
        {
          isClickeable: !0,
          ariaLabel: `Page 2 of ${r}`,
          selectedPage: a === 2,
          onClick: (N) => h(N, 2),
          children: "2"
        }
      ),
      k[0] > 2 && /* @__PURE__ */ f.jsx(Ot, { ellipses: !0, children: "..." }),
      k.map((N) => /* @__PURE__ */ f.jsx(
        Ot,
        {
          ariaLabel: `Page ${N} of ${r}`,
          isClickeable: !0,
          selectedPage: a === N,
          onClick: (j) => h(j, N),
          children: N
        },
        N
      )),
      k[k.length - 1] < r - 1 && /* @__PURE__ */ f.jsx(Ot, { ellipses: !0, children: "..." }),
      a < b + 1 && /* @__PURE__ */ f.jsx(
        Ot,
        {
          isClickeable: !0,
          ariaLabel: `Page ${r - 1} of ${r}`,
          selectedPage: a === r - 1,
          onClick: (N) => h(N, r - 1),
          children: r - 1
        }
      ),
      k[k.length - 1] !== r && /* @__PURE__ */ f.jsx(
        Ot,
        {
          isClickeable: !0,
          ariaLabel: `Page ${r} of ${r}`,
          selectedPage: a === r,
          onClick: (N) => h(N, "last"),
          children: r
        }
      )
    ] });
  };
  return /* @__PURE__ */ f.jsx("nav", { "aria-label": "Pagination", "data-testid": "pagination", children: /* @__PURE__ */ f.jsxs(
    "ul",
    {
      className: we(
        "pagination",
        "justify-content-center",
        "pt-2",
        "pb-2",
        {
          border: e === "bordered",
          "uds-bg-gray1": t === "gray1",
          "uds-bg-gray": t === "gray2",
          "uds-bg-dark": t === "gray7"
        }
      ),
      children: [
        /* @__PURE__ */ f.jsx(
          Ot,
          {
            dataId: "prev",
            isClickeable: !0,
            disabled: a === 1,
            pageLinkIcon: !0,
            onClick: (b) => h(b, "prev"),
            ariaDisabled: a === 1,
            ariaLabel: "Previous Page"
          }
        ),
        p(),
        /* @__PURE__ */ f.jsx(
          Ot,
          {
            dataId: "next",
            isClickeable: !0,
            ariaDisabled: a === r,
            disabled: a === r,
            pageLinkIcon: !0,
            onClick: (b) => h(b, "next"),
            ariaLabel: "Next Page"
          }
        )
      ]
    }
  ) });
};
ta.propTypes = {
  /**
   * Type of pagination
   */
  type: l.oneOf(["default", "bordered"]).isRequired,
  /**
   * Background of pagination
   */
  background: l.oneOf(["white", "gray1", "gray2", "gray7"]).isRequired,
  /**
   * Current page
   */
  currentPage: l.number,
  /**
   * Total number of pages
   */
  totalPages: l.number,
  /**
   * Callback fired when the page is changed
   */
  onChange: l.func.isRequired
};
var vu = /* @__PURE__ */ ((e) => (e.WARNING = "warning", e.INFO = "info", e.SUCCESS = "success", e.ERROR = "error", e))(vu || {});
const yu = ({
  type: e,
  dismissable: t,
  children: n
}) => {
  var p, b, w;
  const { isBootstrap: r, isReact: o } = kn(), [a, d] = Ze(!0), m = () => d(!1), h = {
    warning: {
      iconTitle: "Warning",
      iconName: "bell",
      alertClass: "warning"
    },
    info: {
      iconTitle: "Information",
      iconName: "info-circle",
      alertClass: "info"
    },
    success: {
      iconTitle: "Success",
      iconName: "check-circle",
      alertClass: "success"
    },
    error: {
      iconTitle: "Error",
      iconName: "exclamation-triangle",
      alertClass: "danger"
    }
  };
  return a && /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: we("alert", {
        "alert-dismissable": t,
        [`alert-${(p = h[e]) == null ? void 0 : p.alertClass}`]: e
      }),
      role: "alert",
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "alert-icon", children: /* @__PURE__ */ f.jsx(
          "span",
          {
            title: (b = h[e]) == null ? void 0 : b.iconTitle,
            className: `fa fa-icon fa-${(w = h[e]) == null ? void 0 : w.iconName}`
          }
        ) }),
        /* @__PURE__ */ f.jsx("div", { className: "alert-content", children: n }),
        t && /* @__PURE__ */ f.jsx("div", { className: "alert-close", children: /* @__PURE__ */ f.jsx(
          Yi,
          {
            icon: ["fas", "times"],
            onClick: o && m,
            "data-bs-dismiss": r && "alert"
          }
        ) })
      ]
    }
  );
}, xu = jt.div`
  button {
    padding: 16px 0;
    border: none;
    outline: none;
  }
`, na = ({ gaData: e, hidePrev: t, hideNext: n, slideNav: r }) => {
  const { isReact: o, isBootstrap: a } = kn();
  return /* @__PURE__ */ f.jsxs(xu, { children: [
    (!t || a) && /* @__PURE__ */ f.jsx(tt, { gaData: { ...e, text: "left chevron" }, children: /* @__PURE__ */ f.jsxs(
      "button",
      {
        className: "scroll-control-prev",
        type: "button",
        onClick: o && (() => r(-1)),
        tabIndex: -1,
        children: [
          /* @__PURE__ */ f.jsx("span", { className: "carousel-control-prev-icon", "aria-hidden": "true" }),
          /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: "Previous" })
        ]
      }
    ) }),
    (!n || a) && /* @__PURE__ */ f.jsx(tt, { gaData: { ...e, text: "right chevron" }, children: /* @__PURE__ */ f.jsxs(
      "button",
      {
        className: "scroll-control-next",
        type: "button",
        onClick: o && (() => r(1)),
        tabIndex: -1,
        children: [
          /* @__PURE__ */ f.jsx("span", { className: "carousel-control-next-icon", "aria-hidden": "true" }),
          /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: "Next" })
        ]
      }
    ) })
  ] });
};
na.propTypes = {
  gaData: l.object,
  hidePrev: l.bool,
  hideNext: l.bool,
  slideNav: l.func.isRequired
};
const ra = $i(function(t, n) {
  const {
    id: r,
    selected: o,
    title: a,
    selectTab: d,
    leftKeyPressed: m,
    rightKeyPressed: h,
    icon: p,
    gaData: b
  } = t, { isReact: w, isBootstrap: C } = kn(), L = on(null);
  Pa(n, () => ({
    focus() {
      L.current.focus();
    },
    scrollIntoView() {
      var j, D, V, W, M, J, se;
      const k = ((j = L.current) == null ? void 0 : j.offsetWidth) / 2 + L.current.offsetLeft, N = ((V = (D = L.current) == null ? void 0 : D.offsetParent) == null ? void 0 : V.scrollLeft) + ((M = (W = L.current) == null ? void 0 : W.offsetParent) == null ? void 0 : M.offsetWidth) / 2;
      (se = (J = L.current) == null ? void 0 : J.offsetParent) == null || se.scrollBy({
        left: k - N
      });
    }
  }), []);
  const O = (k) => {
    k.keyCode === 37 ? (k.preventDefault(), m()) : k.keyCode === 39 && (k.preventDefault(), h());
  };
  return /* @__PURE__ */ f.jsx(tt, { gaData: { ...b, text: a }, children: /* @__PURE__ */ f.jsxs(
    "a",
    {
      ref: L,
      className: `nav-item nav-link ${o ? "active" : ""}`,
      id: r,
      href: `#nav-${r}`,
      role: "tab",
      "aria-controls": `nav-${r}`,
      "aria-selected": o,
      "data-bs-toggle": C && "tab",
      onClick: w && ((k) => d(k, r, a)),
      onKeyDown: w && O,
      tabIndex: o ? "" : "-1",
      children: [
        a,
        " ",
        p && /* @__PURE__ */ f.jsx("i", { className: `${p == null ? void 0 : p[0]} fa-${p == null ? void 0 : p[1]} me-1` })
      ]
    }
  ) });
});
ra.propTypes = {
  gaData: l.object,
  id: l.string.isRequired,
  selected: l.bool.isRequired,
  title: l.string.isRequired,
  selectTab: l.func.isRequired,
  leftKeyPressed: l.func.isRequired,
  rightKeyPressed: l.func.isRequired,
  icon: l.arrayOf(l.string)
};
function bu() {
  const e = on({}), t = jn(
    (n) => (r) => {
      e.current[n] = r;
    },
    []
  );
  return [e, t];
}
const wu = ({ id: e, bgColor: t, selected: n, children: r }) => {
  const { isBootstrap: o } = kn();
  return n || o ? /* @__PURE__ */ f.jsx(
    "div",
    {
      className: `tab-pane fade show ${n ? "show active" : ""} ${t === "bg-dark" ? "text-white" : ""}`,
      id: `nav-${e}`,
      role: "tabpanel",
      "aria-labelledby": `nav-${e}-tab`,
      children: r
    }
  ) : null;
};
wu.propTypes = {
  id: l.string.isRequired,
  bgColor: l.string,
  selected: l.bool,
  children: l.oneOfType([l.array, l.element])
};
const ia = ({
  initialTab: e = "",
  children: t,
  bgColor: n = "",
  onTabChange: r = (o) => {
  }
}) => {
  var ke, ve;
  const o = He.Children.toArray(t), a = on(!1), [d, m] = Ze(
    e && e !== "null" ? e : ((ve = (ke = o[0]) == null ? void 0 : ke.props) == null ? void 0 : ve.id) || ""
  ), h = on(null), [p, b] = bu(), [w, C] = Ze(0), [L, O] = Ze(), k = jn(() => {
    var Q, he;
    O(
      ((Q = h.current) == null ? void 0 : Q.scrollWidth) - ((he = h.current) == null ? void 0 : he.offsetWidth)
    );
  }, []), N = jn(() => {
    var Q;
    C((Q = h.current) == null ? void 0 : Q.scrollLeft);
  }, []), j = jn(() => {
    yi(N, 150), xi(N, 150);
  }, [N]), D = jn(() => {
    yi(k, 150), xi(k, 150);
  }, [k]);
  if (lt(() => {
    const Q = h.current;
    return Q && (Q.addEventListener("scroll", j), N()), () => {
      Q && Q.removeEventListener("scroll", j);
    };
  }, [L, j, N]), lt(() => (window.addEventListener("resize", D), k(), () => {
    window.removeEventListener("resize", D);
  }), [D, k]), lt(() => {
    p.current[d] && p.current[d].scrollIntoView();
  }, [d, p]), lt(() => {
    a.current && e && e !== "null" && d !== e && m(e);
  }, [e, d]), lt(() => {
    a.current = !0;
  }, []), o.length === 0)
    return null;
  const V = (Q) => {
    var he;
    r(Q), (he = p.current[Q]) == null || he.focus(), m(Q);
  }, W = {
    event: "select",
    action: "click",
    name: "onclick",
    type: "carousel",
    region: "main content",
    text: ""
  }, M = {
    event: "link",
    action: "click",
    name: "onclick",
    type: "internal link",
    text: ""
  }, J = o.map((Q) => He.cloneElement(Q, {
    bgColor: n,
    selected: d === Q.props.id
  })), se = (Q) => {
    const he = h.current, Ne = he.scrollWidth - he.clientWidth;
    let $e = he.scrollLeft + 200 * Q;
    $e = Math.max(0, Math.min(Ne, $e)), he.scrollTo({
      left: $e,
      behavior: "smooth"
    });
  }, Oe = (Q, he, Ne) => {
    Q.preventDefault(), V(he);
  }, Fe = (Q = !0) => {
    const he = o.length, Ne = Q ? 1 : -1, dt = o.findIndex((Be) => Be.props.id === d), $e = o[(he + dt + Ne) % he].props.id;
    V($e);
  };
  let Ve = "uds-tabbed-panels";
  return n === "bg-dark" && (Ve += " uds-tabbed-panels-dark"), /* @__PURE__ */ f.jsxs("div", { className: n, children: [
    /* @__PURE__ */ f.jsxs("nav", { className: Ve, children: [
      /* @__PURE__ */ f.jsx("div", { className: "nav nav-tabs", role: "tablist", ref: h, children: o.map((Q, he) => /* @__PURE__ */ f.jsx(
        ra,
        {
          ref: b(Q.props.id),
          id: Q.props.id,
          title: Q.props.title,
          selected: d === Q.props.id,
          gaData: M,
          selectTab: Oe,
          leftKeyPressed: () => Fe(!1),
          rightKeyPressed: () => Fe(),
          icon: Q.props.icon,
          index: he
        },
        Q.props.id
      )) }),
      /* @__PURE__ */ f.jsx(
        na,
        {
          hidePrev: w <= 0,
          hideNext: w >= L,
          gaData: W,
          slideNav: se
        }
      )
    ] }),
    /* @__PURE__ */ f.jsx(
      "div",
      {
        className: "tab-content",
        tabIndex: 0,
        role: "tabpanel",
        id: "nav-tabContent",
        children: J
      }
    )
  ] });
};
ia.propTypes = {
  initialTab: l.string,
  children: l.arrayOf(l.element).isRequired,
  bgColor: l.string,
  onTabChange: l.func
};
const Ki = ({ imageSource: e, imageAltText: t, quote: n, itemStyle: r = {} }) => {
  var o, a;
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: `uds-blockquote uds-testimonial ${e ? "with-image" : ""} ${Ar(r.containerCssClass)}`,
      children: [
        e && /* @__PURE__ */ f.jsx(
          Sn,
          {
            src: e,
            alt: t,
            dataTestId: "testimonial-image",
            fetchPriority: "high"
          }
        ),
        /* @__PURE__ */ f.jsx("svg", { role: "presentation", viewBox: "0 0 302.87 245.82", children: /* @__PURE__ */ f.jsx("path", { d: "M113.61,245.82H0V164.56q0-49.34,8.69-77.83T40.84,35.58Q64.29,12.95,100.67,0l22.24,46.9q-34,11.33-48.72,31.54T58.63,132.21h55Zm180,0H180V164.56q0-49.74,8.7-78T221,35.58Q244.65,12.95,280.63,0l22.24,46.9q-34,11.33-48.72,31.54t-15.57,53.77h55Z" }) }),
        /* @__PURE__ */ f.jsxs("blockquote", { style: { paddingLeft: 0 }, children: [
          n.title && /* @__PURE__ */ f.jsx("h3", { className: "text-center", "data-testid": "testimonial-title", children: /* @__PURE__ */ f.jsx("span", { className: Ar(r.titleCssClass), children: n.title }) }),
          n.content && /* @__PURE__ */ f.jsx(
            "p",
            {
              className: Ar(r.contentCssClass),
              "data-testid": "testimonial-content",
              children: n.content
            }
          ),
          (!!((o = n.cite) != null && o.name) || !!((a = n.cite) != null && a.description)) && /* @__PURE__ */ f.jsxs("div", { className: "citation", "data-testid": "testimonial-citation", children: [
            /* @__PURE__ */ f.jsx("cite", { className: "name", children: n.cite.name }),
            n.cite && /* @__PURE__ */ f.jsx("cite", { className: "description", children: n.cite.description })
          ] })
        ] })
      ]
    }
  );
};
Ki.propTypes = {
  quote: l.shape({
    title: l.string,
    content: l.string,
    cite: l.shape({
      name: l.string,
      description: l.string
    })
  }).isRequired,
  imageSource: l.string,
  imageAltText: l.string,
  itemStyle: l.shape({
    containerCssClass: l.arrayOf(l.string),
    titleCssClass: l.arrayOf(l.string),
    contentCssClass: l.arrayOf(l.string)
  })
};
let Su = 0;
const ku = ({
  title: e,
  content: t,
  triggerElement: n
}) => {
  const [r] = Ze(`tooltip-${Su++}`), o = on(null);
  return /* @__PURE__ */ f.jsxs("span", { className: "uds-tooltip-container", children: [
    He.cloneElement(n, {
      ref: o,
      "aria-describedby": r,
      tabindex: 0
    }),
    /* @__PURE__ */ f.jsxs("div", { role: "tooltip", className: "uds-tooltip-description", id: r, children: [
      e && /* @__PURE__ */ f.jsx("span", { className: "uds-tooltip-heading", children: e }),
      t
    ] })
  ] });
}, Tu = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content",
  text: "play button"
}, _u = ({
  url: e = "",
  vttUrl: t,
  caption: n,
  title: r = "",
  className: o,
  controls: a = !0
}) => {
  const d = on(null);
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: we(`uds-video-container ${o}`, {
        "uds-video-with-caption": n
      }),
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "uds-video-player", children: /* @__PURE__ */ f.jsx(tt, { gaData: { ...Tu, section: r }, children: /* @__PURE__ */ f.jsxs(
          "video",
          {
            ref: d,
            title: r,
            playsInline: !0,
            controls: a || !0,
            children: [
              /* @__PURE__ */ f.jsx("source", { src: e }),
              /* @__PURE__ */ f.jsx(
                "track",
                {
                  src: t,
                  kind: "captions",
                  srcLang: "en",
                  label: "english_captions"
                }
              )
            ]
          }
        ) }) }),
        n && /* @__PURE__ */ f.jsx("figure", { "data-testid": "video-caption", children: /* @__PURE__ */ f.jsx("figcaption", { children: n }) })
      ]
    }
  );
}, Eu = ({ title: e = "", caption: t, url: n = "", className: r }) => /* @__PURE__ */ f.jsxs(
  "div",
  {
    className: we(`uds-video-container ${r}`, {
      "uds-video-with-caption": t
    }),
    children: [
      /* @__PURE__ */ f.jsx("div", { className: "uds-video-player youtube-video", children: /* @__PURE__ */ f.jsx("iframe", { title: e, src: n }) }),
      t && /* @__PURE__ */ f.jsx("figure", { "data-testid": "video-caption", children: /* @__PURE__ */ f.jsx("figcaption", { children: t }) })
    ]
  }
), oa = (e) => {
  const {
    type: t = "video",
    url: n = "",
    vttUrl: r,
    title: o = "",
    caption: a,
    className: d,
    controls: m = !0
  } = e;
  return t === "youtube" ? Eu({ url: n, title: o, caption: a, className: d }) : _u({
    url: n,
    vttUrl: r,
    title: o,
    caption: a,
    className: d,
    controls: m
  });
};
oa.propTypes = {
  type: l.oneOf(["video", "youtube"]),
  url: l.string,
  vttUrl: l.string,
  title: l.string,
  className: l.string,
  caption: l.string,
  controls: l.bool
};
const Cu = {
  event: "select",
  action: "click",
  name: "onclick",
  region: "main content",
  type: "pagination",
  text: "owl dot"
}, Zi = ({ children: e }) => /* @__PURE__ */ f.jsx(
  "div",
  {
    role: "group",
    className: "glide__bullets",
    "data-glide-el": "controls[nav]",
    "data-testid": "bullets-container",
    onClick: (t) => t.stopPropagation(),
    onKeyDown: (t) => t.stopPropagation(),
    children: e
  }
);
Zi.propTypes = {
  children: l.oneOfType([
    l.element,
    l.arrayOf(l.element)
  ]).isRequired
};
const sa = ({ buttonCount: e }) => {
  const t = [];
  for (let n = 0; n < e; n += 1)
    t.push(
      /* @__PURE__ */ f.jsx(tt, { gaData: Cu, children: /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          className: "glide__bullet",
          "data-glide-dir": `=${n}`,
          "aria-label": `Slide view ${n + 1}`
        }
      ) }, `bullet-${n}`)
    );
  return /* @__PURE__ */ f.jsx(Zi, { children: t });
};
sa.propTypes = {
  buttonCount: l.number.isRequired
};
const aa = ({ imageItems: e, onItemClick: t = () => null }) => {
  const n = (o, a) => {
    const { ariaSelected: d } = o.currentTarget.dataset;
    o.currentTarget.dataset.ariaSelected = String(!d), o.stopPropagation(), t(a);
  }, r = e.map((o, a) => /* @__PURE__ */ f.jsx(
    "button",
    {
      type: "button",
      role: "option",
      className: "bullet-image-container",
      "data-glide-dir": `=${a}`,
      "aria-label": `Slide view ${a + 1}`,
      "aria-selected": "false",
      onClick: (d) => n(d, a),
      onKeyDown: (d) => n(d, a),
      children: /* @__PURE__ */ f.jsx(
        "img",
        {
          src: o,
          alt: `Slide ${a + 1}`,
          className: "glide__bullet bullet-image",
          loading: "lazy",
          decoding: "async",
          fetchpriority: "low"
        }
      )
    },
    `bullet-${a}`
  ));
  return /* @__PURE__ */ f.jsx(Zi, { children: r });
};
aa.propTypes = {
  imageItems: l.arrayOf(l.string).isRequired,
  onItemClick: l.func
};
const Ji = ({ onClick: e = () => null }) => /* @__PURE__ */ f.jsx(
  "button",
  {
    type: "button",
    className: "glide__arrow glide__arrow--next",
    "data-glide-dir": ">",
    "aria-label": "Next slide",
    onClick: e,
    children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-chevron-right arrow-icon" })
  }
);
Ji.propTypes = {
  onClick: l.func
};
const Qi = ({ onClick: e = () => null }) => /* @__PURE__ */ f.jsx(
  "button",
  {
    type: "button",
    className: "glide__arrow glide__arrow--prev",
    "data-glide-dir": "<",
    "aria-label": "Previous slide",
    onClick: e,
    children: /* @__PURE__ */ f.jsx("span", { className: "fas fa-chevron-left arrow-icon" })
  }
);
Qi.propTypes = {
  onClick: l.func
};
const ss = {
  event: "select",
  action: "click",
  name: "onclick",
  region: "main content",
  type: "carousel"
}, eo = ({ children: e = null }) => /* @__PURE__ */ f.jsx(
  "div",
  {
    className: "glide__arrows",
    "data-glide-el": "controls",
    "data-testid": "arrows-container",
    children: e
  }
);
eo.propTypes = {
  children: l.arrayOf(l.element)
};
const la = ({ onClick: e = () => null, children: t = null }) => /* @__PURE__ */ f.jsxs(eo, { children: [
  /* @__PURE__ */ f.jsx(tt, { gaData: { ...ss, text: "left chevron" }, children: /* @__PURE__ */ f.jsx(Qi, { onClick: e }) }),
  t,
  /* @__PURE__ */ f.jsx(tt, { gaData: { ...ss, text: "right chevron" }, children: /* @__PURE__ */ f.jsx(Ji, { onClick: e }) })
] });
la.propTypes = {
  children: l.element,
  onClick: l.func
};
const ca = ({ carouselItems: e }) => {
  const t = e.map((n) => /* @__PURE__ */ f.jsx("li", { className: "glide__slide slider", children: n.item }, n.id.toString()));
  return /* @__PURE__ */ f.jsx("ul", { className: "glide__slides", children: t });
};
ca.propTypes = {
  carouselItems: l.arrayOf(l.object)
};
function as(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ls(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? as(Object(n), !0).forEach(function(r) {
      Ou(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : as(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ir(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ir = function(t) {
    return typeof t;
  } : Ir = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ir(e);
}
function qr(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ru(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Yr(e, t, n) {
  return t && Ru(e.prototype, t), e;
}
function Ou(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Au(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Ni(e, t);
}
function Ln(e) {
  return Ln = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ln(e);
}
function Ni(e, t) {
  return Ni = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Ni(e, t);
}
function ju() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Nu(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Pu(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Nu(e);
}
function Iu(e) {
  var t = ju();
  return function() {
    var r = Ln(e), o;
    if (t) {
      var a = Ln(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return Pu(this, o);
  };
}
function Lu(e, t) {
  for (; !Object.prototype.hasOwnProperty.call(e, t) && (e = Ln(e), e !== null); )
    ;
  return e;
}
function Lr() {
  return typeof Reflect < "u" && Reflect.get ? Lr = Reflect.get : Lr = function(t, n, r) {
    var o = Lu(t, n);
    if (o) {
      var a = Object.getOwnPropertyDescriptor(o, n);
      return a.get ? a.get.call(arguments.length < 3 ? t : r) : a.value;
    }
  }, Lr.apply(this, arguments);
}
var Mu = {
  /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */
  type: "slider",
  /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */
  startAt: 0,
  /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */
  perView: 1,
  /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */
  focusAt: 0,
  /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */
  gap: 10,
  /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */
  autoplay: !1,
  /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */
  hoverpause: !0,
  /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */
  keyboard: !0,
  /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */
  bound: !1,
  /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */
  swipeThreshold: 80,
  /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */
  dragThreshold: 120,
  /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */
  perSwipe: "",
  /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */
  touchRatio: 0.5,
  /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */
  touchAngle: 45,
  /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */
  animationDuration: 400,
  /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */
  rewind: !0,
  /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */
  rewindDuration: 800,
  /**
   * Easing function for the animation.
   *
   * @type {String}
   */
  animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
  /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */
  waitForTransition: !0,
  /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */
  throttle: 10,
  /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */
  direction: "ltr",
  /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */
  peek: 0,
  /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */
  cloningRatio: 1,
  /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */
  breakpoints: {},
  /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */
  classes: {
    swipeable: "glide--swipeable",
    dragging: "glide--dragging",
    direction: {
      ltr: "glide--ltr",
      rtl: "glide--rtl"
    },
    type: {
      slider: "glide--slider",
      carousel: "glide--carousel"
    },
    slide: {
      clone: "glide__slide--clone",
      active: "glide__slide--active"
    },
    arrow: {
      disabled: "glide__arrow--disabled"
    },
    nav: {
      active: "glide__bullet--active"
    }
  }
};
function Ut(e) {
  console.error("[Glide warn]: ".concat(e));
}
function et(e) {
  return parseInt(e);
}
function Du(e) {
  return parseFloat(e);
}
function Pi(e) {
  return typeof e == "string";
}
function Mn(e) {
  var t = Ir(e);
  return t === "function" || t === "object" && !!e;
}
function zr(e) {
  return typeof e == "function";
}
function ua(e) {
  return typeof e > "u";
}
function Ii(e) {
  return e.constructor === Array;
}
function Fu(e, t, n) {
  var r = {};
  for (var o in t)
    zr(t[o]) ? r[o] = t[o](e, r, n) : Ut("Extension must be a function");
  for (var a in r)
    zr(r[a].mount) && r[a].mount();
  return r;
}
function De(e, t, n) {
  Object.defineProperty(e, t, n);
}
function $u(e) {
  return Object.keys(e).sort().reduce(function(t, n) {
    return t[n] = e[n], t[n], t;
  }, {});
}
function Li(e, t) {
  var n = Object.assign({}, e, t);
  if (t.hasOwnProperty("classes")) {
    n.classes = Object.assign({}, e.classes, t.classes);
    var r = ["direction", "type", "slide", "arrow", "nav"];
    r.forEach(function(o) {
      t.classes.hasOwnProperty(o) && (n.classes[o] = ls(ls({}, e.classes[o]), t.classes[o]));
    });
  }
  return t.hasOwnProperty("breakpoints") && (n.breakpoints = Object.assign({}, e.breakpoints, t.breakpoints)), n;
}
var Bu = /* @__PURE__ */ function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    qr(this, e), this.events = t, this.hop = t.hasOwnProperty;
  }
  return Yr(e, [{
    key: "on",
    value: function(n, r) {
      if (Ii(n)) {
        for (var o = 0; o < n.length; o++)
          this.on(n[o], r);
        return;
      }
      this.hop.call(this.events, n) || (this.events[n] = []);
      var a = this.events[n].push(r) - 1;
      return {
        remove: function() {
          delete this.events[n][a];
        }
      };
    }
    /**
     * Runs registered handlers for specified event.
     *
     * @param {String|Array} event
     * @param {Object=} context
     */
  }, {
    key: "emit",
    value: function(n, r) {
      if (Ii(n)) {
        for (var o = 0; o < n.length; o++)
          this.emit(n[o], r);
        return;
      }
      this.hop.call(this.events, n) && this.events[n].forEach(function(a) {
        a(r || {});
      });
    }
  }]), e;
}(), zu = /* @__PURE__ */ function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    qr(this, e), this._c = {}, this._t = [], this._e = new Bu(), this.disabled = !1, this.selector = t, this.settings = Li(Mu, n), this.index = this.settings.startAt;
  }
  return Yr(e, [{
    key: "mount",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this._e.emit("mount.before"), Mn(n) ? this._c = Fu(this, n, this._e) : Ut("You need to provide a object on `mount()`"), this._e.emit("mount.after"), this;
    }
    /**
     * Collects an instance `translate` transformers.
     *
     * @param  {Array} transformers Collection of transformers.
     * @return {Void}
     */
  }, {
    key: "mutate",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      return Ii(n) ? this._t = n : Ut("You need to provide a array on `mutate()`"), this;
    }
    /**
     * Updates glide with specified settings.
     *
     * @param {Object} settings
     * @return {Glide}
     */
  }, {
    key: "update",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this.settings = Li(this.settings, n), n.hasOwnProperty("startAt") && (this.index = n.startAt), this._e.emit("update"), this;
    }
    /**
     * Change slide with specified pattern. A pattern must be in the special format:
     * `>` - Move one forward
     * `<` - Move one backward
     * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
     * `>>` - Rewinds to end (last slide)
     * `<<` - Rewinds to start (first slide)
     * `|>` - Move one viewport forward
     * `|<` - Move one viewport backward
     *
     * @param {String} pattern
     * @return {Glide}
     */
  }, {
    key: "go",
    value: function(n) {
      return this._c.Run.make(n), this;
    }
    /**
     * Move track by specified distance.
     *
     * @param {String} distance
     * @return {Glide}
     */
  }, {
    key: "move",
    value: function(n) {
      return this._c.Transition.disable(), this._c.Move.make(n), this;
    }
    /**
     * Destroy instance and revert all changes done by this._c.
     *
     * @return {Glide}
     */
  }, {
    key: "destroy",
    value: function() {
      return this._e.emit("destroy"), this;
    }
    /**
     * Start instance autoplaying.
     *
     * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Glide}
     */
  }, {
    key: "play",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      return n && (this.settings.autoplay = n), this._e.emit("play"), this;
    }
    /**
     * Stop instance autoplaying.
     *
     * @return {Glide}
     */
  }, {
    key: "pause",
    value: function() {
      return this._e.emit("pause"), this;
    }
    /**
     * Sets glide into a idle status.
     *
     * @return {Glide}
     */
  }, {
    key: "disable",
    value: function() {
      return this.disabled = !0, this;
    }
    /**
     * Sets glide into a active status.
     *
     * @return {Glide}
     */
  }, {
    key: "enable",
    value: function() {
      return this.disabled = !1, this;
    }
    /**
     * Adds cuutom event listener with handler.
     *
     * @param  {String|Array} event
     * @param  {Function} handler
     * @return {Glide}
     */
  }, {
    key: "on",
    value: function(n, r) {
      return this._e.on(n, r), this;
    }
    /**
     * Checks if glide is a precised type.
     *
     * @param  {String} name
     * @return {Boolean}
     */
  }, {
    key: "isType",
    value: function(n) {
      return this.settings.type === n;
    }
    /**
     * Gets value of the core options.
     *
     * @return {Object}
     */
  }, {
    key: "settings",
    get: function() {
      return this._o;
    },
    set: function(n) {
      Mn(n) ? this._o = n : Ut("Options must be an `object` instance.");
    }
    /**
     * Gets current index of the slider.
     *
     * @return {Object}
     */
  }, {
    key: "index",
    get: function() {
      return this._i;
    },
    set: function(n) {
      this._i = et(n);
    }
    /**
     * Gets type name of the slider.
     *
     * @return {String}
     */
  }, {
    key: "type",
    get: function() {
      return this.settings.type;
    }
    /**
     * Gets value of the idle status.
     *
     * @return {Boolean}
     */
  }, {
    key: "disabled",
    get: function() {
      return this._d;
    },
    set: function(n) {
      this._d = !!n;
    }
  }]), e;
}();
function Hu(e, t, n) {
  var r = {
    /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */
    mount: function() {
      this._o = !1;
    },
    /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */
    make: function(p) {
      var b = this;
      e.disabled || (!e.settings.waitForTransition || e.disable(), this.move = p, n.emit("run.before", this.move), this.calculate(), n.emit("run", this.move), t.Transition.after(function() {
        b.isStart() && n.emit("run.start", b.move), b.isEnd() && n.emit("run.end", b.move), b.isOffset() && (b._o = !1, n.emit("run.offset", b.move)), n.emit("run.after", b.move), e.enable();
      }));
    },
    /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */
    calculate: function() {
      var p = this.move, b = this.length, w = p.steps, C = p.direction, L = 1;
      if (C === "=") {
        if (e.settings.bound && et(w) > b) {
          e.index = b;
          return;
        }
        e.index = w;
        return;
      }
      if (C === ">" && w === ">") {
        e.index = b;
        return;
      }
      if (C === "<" && w === "<") {
        e.index = 0;
        return;
      }
      if (C === "|" && (L = e.settings.perView || 1), C === ">" || C === "|" && w === ">") {
        var O = o(L);
        O > b && (this._o = !0), e.index = a(O, L);
        return;
      }
      if (C === "<" || C === "|" && w === "<") {
        var k = d(L);
        k < 0 && (this._o = !0), e.index = m(k, L);
        return;
      }
      Ut("Invalid direction pattern [".concat(C).concat(w, "] has been used"));
    },
    /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */
    isStart: function() {
      return e.index <= 0;
    },
    /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */
    isEnd: function() {
      return e.index >= this.length;
    },
    /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */
    isOffset: function() {
      var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
      return p ? this._o ? p === "|>" ? this.move.direction === "|" && this.move.steps === ">" : p === "|<" ? this.move.direction === "|" && this.move.steps === "<" : this.move.direction === p : !1 : this._o;
    },
    /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */
    isBound: function() {
      return e.isType("slider") && e.settings.focusAt !== "center" && e.settings.bound;
    }
  };
  function o(h) {
    var p = e.index;
    return e.isType("carousel") ? p + h : p + (h - p % h);
  }
  function a(h, p) {
    var b = r.length;
    return h <= b ? h : e.isType("carousel") ? h - (b + 1) : e.settings.rewind ? r.isBound() && !r.isEnd() ? b : 0 : r.isBound() ? b : Math.floor(b / p) * p;
  }
  function d(h) {
    var p = e.index;
    if (e.isType("carousel"))
      return p - h;
    var b = Math.ceil(p / h);
    return (b - 1) * h;
  }
  function m(h, p) {
    var b = r.length;
    return h >= 0 ? h : e.isType("carousel") ? h + (b + 1) : e.settings.rewind ? r.isBound() && r.isStart() ? b : Math.floor(b / p) * p : 0;
  }
  return De(r, "move", {
    /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */
    get: function() {
      return this._m;
    },
    /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */
    set: function(p) {
      var b = p.substr(1);
      this._m = {
        direction: p.substr(0, 1),
        steps: b ? et(b) ? et(b) : b : 0
      };
    }
  }), De(r, "length", {
    /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */
    get: function() {
      var p = e.settings, b = t.Html.slides.length;
      return this.isBound() ? b - 1 - (et(p.perView) - 1) + et(p.focusAt) : b - 1;
    }
  }), De(r, "offset", {
    /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */
    get: function() {
      return this._o;
    }
  }), r;
}
function cs() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function Xr(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r, o, a, d, m = 0, h = function() {
    m = n.leading === !1 ? 0 : cs(), r = null, d = e.apply(o, a), r || (o = a = null);
  }, p = function() {
    var w = cs();
    !m && n.leading === !1 && (m = w);
    var C = t - (w - m);
    return o = this, a = arguments, C <= 0 || C > t ? (r && (clearTimeout(r), r = null), m = w, d = e.apply(o, a), r || (o = a = null)) : !r && n.trailing !== !1 && (r = setTimeout(h, C)), d;
  };
  return p.cancel = function() {
    clearTimeout(r), m = 0, r = o = a = null;
  }, p;
}
var Rr = {
  ltr: ["marginLeft", "marginRight"],
  rtl: ["marginRight", "marginLeft"]
};
function Vu(e, t, n) {
  var r = {
    /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */
    apply: function(a) {
      for (var d = 0, m = a.length; d < m; d++) {
        var h = a[d].style, p = t.Direction.value;
        d !== 0 ? h[Rr[p][0]] = "".concat(this.value / 2, "px") : h[Rr[p][0]] = "", d !== a.length - 1 ? h[Rr[p][1]] = "".concat(this.value / 2, "px") : h[Rr[p][1]] = "";
      }
    },
    /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */
    remove: function(a) {
      for (var d = 0, m = a.length; d < m; d++) {
        var h = a[d].style;
        h.marginLeft = "", h.marginRight = "";
      }
    }
  };
  return De(r, "value", {
    /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */
    get: function() {
      return et(e.settings.gap);
    }
  }), De(r, "grow", {
    /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */
    get: function() {
      return r.value * t.Sizes.length;
    }
  }), De(r, "reductor", {
    /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */
    get: function() {
      var a = e.settings.perView;
      return r.value * (a - 1) / a;
    }
  }), n.on(["build.after", "update"], Xr(function() {
    r.apply(t.Html.wrapper.children);
  }, 30)), n.on("destroy", function() {
    r.remove(t.Html.wrapper.children);
  }), r;
}
function da(e) {
  if (e && e.parentNode) {
    for (var t = e.parentNode.firstChild, n = []; t; t = t.nextSibling)
      t.nodeType === 1 && t !== e && n.push(t);
    return n;
  }
  return [];
}
function Mi(e) {
  return Array.prototype.slice.call(e);
}
var Wu = '[data-glide-el="track"]';
function Uu(e, t, n) {
  var r = {
    /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */
    mount: function() {
      this.root = e.selector, this.track = this.root.querySelector(Wu), this.collectSlides();
    },
    /**
     * Collect slides
     */
    collectSlides: function() {
      this.slides = Mi(this.wrapper.children).filter(function(a) {
        return !a.classList.contains(e.settings.classes.slide.clone);
      });
    }
  };
  return De(r, "root", {
    /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */
    get: function() {
      return r._r;
    },
    /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */
    set: function(a) {
      Pi(a) && (a = document.querySelector(a)), a !== null ? r._r = a : Ut("Root element must be a existing Html node");
    }
  }), De(r, "track", {
    /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */
    get: function() {
      return r._t;
    },
    /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */
    set: function(a) {
      r._t = a;
    }
  }), De(r, "wrapper", {
    /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */
    get: function() {
      return r.track.children[0];
    }
  }), n.on("update", function() {
    r.collectSlides();
  }), r;
}
function qu(e, t, n) {
  var r = {
    /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = e.settings.peek;
    }
  };
  return De(r, "value", {
    /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */
    get: function() {
      return r._v;
    },
    /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */
    set: function(a) {
      Mn(a) ? (a.before = et(a.before), a.after = et(a.after)) : a = et(a), r._v = a;
    }
  }), De(r, "reductor", {
    /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */
    get: function() {
      var a = r.value, d = e.settings.perView;
      return Mn(a) ? a.before / d + a.after / d : a * 2 / d;
    }
  }), n.on(["resize", "update"], function() {
    r.mount();
  }), r;
}
function Yu(e, t, n) {
  var r = {
    /**
     * Constructs move component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._o = 0;
    },
    /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */
    make: function() {
      var a = this, d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.offset = d, n.emit("move", {
        movement: this.value
      }), t.Transition.after(function() {
        n.emit("move.after", {
          movement: a.value
        });
      });
    }
  };
  return De(r, "offset", {
    /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    get: function() {
      return r._o;
    },
    /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    set: function(a) {
      r._o = ua(a) ? 0 : et(a);
    }
  }), De(r, "translate", {
    /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */
    get: function() {
      return t.Sizes.slideWidth * e.index;
    }
  }), De(r, "value", {
    /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */
    get: function() {
      var a = this.offset, d = this.translate;
      return t.Direction.is("rtl") ? d + a : d - a;
    }
  }), n.on(["build.before", "run"], function() {
    r.make();
  }), r;
}
function Xu(e, t, n) {
  var r = {
    /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */
    setupSlides: function() {
      for (var a = "".concat(this.slideWidth, "px"), d = t.Html.slides, m = 0; m < d.length; m++)
        d[m].style.width = a;
    },
    /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */
    setupWrapper: function() {
      t.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
    },
    /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */
    remove: function() {
      for (var a = t.Html.slides, d = 0; d < a.length; d++)
        a[d].style.width = "";
      t.Html.wrapper.style.width = "";
    }
  };
  return De(r, "length", {
    /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */
    get: function() {
      return t.Html.slides.length;
    }
  }), De(r, "width", {
    /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */
    get: function() {
      return t.Html.track.offsetWidth;
    }
  }), De(r, "wrapperSize", {
    /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */
    get: function() {
      return r.slideWidth * r.length + t.Gaps.grow + t.Clones.grow;
    }
  }), De(r, "slideWidth", {
    /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */
    get: function() {
      return r.width / e.settings.perView - t.Peek.reductor - t.Gaps.reductor;
    }
  }), n.on(["build.before", "resize", "update"], function() {
    r.setupSlides(), r.setupWrapper();
  }), n.on("destroy", function() {
    r.remove();
  }), r;
}
function Gu(e, t, n) {
  var r = {
    /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */
    mount: function() {
      n.emit("build.before"), this.typeClass(), this.activeClass(), n.emit("build.after");
    },
    /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */
    typeClass: function() {
      t.Html.root.classList.add(e.settings.classes.type[e.settings.type]);
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    activeClass: function() {
      var a = e.settings.classes, d = t.Html.slides[e.index];
      d && (d.classList.add(a.slide.active), da(d).forEach(function(m) {
        m.classList.remove(a.slide.active);
      }));
    },
    /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */
    removeClasses: function() {
      var a = e.settings.classes, d = a.type, m = a.slide;
      t.Html.root.classList.remove(d[e.settings.type]), t.Html.slides.forEach(function(h) {
        h.classList.remove(m.active);
      });
    }
  };
  return n.on(["destroy", "update"], function() {
    r.removeClasses();
  }), n.on(["resize", "update"], function() {
    r.mount();
  }), n.on("move.after", function() {
    r.activeClass();
  }), r;
}
function Ku(e, t, n) {
  var r = {
    /**
     * Create pattern map and collect slides to be cloned.
     */
    mount: function() {
      this.items = [], e.isType("carousel") && (this.items = this.collect());
    },
    /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */
    collect: function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], d = t.Html.slides, m = e.settings, h = m.perView, p = m.classes, b = m.cloningRatio;
      if (d.length > 0)
        for (var w = +!!e.settings.peek, C = h + w + Math.round(h / 2), L = d.slice(0, C).reverse(), O = d.slice(C * -1), k = 0; k < Math.max(b, Math.floor(h / d.length)); k++) {
          for (var N = 0; N < L.length; N++) {
            var j = L[N].cloneNode(!0);
            j.classList.add(p.slide.clone), a.push(j);
          }
          for (var D = 0; D < O.length; D++) {
            var V = O[D].cloneNode(!0);
            V.classList.add(p.slide.clone), a.unshift(V);
          }
        }
      return a;
    },
    /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */
    append: function() {
      for (var a = this.items, d = t.Html, m = d.wrapper, h = d.slides, p = Math.floor(a.length / 2), b = a.slice(0, p).reverse(), w = a.slice(p * -1).reverse(), C = "".concat(t.Sizes.slideWidth, "px"), L = 0; L < w.length; L++)
        m.appendChild(w[L]);
      for (var O = 0; O < b.length; O++)
        m.insertBefore(b[O], h[0]);
      for (var k = 0; k < a.length; k++)
        a[k].style.width = C;
    },
    /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */
    remove: function() {
      for (var a = this.items, d = 0; d < a.length; d++)
        t.Html.wrapper.removeChild(a[d]);
    }
  };
  return De(r, "grow", {
    /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */
    get: function() {
      return (t.Sizes.slideWidth + t.Gaps.value) * r.items.length;
    }
  }), n.on("update", function() {
    r.remove(), r.mount(), r.append();
  }), n.on("build.before", function() {
    e.isType("carousel") && r.append();
  }), n.on("destroy", function() {
    r.remove();
  }), r;
}
var sn = /* @__PURE__ */ function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    qr(this, e), this.listeners = t;
  }
  return Yr(e, [{
    key: "on",
    value: function(n, r, o) {
      var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      Pi(n) && (n = [n]);
      for (var d = 0; d < n.length; d++)
        this.listeners[n[d]] = o, r.addEventListener(n[d], this.listeners[n[d]], a);
    }
    /**
     * Removes event listeners from arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Boolean|Object} capture
     * @return {Void}
     */
  }, {
    key: "off",
    value: function(n, r) {
      var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      Pi(n) && (n = [n]);
      for (var a = 0; a < n.length; a++)
        r.removeEventListener(n[a], this.listeners[n[a]], o);
    }
    /**
     * Destroy collected listeners.
     *
     * @returns {Void}
     */
  }, {
    key: "destroy",
    value: function() {
      delete this.listeners;
    }
  }]), e;
}();
function Zu(e, t, n) {
  var r = new sn(), o = {
    /**
     * Initializes window bindings.
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */
    bind: function() {
      r.on("resize", window, Xr(function() {
        n.emit("resize");
      }, e.settings.throttle));
    },
    /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */
    unbind: function() {
      r.off("resize", window);
    }
  };
  return n.on("destroy", function() {
    o.unbind(), r.destroy();
  }), o;
}
var Ju = ["ltr", "rtl"], Qu = {
  ">": "<",
  "<": ">",
  "=": "="
};
function ed(e, t, n) {
  var r = {
    /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = e.settings.direction;
    },
    /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */
    resolve: function(a) {
      var d = a.slice(0, 1);
      return this.is("rtl") ? a.split(d).join(Qu[d]) : a;
    },
    /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */
    is: function(a) {
      return this.value === a;
    },
    /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */
    addClass: function() {
      t.Html.root.classList.add(e.settings.classes.direction[this.value]);
    },
    /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */
    removeClass: function() {
      t.Html.root.classList.remove(e.settings.classes.direction[this.value]);
    }
  };
  return De(r, "value", {
    /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */
    get: function() {
      return r._v;
    },
    /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */
    set: function(a) {
      Ju.indexOf(a) > -1 ? r._v = a : Ut("Direction value must be `ltr` or `rtl`");
    }
  }), n.on(["destroy", "update"], function() {
    r.removeClass();
  }), n.on("update", function() {
    r.mount();
  }), n.on(["build.before", "update"], function() {
    r.addClass();
  }), r;
}
function td(e, t) {
  return {
    /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      return t.Direction.is("rtl") ? -r : r;
    }
  };
}
function nd(e, t) {
  return {
    /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      var o = Math.floor(r / t.Sizes.slideWidth);
      return r + t.Gaps.value * o;
    }
  };
}
function rd(e, t) {
  return {
    /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      return r + t.Clones.grow / 2;
    }
  };
}
function id(e, t) {
  return {
    /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      if (e.settings.focusAt >= 0) {
        var o = t.Peek.value;
        return Mn(o) ? r - o.before : r - o;
      }
      return r;
    }
  };
}
function od(e, t) {
  return {
    /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      var o = t.Gaps.value, a = t.Sizes.width, d = e.settings.focusAt, m = t.Sizes.slideWidth;
      return d === "center" ? r - (a / 2 - m / 2) : r - m * d - o * d;
    }
  };
}
function sd(e, t, n) {
  var r = [nd, rd, id, od].concat(e._t, [td]);
  return {
    /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    mutate: function(a) {
      for (var d = 0; d < r.length; d++) {
        var m = r[d];
        zr(m) && zr(m().modify) ? a = m(e, t, n).modify(a) : Ut("Transformer should be a function that returns an object with `modify()` method");
      }
      return a;
    }
  };
}
function ad(e, t, n) {
  var r = {
    /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */
    set: function(a) {
      var d = sd(e, t).mutate(a), m = "translate3d(".concat(-1 * d, "px, 0px, 0px)");
      t.Html.wrapper.style.mozTransform = m, t.Html.wrapper.style.webkitTransform = m, t.Html.wrapper.style.transform = m;
    },
    /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      t.Html.wrapper.style.transform = "";
    },
    /**
     * @return {number}
     */
    getStartIndex: function() {
      var a = t.Sizes.length, d = e.index, m = e.settings.perView;
      return t.Run.isOffset(">") || t.Run.isOffset("|>") ? a + (d - m) : (d + m) % a;
    },
    /**
     * @return {number}
     */
    getTravelDistance: function() {
      var a = t.Sizes.slideWidth * e.settings.perView;
      return t.Run.isOffset(">") || t.Run.isOffset("|>") ? a * -1 : a;
    }
  };
  return n.on("move", function(o) {
    if (!e.isType("carousel") || !t.Run.isOffset())
      return r.set(o.movement);
    t.Transition.after(function() {
      n.emit("translate.jump"), r.set(t.Sizes.slideWidth * e.index);
    });
    var a = t.Sizes.slideWidth * t.Translate.getStartIndex();
    return r.set(a - t.Translate.getTravelDistance());
  }), n.on("destroy", function() {
    r.remove();
  }), r;
}
function ld(e, t, n) {
  var r = !1, o = {
    /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */
    compose: function(d) {
      var m = e.settings;
      return r ? "".concat(d, " 0ms ").concat(m.animationTimingFunc) : "".concat(d, " ").concat(this.duration, "ms ").concat(m.animationTimingFunc);
    },
    /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */
    set: function() {
      var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
      t.Html.wrapper.style.transition = this.compose(d);
    },
    /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      t.Html.wrapper.style.transition = "";
    },
    /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */
    after: function(d) {
      setTimeout(function() {
        d();
      }, this.duration);
    },
    /**
     * Enable transition.
     *
     * @return {Void}
     */
    enable: function() {
      r = !1, this.set();
    },
    /**
     * Disable transition.
     *
     * @return {Void}
     */
    disable: function() {
      r = !0, this.set();
    }
  };
  return De(o, "duration", {
    /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */
    get: function() {
      var d = e.settings;
      return e.isType("slider") && t.Run.offset ? d.rewindDuration : d.animationDuration;
    }
  }), n.on("move", function() {
    o.set();
  }), n.on(["build.before", "resize", "translate.jump"], function() {
    o.disable();
  }), n.on("run", function() {
    o.enable();
  }), n.on("destroy", function() {
    o.remove();
  }), o;
}
var fa = !1;
try {
  var us = Object.defineProperty({}, "passive", {
    get: function() {
      fa = !0;
    }
  });
  window.addEventListener("testPassive", null, us), window.removeEventListener("testPassive", null, us);
} catch {
}
var Di = fa, Or = ["touchstart", "mousedown"], ds = ["touchmove", "mousemove"], fs = ["touchend", "touchcancel", "mouseup", "mouseleave"], ps = ["mousedown", "mousemove", "mouseup", "mouseleave"];
function cd(e, t, n) {
  var r = new sn(), o = 0, a = 0, d = 0, m = !1, h = Di ? {
    passive: !0
  } : !1, p = {
    /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */
    mount: function() {
      this.bindSwipeStart();
    },
    /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */
    start: function(w) {
      if (!m && !e.disabled) {
        this.disable();
        var C = this.touches(w);
        o = null, a = et(C.pageX), d = et(C.pageY), this.bindSwipeMove(), this.bindSwipeEnd(), n.emit("swipe.start");
      }
    },
    /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */
    move: function(w) {
      if (!e.disabled) {
        var C = e.settings, L = C.touchAngle, O = C.touchRatio, k = C.classes, N = this.touches(w), j = et(N.pageX) - a, D = et(N.pageY) - d, V = Math.abs(j << 2), W = Math.abs(D << 2), M = Math.sqrt(V + W), J = Math.sqrt(W);
        if (o = Math.asin(J / M), o * 180 / Math.PI < L)
          w.stopPropagation(), t.Move.make(j * Du(O)), t.Html.root.classList.add(k.dragging), n.emit("swipe.move");
        else
          return !1;
      }
    },
    /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */
    end: function(w) {
      if (!e.disabled) {
        var C = e.settings, L = C.perSwipe, O = C.touchAngle, k = C.classes, N = this.touches(w), j = this.threshold(w), D = N.pageX - a, V = o * 180 / Math.PI;
        this.enable(), D > j && V < O ? t.Run.make(t.Direction.resolve("".concat(L, "<"))) : D < -j && V < O ? t.Run.make(t.Direction.resolve("".concat(L, ">"))) : t.Move.make(), t.Html.root.classList.remove(k.dragging), this.unbindSwipeMove(), this.unbindSwipeEnd(), n.emit("swipe.end");
      }
    },
    /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */
    bindSwipeStart: function() {
      var w = this, C = e.settings, L = C.swipeThreshold, O = C.dragThreshold;
      L && r.on(Or[0], t.Html.wrapper, function(k) {
        w.start(k);
      }, h), O && r.on(Or[1], t.Html.wrapper, function(k) {
        w.start(k);
      }, h);
    },
    /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */
    unbindSwipeStart: function() {
      r.off(Or[0], t.Html.wrapper, h), r.off(Or[1], t.Html.wrapper, h);
    },
    /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */
    bindSwipeMove: function() {
      var w = this;
      r.on(ds, t.Html.wrapper, Xr(function(C) {
        w.move(C);
      }, e.settings.throttle), h);
    },
    /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */
    unbindSwipeMove: function() {
      r.off(ds, t.Html.wrapper, h);
    },
    /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */
    bindSwipeEnd: function() {
      var w = this;
      r.on(fs, t.Html.wrapper, function(C) {
        w.end(C);
      });
    },
    /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */
    unbindSwipeEnd: function() {
      r.off(fs, t.Html.wrapper);
    },
    /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */
    touches: function(w) {
      return ps.indexOf(w.type) > -1 ? w : w.touches[0] || w.changedTouches[0];
    },
    /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */
    threshold: function(w) {
      var C = e.settings;
      return ps.indexOf(w.type) > -1 ? C.dragThreshold : C.swipeThreshold;
    },
    /**
     * Enables swipe event.
     *
     * @return {self}
     */
    enable: function() {
      return m = !1, t.Transition.enable(), this;
    },
    /**
     * Disables swipe event.
     *
     * @return {self}
     */
    disable: function() {
      return m = !0, t.Transition.disable(), this;
    }
  };
  return n.on("build.after", function() {
    t.Html.root.classList.add(e.settings.classes.swipeable);
  }), n.on("destroy", function() {
    p.unbindSwipeStart(), p.unbindSwipeMove(), p.unbindSwipeEnd(), r.destroy();
  }), p;
}
function ud(e, t, n) {
  var r = new sn(), o = {
    /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */
    bind: function() {
      r.on("dragstart", t.Html.wrapper, this.dragstart);
    },
    /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */
    unbind: function() {
      r.off("dragstart", t.Html.wrapper);
    },
    /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */
    dragstart: function(d) {
      d.preventDefault();
    }
  };
  return n.on("destroy", function() {
    o.unbind(), r.destroy();
  }), o;
}
function dd(e, t, n) {
  var r = new sn(), o = !1, a = !1, d = {
    /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._a = t.Html.wrapper.querySelectorAll("a"), this.bind();
    },
    /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */
    bind: function() {
      r.on("click", t.Html.wrapper, this.click);
    },
    /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */
    unbind: function() {
      r.off("click", t.Html.wrapper);
    },
    /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */
    click: function(h) {
      a && (h.stopPropagation(), h.preventDefault());
    },
    /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */
    detach: function() {
      if (a = !0, !o) {
        for (var h = 0; h < this.items.length; h++)
          this.items[h].draggable = !1;
        o = !0;
      }
      return this;
    },
    /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */
    attach: function() {
      if (a = !1, o) {
        for (var h = 0; h < this.items.length; h++)
          this.items[h].draggable = !0;
        o = !1;
      }
      return this;
    }
  };
  return De(d, "items", {
    /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return d._a;
    }
  }), n.on("swipe.move", function() {
    d.detach();
  }), n.on("swipe.end", function() {
    t.Transition.after(function() {
      d.attach();
    });
  }), n.on("destroy", function() {
    d.attach(), d.unbind(), r.destroy();
  }), d;
}
var fd = '[data-glide-el="controls[nav]"]', to = '[data-glide-el^="controls"]', pd = "".concat(to, ' [data-glide-dir*="<"]'), hd = "".concat(to, ' [data-glide-dir*=">"]');
function md(e, t, n) {
  var r = new sn(), o = Di ? {
    passive: !0
  } : !1, a = {
    /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */
    mount: function() {
      this._n = t.Html.root.querySelectorAll(fd), this._c = t.Html.root.querySelectorAll(to), this._arrowControls = {
        previous: t.Html.root.querySelectorAll(pd),
        next: t.Html.root.querySelectorAll(hd)
      }, this.addBindings();
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    setActive: function() {
      for (var m = 0; m < this._n.length; m++)
        this.addClass(this._n[m].children);
    },
    /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */
    removeActive: function() {
      for (var m = 0; m < this._n.length; m++)
        this.removeClass(this._n[m].children);
    },
    /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    addClass: function(m) {
      var h = e.settings, p = m[e.index];
      p && (p.classList.add(h.classes.nav.active), da(p).forEach(function(b) {
        b.classList.remove(h.classes.nav.active);
      }));
    },
    /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    removeClass: function(m) {
      var h = m[e.index];
      h == null || h.classList.remove(e.settings.classes.nav.active);
    },
    /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */
    setArrowState: function() {
      if (!e.settings.rewind) {
        var m = a._arrowControls.next, h = a._arrowControls.previous;
        this.resetArrowState(m, h), e.index === 0 && this.disableArrow(h), e.index === t.Run.length && this.disableArrow(m);
      }
    },
    /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    resetArrowState: function() {
      for (var m = e.settings, h = arguments.length, p = new Array(h), b = 0; b < h; b++)
        p[b] = arguments[b];
      p.forEach(function(w) {
        Mi(w).forEach(function(C) {
          C.classList.remove(m.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    disableArrow: function() {
      for (var m = e.settings, h = arguments.length, p = new Array(h), b = 0; b < h; b++)
        p[b] = arguments[b];
      p.forEach(function(w) {
        Mi(w).forEach(function(C) {
          C.classList.add(m.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */
    addBindings: function() {
      for (var m = 0; m < this._c.length; m++)
        this.bind(this._c[m].children);
    },
    /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */
    removeBindings: function() {
      for (var m = 0; m < this._c.length; m++)
        this.unbind(this._c[m].children);
    },
    /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    bind: function(m) {
      for (var h = 0; h < m.length; h++)
        r.on("click", m[h], this.click), r.on("touchstart", m[h], this.click, o);
    },
    /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    unbind: function(m) {
      for (var h = 0; h < m.length; h++)
        r.off(["click", "touchstart"], m[h]);
    },
    /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */
    click: function(m) {
      !Di && m.type === "touchstart" && m.preventDefault();
      var h = m.currentTarget.getAttribute("data-glide-dir");
      t.Run.make(t.Direction.resolve(h));
    }
  };
  return De(a, "items", {
    /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return a._c;
    }
  }), n.on(["mount.after", "move.after"], function() {
    a.setActive();
  }), n.on(["mount.after", "run"], function() {
    a.setArrowState();
  }), n.on("destroy", function() {
    a.removeBindings(), a.removeActive(), r.destroy();
  }), a;
}
function gd(e, t, n) {
  var r = new sn(), o = {
    /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */
    mount: function() {
      e.settings.keyboard && this.bind();
    },
    /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */
    bind: function() {
      r.on("keyup", document, this.press);
    },
    /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */
    unbind: function() {
      r.off("keyup", document);
    },
    /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */
    press: function(d) {
      var m = e.settings.perSwipe, h = {
        ArrowRight: ">",
        ArrowLeft: "<"
      };
      ["ArrowRight", "ArrowLeft"].includes(d.code) && t.Run.make(t.Direction.resolve("".concat(m).concat(h[d.code])));
    }
  };
  return n.on(["destroy", "update"], function() {
    o.unbind();
  }), n.on("update", function() {
    o.mount();
  }), n.on("destroy", function() {
    r.destroy();
  }), o;
}
function vd(e, t, n) {
  var r = new sn(), o = {
    /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */
    mount: function() {
      this.enable(), this.start(), e.settings.hoverpause && this.bind();
    },
    /**
     * Enables autoplaying
     *
     * @returns {Void}
     */
    enable: function() {
      this._e = !0;
    },
    /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */
    disable: function() {
      this._e = !1;
    },
    /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */
    start: function() {
      var d = this;
      this._e && (this.enable(), e.settings.autoplay && ua(this._i) && (this._i = setInterval(function() {
        d.stop(), t.Run.make(">"), d.start(), n.emit("autoplay");
      }, this.time)));
    },
    /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */
    stop: function() {
      this._i = clearInterval(this._i);
    },
    /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */
    bind: function() {
      var d = this;
      r.on("mouseover", t.Html.root, function() {
        d._e && d.stop();
      }), r.on("mouseout", t.Html.root, function() {
        d._e && d.start();
      });
    },
    /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */
    unbind: function() {
      r.off(["mouseover", "mouseout"], t.Html.root);
    }
  };
  return De(o, "time", {
    /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */
    get: function() {
      var d = t.Html.slides[e.index].getAttribute("data-glide-autoplay");
      return et(d || e.settings.autoplay);
    }
  }), n.on(["destroy", "update"], function() {
    o.unbind();
  }), n.on(["run.before", "swipe.start", "update"], function() {
    o.stop();
  }), n.on(["pause", "destroy"], function() {
    o.disable(), o.stop();
  }), n.on(["run.after", "swipe.end"], function() {
    o.start();
  }), n.on(["play"], function() {
    o.enable(), o.start();
  }), n.on("update", function() {
    o.mount();
  }), n.on("destroy", function() {
    r.destroy();
  }), o;
}
function hs(e) {
  return Mn(e) ? $u(e) : (Ut("Breakpoints option must be an object"), {});
}
function yd(e, t, n) {
  var r = new sn(), o = e.settings, a = hs(o.breakpoints), d = Object.assign({}, o), m = {
    /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */
    match: function(p) {
      if (typeof window.matchMedia < "u") {
        for (var b in p)
          if (p.hasOwnProperty(b) && window.matchMedia("(max-width: ".concat(b, "px)")).matches)
            return p[b];
      }
      return d;
    }
  };
  return Object.assign(o, m.match(a)), r.on("resize", window, Xr(function() {
    e.settings = Li(o, m.match(a));
  }, e.settings.throttle)), n.on("update", function() {
    a = hs(a), d = Object.assign({}, o);
  }), n.on("destroy", function() {
    r.off("resize", window);
  }), m;
}
var xd = {
  // Required
  Html: Uu,
  Translate: ad,
  Transition: ld,
  Direction: ed,
  Peek: qu,
  Sizes: Xu,
  Gaps: Vu,
  Move: Yu,
  Clones: Ku,
  Resize: Zu,
  Build: Gu,
  Run: Hu,
  // Optional
  Swipe: cd,
  Images: ud,
  Anchors: dd,
  Controls: md,
  Keyboard: gd,
  Autoplay: vd,
  Breakpoints: yd
}, bd = /* @__PURE__ */ function(e) {
  Au(n, e);
  var t = Iu(n);
  function n() {
    return qr(this, n), t.apply(this, arguments);
  }
  return Yr(n, [{
    key: "mount",
    value: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return Lr(Ln(n.prototype), "mount", this).call(this, Object.assign({}, xd, o));
    }
  }]), n;
}(zu);
function wd(e) {
  let t, n, r;
  switch (e) {
    case 3:
      t = 1, n = 2, r = 3;
      break;
    case 2:
      t = 1, n = 2, r = 2;
      break;
    case 1:
    default:
      t = 1, n = 1, r = 1;
  }
  return {
    perViewSm: t,
    perViewMd: n,
    perViewLg: r
  };
}
function Sd(e = 1, t, n = !0, r) {
  const { perViewSm: o, perViewMd: a, perViewLg: d } = wd(e), m = n ? 24 : 0, h = n ? { before: 48, after: 48 } : 0, p = n ? { before: 124, after: 124 } : 0;
  return {
    type: "slider",
    // No wrap-around.
    focusAt: 0,
    bound: !0,
    // Only if type slider with focusAt 0
    rewind: !1,
    // Only if type slider
    gap: m,
    // Space between slides... may be impacted by viewport size.
    // `keyboard` Left/Right arrow key support for slides - true is default.
    // Is not fully Accessible, on keydown allcarousels move simultaneously
    // A custome keyboard handler is implemented
    keyboard: !1,
    startAt: 0,
    swipeThreshold: 80,
    // Distance required for swipe to change slide.
    dragThreshold: r ? 120 : !1,
    // Distance for mouse drag to change slide.
    perTouch: 1,
    // Number of slides that can be moved per each swipe/drag.
    perView: d,
    // Can be overwritten at breakpoints
    peek: p,
    // Can be overwritten at breakpoints
    // if isFullWidth = true, then we have only 1 image per view which takes the full width.
    // no need for breakpoints
    breakpoints: t ? null : {
      576: {
        // BS4 sm
        perView: o,
        peek: h
      },
      768: {
        // BS4 md
        perView: a,
        peek: h
      },
      992: {
        // BS4 lg
        perView: d,
        peek: h
      },
      1260: {
        // BS4 xl
        perView: d,
        peek: h
      },
      1400: {
        perView: d,
        peek: p
      },
      1920: {
        perView: d,
        peek: p
      }
    }
  };
}
function kd(e, t, n) {
  const r = e.querySelector(".glide__arrow--prev"), o = e.querySelector(".glide__arrow--next"), a = e.querySelector(".glide__track"), d = e.querySelector(
    ".image-navigator-images"
  );
  if (!(r || o)) return;
  const m = ["slider-start", "slider-mid", "slider-end"], h = "glide__arrow--disabled";
  a == null || a.classList.remove(...m), d == null || d.classList.remove(...m), t === 0 ? (a == null || a.classList.add("slider-start"), d == null || d.classList.add("slider-start"), r == null || r.classList.add(h), r == null || r.setAttribute("aria-disabled", "true"), o == null || o.classList.remove(h), o == null || o.setAttribute("aria-disabled", "false")) : t >= n - 1 ? (a == null || a.classList.add("slider-end"), d == null || d.classList.add("slider-end"), r == null || r.classList.remove(h), r == null || r.setAttribute("aria-disabled", "false"), o == null || o.classList.add(h), o == null || o.setAttribute("aria-disabled", "true")) : (a == null || a.classList.add("slider-mid"), d == null || d.classList.add("slider-mid"), r == null || r.classList.remove(h), o == null || o.classList.remove(h), r == null || r.setAttribute("aria-disabled", "false"), o == null || o.setAttribute("aria-disabled", "false"));
}
function Td(e, t, n) {
  const r = e.querySelectorAll(".glide__slide"), o = t, a = Math.min(
    r.length - 1,
    t + n - 1
  );
  r.forEach((d, m) => {
    m < o || m > a ? (d.setAttribute("aria-hidden", "true"), d.setAttribute("tabindex", "-1"), d.setAttribute("inert", "")) : (d.setAttribute("aria-hidden", "false"), d.removeAttribute("tabindex"), d.removeAttribute("inert"));
  });
}
function _d({
  instanceName: e,
  perView: t,
  buttonCount: n,
  isFullWidth: r = !1,
  onItemClick: o,
  hasPeek: a = !0,
  isDraggable: d
}) {
  const m = Sd(t, r, a, d), h = new bd(`#${e}`, m);
  let p = document.querySelector(`#${e}`);
  return p.addEventListener("keyup", (b) => {
    const w = b;
    w.keyCode === 39 ? h.go(">") : w.keyCode === 37 ? h.go("<") : w.keyCode === 13 && h.go(document.activeElement.dataset.glideDir);
  }), h.on("build.before", () => {
    p = document.querySelector(`#${e}`), p && p.classList.add("slider-start");
  }), h.on("move", () => {
    if (p = document.querySelector(`#${e}`), !p) return;
    const b = h.index;
    Td(p, b, t);
    const w = p.querySelector(".navigation-slider"), C = p.querySelector(".image-navigator-images");
    if (w && C) {
      const L = w.querySelectorAll(
        ".bullet-image-container"
      ), O = w.clientWidth, k = 82, N = L[b], j = C.getBoundingClientRect().x, D = w.getBoundingClientRect().x - j, V = N.getBoundingClientRect().x - j, W = N.getBoundingClientRect().x + N.getBoundingClientRect().width - j;
      if (b === 0 || V <= 0 + k)
        w.style.left = `${D - V + k}px`;
      else if (W >= O - k) {
        const M = W - O;
        w.style.left = `${D - M - k}px`;
      }
    }
    kd(p, b, n), p.setAttribute("data-current-index", b), o && o(b);
  }), h.mount(), h;
}
function Ed(e, t) {
  let n;
  const r = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  );
  return n = e, r >= 992 && (t >= 2 && (n = e - 1), t >= 3 && (n = e - 2)), n;
}
const or = ({
  perView: e = 1,
  width: t,
  maxWidth: n,
  carouselItems: r,
  cssClass: o = "",
  CustomNavComponent: a,
  role: d,
  ariaLabelledBy: m,
  isFullWidth: h,
  removeSideBackground: p = !1,
  hasNavButtons: b = !0,
  hasPositionIndicators: w = !0,
  imageAutoSize: C = !0,
  onItemClick: L = () => null,
  hasPeek: O = !0,
  isDraggable: k = !0,
  hasShadow: N = !0
}) => {
  const j = `glide-${Math.ceil(Math.random() * 1e4)}`, D = Ed(r.length, e);
  return lt(() => {
    _d({
      instanceName: j,
      perView: e,
      buttonCount: D,
      isFullWidth: h,
      onItemClick: L,
      hasPeek: O,
      isDraggable: k
    });
  }, [
    j,
    e,
    D,
    h,
    L,
    O,
    k
  ]), /* @__PURE__ */ f.jsxs(
    "div",
    {
      role: d,
      "aria-labelledby": m,
      className: `glide ${o}`,
      id: j,
      style: { width: t, maxWidth: n },
      "data-remove-side-background": p,
      "data-image-auto-size": C,
      "data-has-shadow": N,
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "glide__track", "data-glide-el": "track", children: /* @__PURE__ */ f.jsx(ca, { carouselItems: r }) }),
        a ? (
          // @ts-ignore
          /* @__PURE__ */ f.jsx(a, { instanceName: j })
        ) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          w && /* @__PURE__ */ f.jsx(sa, { buttonCount: D }),
          b && /* @__PURE__ */ f.jsx(la, {})
        ] })
      ]
    }
  );
};
or.propTypes = {
  perView: l.number,
  width: l.string,
  maxWidth: l.string,
  carouselItems: l.arrayOf(l.object).isRequired,
  cssClass: l.string,
  CustomNavComponent: l.func,
  role: l.string,
  ariaLabelledBy: l.string,
  onItemClick: l.func,
  isFullWidth: l.bool,
  removeSideBackground: l.bool,
  hasNavButtons: l.bool,
  hasPositionIndicators: l.bool,
  imageAutoSize: l.bool,
  hasPeek: l.bool,
  isDraggable: l.bool,
  hasShadow: l.bool
};
const Cd = ({
  id: e,
  imageSource: t,
  imageAltText: n,
  title: r,
  content: o,
  eventLocation: a,
  eventTime: d,
  buttons: m,
  linkLabel: h,
  linkUrl: p,
  tags: b
}, w, C, L) => {
  var O;
  return {
    // @ts-ignore
    id: e,
    item: /* @__PURE__ */ f.jsx(
      Vt,
      {
        type: w,
        horizontal: C,
        image: t,
        imageAltText: n,
        title: r,
        body: o,
        eventFormat: L,
        eventLocation: a,
        eventTime: d,
        buttons: m,
        linkLabel: h,
        linkUrl: p || ((O = m == null ? void 0 : m[0]) == null ? void 0 : O.href),
        tags: b
      }
    )
  };
}, pa = ({
  perView: e = 0,
  cardItems: t = [],
  cardType: n = "default",
  cardEventFormat: r = "stack",
  cardHorizontal: o = !1,
  width: a = void 0,
  maxWidth: d = void 0,
  imageAutoSize: m = !0
}) => {
  const h = parseInt(`${e}`, 10), [p, b] = Ze(h), w = 1024, C = 768;
  lt(() => {
    const k = () => {
      const N = window.innerWidth;
      let j;
      switch (h) {
        case 3:
          N > w ? j = 3 : N > C ? j = 2 : j = 1;
          break;
        case 2:
          j = N < C ? 1 : 2;
          break;
        default:
          j = 1;
          break;
      }
      b(j);
    };
    return k(), window.addEventListener("resize", k), () => window.removeEventListener("resize", k);
  }, [h]);
  const L = t.map(
    (k) => Cd(k, n, o, r)
  ), O = t.length > p;
  return /* @__PURE__ */ f.jsx(
    or,
    {
      perView: +p,
      maxWidth: d,
      width: a,
      carouselItems: L,
      cssClass: "aligned-carousel",
      imageAutoSize: m,
      removeSideBackground: t.length <= p,
      hasPositionIndicators: O,
      hasNavButtons: O,
      isDraggable: O,
      hasShadow: !0
    }
  );
};
pa.propTypes = {
  perView: l.string.isRequired,
  cardItems: l.arrayOf(
    l.shape({
      title: l.string.isRequired,
      content: l.string,
      eventLocation: l.string,
      eventTime: l.string,
      image: l.string,
      imageAltText: l.string,
      buttons: Vt.propTypes.buttons,
      linkLabel: l.string,
      linkUrl: l.string,
      tags: Vt.propTypes.tags
    })
  ).isRequired,
  cardType: Vt.propTypes.type,
  cardEventFormat: Vt.propTypes.eventFormat,
  cardHorizontal: Vt.propTypes.horizontal,
  width: l.string,
  maxWidth: l.string,
  imageAutoSize: l.bool
};
const Rd = ({ id: e, imageSource: t, imageAltText: n, title: r, content: o }) => ({
  // @ts-ignore
  id: e,
  item: /* @__PURE__ */ f.jsx("div", { className: "uds-img", children: /* @__PURE__ */ f.jsxs("figure", { className: "figure uds-figure", children: [
    /* @__PURE__ */ f.jsx(
      "img",
      {
        src: t,
        className: "uds-img figure-img img-fluid",
        alt: n,
        loading: "lazy",
        decoding: "async"
      }
    ),
    (r || o) && /* @__PURE__ */ f.jsx(
      "figcaption",
      {
        className: "figure-caption uds-figure-caption",
        "data-testid": "image-content-container",
        children: /* @__PURE__ */ f.jsx("div", { className: "uds-caption-text", children: r ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          /* @__PURE__ */ f.jsx("h3", { children: r }),
          /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: { __html: o } })
        ] }) : /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: { __html: o } }) })
      }
    )
  ] }) })
}), ha = ({
  perView: e = 0,
  imageItems: t = [],
  width: n = void 0,
  maxWidth: r = void 0,
  imageAutoSize: o = !0
}) => {
  if (!t || t.length === 0)
    return null;
  const a = parseInt(`${e}`, 10), d = t.map(Rd) || [], m = t.length > a;
  return /* @__PURE__ */ f.jsx(
    or,
    {
      perView: +a,
      maxWidth: r,
      width: n,
      cssClass: "image-carousel aligned-carousel",
      carouselItems: d,
      imageAutoSize: o,
      removeSideBackground: t.length <= a,
      hasPositionIndicators: m,
      hasNavButtons: m,
      isDraggable: m,
      hasShadow: !0
    }
  );
};
ha.propTypes = {
  perView: l.number.isRequired,
  imageItems: l.arrayOf(l.object).isRequired,
  width: l.string,
  maxWidth: l.string,
  imageAutoSize: l.bool
};
const Od = (e, t) => {
  if (!e)
    return 0;
  const n = (e.match(/<br/g) || []).length, r = t / 6;
  return (parseInt(`${e.length / r}`, 10) + n) * 20;
}, Hr = {
  imageItems: l.arrayOf(
    l.shape({
      id: l.number,
      imageSource: l.string,
      thumbnailSource: l.string,
      imageAltText: l.string,
      content: l.oneOfType([l.string, l.element])
    })
  ),
  hasContent: l.bool
}, Ad = ({ id: e, imageSource: t, imageAltText: n }) => ({
  // @ts-ignore
  id: e,
  item: /* @__PURE__ */ f.jsx("div", { className: "uds-img", children: /* @__PURE__ */ f.jsx(
    "img",
    {
      src: t,
      className: "uds-img figure-img img-fluid",
      alt: n,
      loading: "lazy",
      decoding: "async"
    }
  ) })
}), ma = ({ instanceName: e, imageItems: t, hasContent: n }) => {
  var b, w;
  const r = "data-current-index", [o, a] = Ze(((b = t == null ? void 0 : t[0]) == null ? void 0 : b.title) || ""), [d, m] = Ze(((w = t == null ? void 0 : t[0]) == null ? void 0 : w.content) || ""), h = jn(
    (C) => {
      const L = t == null ? void 0 : t[C];
      L && (a(L.title), m(L.content));
    },
    [t]
  );
  if (lt(() => {
    if (!t || t.length === 0)
      return;
    const C = document.querySelector(
      ".image-gallery figcaption .uds-caption-text div"
    );
    if (C) {
      const N = parseInt(
        window.getComputedStyle(C, null).getPropertyValue("width").split("px")[0],
        10
      ), j = t.reduce((D, V) => {
        const W = Od(V.content, N);
        return W > D ? W : D;
      }, 0);
      C.style.height = `${j}px`;
    }
    const L = document.querySelector(`#${e}`);
    if (!L)
      return;
    function O(N) {
      for (const j of N)
        if (j && j.attributeName === r) {
          const D = L.getAttribute(r);
          D !== null && h(+D);
          return;
        }
    }
    const k = new MutationObserver(O);
    return k.observe(L, {
      attributes: !0
    }), () => {
      k.disconnect();
    };
  }, [e, t, h]), !t || t.length === 0)
    return null;
  const p = t.map((C) => C.imageSource);
  return /* @__PURE__ */ f.jsxs("div", { className: "image-gallery-action-area", "data-has-content": n, children: [
    /* @__PURE__ */ f.jsx("div", { className: "image-navigator", children: /* @__PURE__ */ f.jsxs(eo, { children: [
      /* @__PURE__ */ f.jsx(Qi, {}),
      /* @__PURE__ */ f.jsx("div", { className: "image-navigator-images", children: /* @__PURE__ */ f.jsx("div", { className: "navigation-slider", children: /* @__PURE__ */ f.jsx(
        aa,
        {
          imageItems: p,
          onItemClick: (C) => h(C)
        }
      ) }) }),
      /* @__PURE__ */ f.jsx(Ji, {})
    ] }) }),
    n && (o || d) ? /* @__PURE__ */ f.jsx(
      "figcaption",
      {
        id: "caption",
        className: "figure-caption uds-figure-caption",
        "data-testid": "image-gallery-content-container",
        children: /* @__PURE__ */ f.jsxs("div", { className: "uds-caption-text", children: [
          o ? /* @__PURE__ */ f.jsx("h3", { children: o }) : null,
          /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: { __html: d } })
        ] })
      }
    ) : null
  ] });
};
ma.propTypes = {
  instanceName: l.string,
  imageItems: Hr.imageItems,
  hasContent: Hr.hasContent
};
const ga = ({
  width: e,
  maxWidth: t,
  imageItems: n = [],
  hasContent: r = !1,
  imageAutoSize: o = !0
}) => {
  const a = n.map(Ad), d = n.length > 1;
  return /* @__PURE__ */ f.jsx(
    or,
    {
      perView: 1,
      maxWidth: t,
      width: e,
      carouselItems: a,
      cssClass: "image-gallery",
      role: "figure",
      ariaLabelledBy: r ? "caption" : null,
      isFullWidth: !0,
      imageAutoSize: o,
      hasPeek: !1,
      CustomNavComponent: ({ instanceName: m }) => /* @__PURE__ */ f.jsx(
        ma,
        {
          instanceName: m,
          hasContent: r,
          imageItems: n
        }
      ),
      removeSideBackground: n.length <= 1,
      hasPositionIndicators: d,
      hasNavButtons: d,
      isDraggable: d,
      hasShadow: !0
    }
  );
};
ga.propTypes = {
  imageItems: Hr.imageItems.isRequired,
  hasContent: Hr.hasContent,
  width: l.string,
  maxWidth: l.string,
  imageAutoSize: l.bool
};
const jd = ({ id: e, imageSource: t, imageAltText: n, quote: r }, o = {}) => ({
  // @ts-ignore
  id: e,
  item: /* @__PURE__ */ f.jsx(
    Ki,
    {
      imageSource: t,
      imageAltText: n,
      quote: r,
      itemStyle: o
    }
  )
}), va = ({
  width: e,
  maxWidth: t,
  testimonialItems: n = [],
  itemStyle: r = {},
  hasNavButtons: o = !1,
  hasPositionIndicators: a = !1,
  imageAutoSize: d = !0
}) => {
  const m = n.map(
    (h) => jd(h, r)
  );
  return /* @__PURE__ */ f.jsx(
    or,
    {
      perView: 1,
      maxWidth: t,
      width: e,
      carouselItems: m,
      isFullWidth: !0,
      removeSideBackground: !0,
      hasNavButtons: o,
      hasPositionIndicators: a,
      imageAutoSize: d,
      hasPeek: !1,
      hasShadow: !1
    }
  );
};
va.propTypes = {
  testimonialItems: l.arrayOf(
    l.shape({
      title: l.string,
      content: l.string,
      cite: l.shape({
        name: l.string,
        description: l.string
      })
    })
  ).isRequired,
  itemStyle: l.shape({
    containerCssClass: l.arrayOf(l.string),
    titleCssClass: l.arrayOf(l.string),
    contentCssClass: l.arrayOf(l.string)
  }),
  width: l.string,
  maxWidth: l.string,
  imageAutoSize: l.bool,
  hasNavButtons: l.bool,
  hasPositionIndicators: l.bool
};
var Dt = /* @__PURE__ */ ((e) => (e.UNORDERED = "unordered", e.ORDERED = "ordered", e.ICON = "icon", e.STEP = "step", e.DISPLAY = "display", e))(Dt || {}), Mr = /* @__PURE__ */ ((e) => (e.UL = "ul", e.OL = "ol", e))(Mr || {}), bn = /* @__PURE__ */ ((e) => (e.NONE = "none", e.LIGHT = "light", e.MEDIUM = "medium", e.DARK = "dark", e))(bn || {}), Dr = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.PRIMARY = "primary", e.SECONDARY = "secondary", e))(Dr || {});
const ya = (e) => {
  switch (e) {
    case Mr.OL:
    case Dt.ORDERED:
    case Dt.STEP:
      return Mr.OL;
    default:
      return Mr.UL;
  }
}, xa = ({
  listType: e,
  content: t,
  icon: n,
  nestedType: r,
  nestedItems: o
}) => {
  const [a, ...d] = Array.isArray(t) ? t : [t];
  let m = null;
  if (o != null && o.length) {
    const h = r || e, p = ya(h);
    m = /* @__PURE__ */ f.jsx(p, { children: o.map((b, w) => /* @__PURE__ */ f.jsx(xa, { listType: h, ...b }, w)) });
  }
  return /* @__PURE__ */ f.jsxs("li", { children: [
    n && /* @__PURE__ */ f.jsx("span", { className: `fa-li ${n == null ? void 0 : n[0]} fa-${n == null ? void 0 : n[1]}` }),
    a,
    " ",
    d.map((h, p) => [/* @__PURE__ */ f.jsx("br", {}, `br-${p}`), /* @__PURE__ */ f.jsx("span", { children: h }, p)]),
    m
  ] });
}, Nd = ({
  listType: e = Dt.UNORDERED,
  backgroundColor: t = bn.NONE,
  listItemStyleColor: n = Dr.DEFAULT,
  items: r
}) => {
  const o = ya(e);
  let a = "maroon", d = "maroon";
  t === bn.DARK && (a = "gold", d = "gold"), e === Dt.STEP && (a = "uds-steplist-maroon", d = "uds-steplist-gold", t === bn.DARK && (a = "uds-steplist-gold"));
  const m = we({
    "uds-list": e === Dt.UNORDERED || e === Dt.ORDERED,
    "uds-list fa-ul": e === Dt.ICON,
    "uds-list uds-steplist": e === Dt.STEP,
    "uds-list uds-display-list": e === Dt.DISPLAY,
    "light-smokemode": t === bn.LIGHT,
    smokemode: t === bn.MEDIUM,
    darkmode: t === bn.DARK,
    [`${a}`]: n === Dr.PRIMARY,
    // Intentional space ` ${secondaryColor}` for when primary and secondary colors are the same
    [` ${d}`]: n === Dr.SECONDARY
  });
  return /* @__PURE__ */ f.jsx(o, { className: m || null, children: r.map((h, p) => /* @__PURE__ */ f.jsx(xa, { listType: e, ...h }, p)) });
}, Pd = {
  none: "",
  gold: "text-gold",
  white: "text-white"
}, Id = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Ld = ({
  gridLinkItems: e,
  numColumns: t,
  textColor: n,
  children: r
}) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  /* @__PURE__ */ f.jsx(
    "div",
    {
      className: [
        "uds-grid-links",
        t,
        Pd[n]
      ].join(" "),
      children: e && e.map((o) => /* @__PURE__ */ f.jsx(
        tt,
        {
          gaData: {
            ...Id,
            text: o.label,
            section: `grid links ${o.label}`
          },
          children: /* @__PURE__ */ f.jsxs("a", { href: o.href, children: [
            /* @__PURE__ */ f.jsx("span", { className: `fa fa-fw ${o.icon}` }),
            o.label
          ] })
        },
        o.label + o.href
      ))
    }
  ),
  /* @__PURE__ */ f.jsx("div", { children: r })
] });
var no, ms = Ia;
no = ms.createRoot, ms.hydrateRoot;
const Md = (e, t, n) => {
  no(n).render(He.createElement(e, t));
}, Gr = ({ typeCarousel: e, targetSelector: t, props: n }) => {
  const o = {
    card: pa,
    testimonial: va,
    image: ha,
    "image-gallery": ga
  }[e];
  o && Md(o, n, document.querySelector(t));
}, Bd = ({ targetSelector: e, props: t }) => Gr({
  typeCarousel: "card",
  targetSelector: e,
  props: t
}), zd = ({ targetSelector: e, props: t }) => {
  Gr({
    typeCarousel: "testimonial",
    targetSelector: e,
    props: t
  });
}, Hd = ({ targetSelector: e, props: t }) => {
  Gr({ typeCarousel: "image", targetSelector: e, props: t });
}, Vd = ({ targetSelector: e, props: t }) => {
  Gr({
    typeCarousel: "image-gallery",
    targetSelector: e,
    props: t
  });
}, Ye = (e, t, n) => {
  no(n).render(He.createElement(e, t));
}, Wd = ({ targetSelector: e, props: t }) => Ye(Os, t, document.querySelector(e)), Ud = ({ targetSelector: e, props: t }) => Ye(Vs, t, document.querySelector(e)), qd = ({ targetSelector: e, props: t }) => Ye(qs, t, document.querySelector(e)), Yd = ({ targetSelector: e, props: t }) => Ye(wn, t, document.querySelector(e)), Xd = ({ targetSelector: e, props: t }) => Ye(Yi, t, document.querySelector(e)), Gd = ({ targetSelector: e, props: t }) => Ye(Xi, t, document.querySelector(e)), Kd = ({ targetSelector: e, props: t }) => Ye(Vt, t, document.querySelector(e)), Zd = ({ targetSelector: e, props: t }) => Ye(Zs, t, document.querySelector(e)), Jd = ({ targetSelector: e, props: t }) => Ye(Ld, t, document.querySelector(e)), Qd = ({ targetSelector: e, props: t }) => Ye(ea, t, document.querySelector(e)), ef = ({ targetSelector: e, props: t }) => Ye(Sn, t, document.querySelector(e)), tf = ({ targetSelector: e, props: t }) => Ye(ta, t, document.querySelector(e)), nf = ({ targetSelector: e, props: t }) => Ye(Gi, t, document.querySelector(e)), rf = ({ targetSelector: e, props: t }) => Ye(ia, t, document.querySelector(e)), of = ({ targetSelector: e, props: t }) => Ye(Ki, t, document.querySelector(e)), sf = ({ targetSelector: e, props: t }) => Ye(oa, t, document.querySelector(e)), af = ({ targetSelector: e, props: t }) => Ye(yu, t, document.querySelector(e)), lf = ({ targetSelector: e, props: t }) => Ye(nu, t, document.querySelector(e)), cf = ({ targetSelector: e, props: t }) => Ye(ku, t, document.querySelector(e)), uf = ({ targetSelector: e, props: t }) => Ye(Nd, t, document.querySelector(e));
export {
  Os as Accordion,
  Vs as AnchorMenu,
  qs as Article,
  wn as Button,
  Yi as ButtonIconOnly,
  Xi as ButtonTag,
  Vt as Card,
  Zs as CardArrangement,
  pa as CardCarousel,
  nu as Divider,
  tu as DividerType,
  fu as FeedBody,
  au as FeedContainerProvider,
  su as FeedContext,
  du as FeedHeader,
  Ld as GridLinks,
  ea as Hero,
  Sn as Image,
  ha as ImageCarousel,
  ga as ImageGalleryCarousel,
  Nd as List,
  na as NavControls,
  ta as Pagination,
  Gi as RankingCard,
  yu as SystemAlert,
  vu as SystemAlertType,
  wu as Tab,
  ra as TabHeader,
  ia as TabbedPanels,
  Ki as Testimonial,
  va as TestimonialCarousel,
  ku as Tooltip,
  oa as Video,
  $d as feedCardButtonShape,
  cu as feedComponentShape,
  Qs as feedCtaButtonShape,
  lu as feedDataSourceShape,
  Js as feedHeaderShape,
  Wd as initAccordion,
  Ud as initAnchorMenu,
  qd as initArticle,
  Yd as initButton,
  Xd as initButtonIconOnly,
  Gd as initButtonTag,
  Kd as initCard,
  Zd as initCardArrangement,
  Bd as initCardCarousel,
  lf as initDivider,
  Jd as initGridLinks,
  Qd as initHero,
  ef as initImage,
  Hd as initImageCarousel,
  Vd as initImageGalleryCarousel,
  uf as initList,
  tf as initPagination,
  nf as initRankingCard,
  af as initSystemAlert,
  rf as initTabbedPanels,
  of as initTestimonial,
  zd as initTestimonialCarousel,
  cf as initTooltip,
  sf as initVideo
};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*! @license DOMPurify 3.2.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.5/LICENSE */
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*!
 * Glide.js v3.6.2
 * (c) 2013-2024 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */

(function() {
                var css = `@charset "UTF-8";.glide{position:relative;width:100%;box-sizing:border-box}.glide *{box-sizing:inherit}.glide__track{overflow:hidden}.glide__slides{position:relative;width:100%;list-style:none;backface-visibility:hidden;transform-style:preserve-3d;touch-action:pan-Y;overflow:hidden;margin:0;padding:0;white-space:nowrap;display:flex;flex-wrap:nowrap;will-change:transform}.glide__slides--dragging{-webkit-user-select:none;user-select:none}.glide__slide{width:100%;height:100%;flex-shrink:0;white-space:normal;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent}.glide__slide a{-webkit-user-select:none;user-select:none;-webkit-user-drag:none;-moz-user-select:none;-ms-user-select:none}.glide__arrows,.glide__bullets{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.glide--rtl{direction:rtl}@media only screen and (min-width: 1260px){.container .aligned-carousel{margin-left:-124px!important}}.glide{display:flex;flex-direction:column;gap:32px;position:relative}[data-image-auto-size=true] .glide__slides .glide__slide{height:auto;position:relative;display:inline-flex;justify-content:center}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img{display:flex;width:100%;max-width:100%}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img img{flex-grow:1;object-fit:cover}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img img.uds-img{max-width:100%}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img figure.uds-figure{display:flex;justify-content:space-between;flex-direction:column}.glide .glide__track{position:relative}.glide .glide__track .glide__slides{margin-bottom:0;touch-action:auto}.glide .glide__track .glide__slides .glide__slide .card{width:100%}@media only screen and (min-width: 576px){.glide[data-has-shadow=true] .glide__track.slider-start:after{background:linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide[data-has-shadow=true] .glide__track.slider-mid:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px),linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide[data-has-shadow=true] .glide__track.slider-end:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}}.glide__arrows{z-index:2;align-self:center}.glide__arrows .glide__arrow{color:#191919;width:4rem;height:4rem;margin:0 .5rem;background-color:#e8e8e8;border:1px solid #d0d0d0;border-radius:50%;font-size:1.3rem;text-shadow:0 .25em .5em rgba(0,0,0,.1);opacity:1;cursor:pointer;transition:opacity .15s ease,border .3s ease-in-out;line-height:1}.glide__arrows .glide__arrow.glide__arrow--disabled{color:#e8e8e8;background-color:#fafafa;border:1px solid #e8e8e8;opacity:1}.glide__arrows .glide__arrow:focus{outline:none}.glide__arrows .glide__arrow:hover{border-color:#fff}.glide__arrows .glide__arrow--left{left:2em}.glide__arrows .glide__arrow--right{right:2em}.glide__arrows .glide__arrow--disabled{opacity:.33}.glide__bullets{z-index:2;list-style:none;max-width:100%;display:flex;justify-content:center}.glide__bullet{transition:all .3s ease-in-out;background-color:#d0d0d0;width:1rem;height:1rem;padding:0;border-radius:50%;border:2px solid transparent;cursor:pointer;line-height:0;margin:.375rem}.glide__bullet:focus{outline:none}.glide__bullet:hover,.glide__bullet:focus{border:1px solid #d0d0d0;background-color:#191919}.glide__bullet--active{background-color:#191919}.glide.aligned-carousel{width:1448px;margin:auto}.glide.image-gallery{gap:0;overflow:hidden}.glide.image-gallery .glide__track{border:1px solid #d0d0d0}.glide.image-gallery .glide__track:after{content:none}.glide.image-gallery .glide__track .glide__slides{margin-bottom:0;height:100%}.glide.image-gallery .glide__track .glide__slides li.glide__slide{display:list-item}.glide.image-gallery .glide__track .glide__slides .glide__slide>div.uds-img{height:100%}.glide.image-gallery .glide__track .glide__slides .glide__slide>div.uds-img img{object-fit:cover;border:none}.glide.image-gallery .image-gallery-action-area{border:1px solid #d0d0d0;border-top:0}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .image-navigator{border-bottom:1px solid #d0d0d0}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .uds-caption-text{padding:1rem 0;display:inline-block}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .uds-caption-text>div{height:auto!important}.glide.image-gallery figcaption{padding:0 .75rem;font-size:.75rem}.glide.image-gallery .image-navigator{position:relative}.glide.image-gallery .image-navigator .image-navigator-images{min-height:64px;padding-top:1rem;padding-bottom:1rem;width:100%;margin:auto;overflow:hidden}.glide.image-gallery .image-navigator .image-navigator-images.slider-start:after{background:linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images.slider-mid:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px),linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images.slider-end:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider{position:relative;left:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets{position:relative}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container{position:relative;margin:0 .5rem;height:48px;border:0;padding:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container:first-child{margin-left:16rem}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container .bullet-image{flex-basis:auto;width:88px;height:100%;border-radius:0;border:0;z-index:2;object-fit:cover;margin:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container:focus{box-shadow:0 0 0 2px #fff,0 0 0 4px #191919!important}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .glide__bullet--active{background-color:transparent;border:5px solid #ffc627}.glide.image-gallery .image-navigator .glide__arrows{width:100%;display:flex;justify-content:space-between;align-items:center}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow{width:2.5rem;height:2.5rem;display:flex;align-items:center;justify-content:center;z-index:3;position:absolute;background-color:#fff}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow:hover{border-color:#d0d0d0}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow .arrow-icon{font-size:1rem}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow.glide__arrow--prev{left:0}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow.glide__arrow--next{right:0}@media only screen and (max-width: 576px){.glide{gap:21px}.glide:not(.glide.image-gallery) .glide__bullets{display:none}.glide.image-gallery{width:100%;margin:auto!important}.glide.image-gallery .image-navigator .image-navigator-images .glide__arrows .glide__arrow{display:none}}@media only screen and (max-width: 1260px){.glide.aligned-carousel{width:100%}}.glide--swipeable{cursor:grab;cursor:-moz-grab;cursor:-webkit-grab}.glide--dragging{cursor:grabbing;cursor:-moz-grabbing;cursor:-webkit-grabbing}.glide[data-remove-side-background=true]:after,.glide[data-remove-side-background=true]:before{content:none}.glide button:focus,.glide a:focus,.glide input:focus,.glide textarea:focus,.glide select:focus{outline:none!important;box-shadow:0 0 0 2px #fff,0 0 0 4px #191919!important}.glide.image-gallery,.glide.image-carousel{margin:auto}.glide.image-gallery[role=figure],.glide.image-gallery figure.uds-figure,.glide.image-carousel[role=figure],.glide.image-carousel figure.uds-figure{margin:0}.glide.image-gallery[role=figure] figcaption *,.glide.image-gallery[role=figure] .uds-caption-text,.glide.image-gallery figure.uds-figure figcaption *,.glide.image-gallery figure.uds-figure .uds-caption-text,.glide.image-carousel[role=figure] figcaption *,.glide.image-carousel[role=figure] .uds-caption-text,.glide.image-carousel figure.uds-figure figcaption *,.glide.image-carousel figure.uds-figure .uds-caption-text{color:#191919;max-width:100%}
`;
                var style = document.createElement('style');
                style.type = 'text/css';
                if (style.styleSheet) {
                  style.styleSheet.cssText = css;
                } else {
                  style.appendChild(document.createTextNode(css));
                }
                document.head.appendChild(style);
              })();